import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: number; output: number; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: Date; output: Date; }
  DateTime: { input: Date; output: Date; }
  DateTimeOffset: { input: any; output: any; }
  Decimal: { input: number; output: number; }
  Milliseconds: { input: number; output: number; }
  Seconds: { input: number; output: number; }
};

export type AssetGraphType = {
  assetId: Scalars['String']['output'];
  communityId?: Maybe<Scalars['Int']['output']>;
  contentType: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSizeInBytes?: Maybe<Scalars['Int']['output']>;
  messId?: Maybe<Scalars['Int']['output']>;
  postId?: Maybe<Scalars['Int']['output']>;
  presignedUrl?: Maybe<Scalars['String']['output']>;
  s3Key: Scalars['String']['output'];
  uploaded?: Maybe<Scalars['String']['output']>;
};

export type AssetMutation = {
  createAssetsForMultiplePosts?: Maybe<Array<Maybe<CreateAssetGraphType>>>;
  /** Create assets for dynamic content */
  createCommunityAsset?: Maybe<CreateAssetGraphType>;
  /** Create assets for dynamic content */
  createMessageAsset?: Maybe<CreateAssetGraphType>;
  /** Create assets for dynamic content */
  createPostAsset?: Maybe<CreateAssetGraphType>;
  createPostAssets?: Maybe<Array<Maybe<CreateAssetGraphType>>>;
  /** Create non categorized asset */
  createUserAsset?: Maybe<CreateAssetGraphType>;
  /** Delete an asset */
  deleteAsset?: Maybe<Scalars['Boolean']['output']>;
};


export type AssetMutationCreateAssetsForMultiplePostsArgs = {
  asset: CreateAssetBaseInputType;
  postIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type AssetMutationCreateCommunityAssetArgs = {
  asset: CreateCommunityAssetInputType;
};


export type AssetMutationCreateMessageAssetArgs = {
  asset: CreateMessageAssetInputType;
};


export type AssetMutationCreatePostAssetArgs = {
  asset: CreatePostAssetInputType;
};


export type AssetMutationCreatePostAssetsArgs = {
  assets: Array<InputMaybe<CreateAssetBaseInputType>>;
  postId: Scalars['Int']['input'];
};


export type AssetMutationCreateUserAssetArgs = {
  asset: CreateAssetBaseInputType;
};


export type AssetMutationDeleteAssetArgs = {
  assetId: Scalars['String']['input'];
};

/** A connection from an object to a list of objects of type `Comment`. */
export type CommentConnection = {
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<CommentEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<CommentGraphType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `Comment`. */
export type CommentEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CommentGraphType>;
};

export type CommentGraphType = {
  author?: Maybe<UserGraphType>;
  authorId: Scalars['Int']['output'];
  /** Get all the comments of this comment */
  comments?: Maybe<CommentConnection>;
  commentsCount?: Maybe<Scalars['Int']['output']>;
  createdDate: Scalars['Date']['output'];
  createdDateTime?: Maybe<Scalars['DateTime']['output']>;
  hasRelated?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isNegative: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  parentCommentId?: Maybe<Scalars['Int']['output']>;
  postId?: Maybe<Scalars['Int']['output']>;
  relateCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<EEntryStatus>;
  updatedDate: Scalars['Date']['output'];
};


export type CommentGraphTypeCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type CommentMutation = {
  create?: Maybe<CommentGraphType>;
  createSubComment?: Maybe<CommentGraphType>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  toggleVisibility?: Maybe<CommentGraphType>;
  update?: Maybe<CommentGraphType>;
  /** Update status of a comment */
  updateStatus?: Maybe<Scalars['Boolean']['output']>;
};


export type CommentMutationCreateArgs = {
  request: CreateCommentInputType;
};


export type CommentMutationCreateSubCommentArgs = {
  request: CreateSubCommentInputType;
};


export type CommentMutationDeleteArgs = {
  commentId: Scalars['Int']['input'];
};


export type CommentMutationToggleVisibilityArgs = {
  commentId: Scalars['Int']['input'];
};


export type CommentMutationUpdateArgs = {
  request: UpdateCommentInputType;
};


export type CommentMutationUpdateStatusArgs = {
  commentId: Scalars['Int']['input'];
  status: EEntryStatus;
};

export type CommentQuery = {
  embargoComments?: Maybe<CommentConnection>;
  /** Get a comment by the commentId */
  getComment?: Maybe<CommentGraphType>;
  /** Get all the comments of a post */
  getComments?: Maybe<CommentConnection>;
  /** Get all the comments of a post */
  getCommunityComments?: Maybe<CommentConnection>;
  /** Get all comments of another comment */
  getSubComments?: Maybe<CommentConnection>;
};


export type CommentQueryEmbargoCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  communityId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type CommentQueryGetCommentArgs = {
  commentId: Scalars['Int']['input'];
};


export type CommentQueryGetCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  commentStatus?: InputMaybe<EEntryStatus>;
  first?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<ESorting>;
};


export type CommentQueryGetCommunityCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  commentStatus?: InputMaybe<EEntryStatus>;
  communityId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type CommentQueryGetSubCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  commentId: Scalars['Int']['input'];
  commentStatus?: InputMaybe<EEntryStatus>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection from an object to a list of objects of type `CommentRelate`. */
export type CommentRelateConnection = {
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<CommentRelateEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<CommentRelateGraphType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `CommentRelate`. */
export type CommentRelateEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CommentRelateGraphType>;
};

export type CommentRelateGraphType = RelateInterfaceGraphType & {
  /** Comment details */
  comment?: Maybe<CommentGraphType>;
  /** Comment id */
  commentId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  type?: Maybe<ERelateType>;
  /** User details */
  user?: Maybe<UserGraphType>;
  userId: Scalars['Int']['output'];
};

export type CommunityCategoryGraphType = {
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type CommunityCategoryMutation = {
  create?: Maybe<CommunityCategoryGraphType>;
};


export type CommunityCategoryMutationCreateArgs = {
  inputType: CraeteCommunityCategoryInputType;
};

export type CommunityCategoryQuery = {
  /** Get all relates of a posts */
  getCommunityCategories?: Maybe<Array<Maybe<CommunityCategoryGraphType>>>;
};

/** A connection from an object to a list of objects of type `Community`. */
export type CommunityConnection = {
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<CommunityEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<CommunityGraphType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A connection from an object to a list of objects of type `CommunityConnection`. */
export type CommunityConnectionConnection = {
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<CommunityConnectionEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<CommunityConnectionGraphType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `CommunityConnection`. */
export type CommunityConnectionEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CommunityConnectionGraphType>;
};

export type CommunityConnectionGraphType = {
  community?: Maybe<CommunityGraphType>;
  communityId: Scalars['Int']['output'];
  createdDate: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  role?: Maybe<ECommunityRole>;
  status?: Maybe<EConnectionStatus>;
  trustLevel?: Maybe<ETrustLevel>;
  updatedDate: Scalars['Date']['output'];
  user?: Maybe<UserGraphType>;
  userId: Scalars['Int']['output'];
};

export type CommunityConnectionMutation = {
  /** Accept or decline a community connection request */
  acceptOrDecline?: Maybe<CommunityConnectionGraphType>;
  /** Add users in a community */
  addOrUpdateUsersInCommunity?: Maybe<Scalars['Boolean']['output']>;
  /** Add user in a community */
  addUserInCommunity?: Maybe<Scalars['Boolean']['output']>;
  /** Join a community */
  joinCommunity?: Maybe<CommunityConnectionGraphType>;
  /** Join a community */
  joinCommunityWithKey?: Maybe<Scalars['Boolean']['output']>;
  /** Leave a community */
  leaveCommunity?: Maybe<Scalars['Boolean']['output']>;
  /** Remove a member by the authority */
  removeMemberByAuthority?: Maybe<Scalars['Boolean']['output']>;
  /** Remove users in a community */
  removeUsersFromCommunity?: Maybe<Scalars['Boolean']['output']>;
  /** Set connection as alumni or as active */
  toggleAlumni?: Maybe<Scalars['Boolean']['output']>;
  /** Update the community user role */
  updateCommunityRole?: Maybe<CommunityConnectionGraphType>;
  /** Update status in a community */
  updateStatus?: Maybe<Scalars['Boolean']['output']>;
  /** Update user trust level in a community */
  updateTrustLevel?: Maybe<Scalars['Boolean']['output']>;
};


export type CommunityConnectionMutationAcceptOrDeclineArgs = {
  inputType: UpdateCommunityConnectionStatusInputType;
};


export type CommunityConnectionMutationAddOrUpdateUsersInCommunityArgs = {
  communityId: Scalars['Int']['input'];
  role: ECommunityRole;
  userIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type CommunityConnectionMutationAddUserInCommunityArgs = {
  communityId: Scalars['Int']['input'];
  role: ECommunityRole;
  userId: Scalars['Int']['input'];
};


export type CommunityConnectionMutationJoinCommunityArgs = {
  communityId: Scalars['Int']['input'];
};


export type CommunityConnectionMutationJoinCommunityWithKeyArgs = {
  key: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type CommunityConnectionMutationLeaveCommunityArgs = {
  connectionId: Scalars['Int']['input'];
};


export type CommunityConnectionMutationRemoveMemberByAuthorityArgs = {
  communityId: Scalars['Int']['input'];
  connectionId?: InputMaybe<Scalars['Int']['input']>;
  memberId: Scalars['Int']['input'];
};


export type CommunityConnectionMutationRemoveUsersFromCommunityArgs = {
  communityId: Scalars['Int']['input'];
  userIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type CommunityConnectionMutationToggleAlumniArgs = {
  communityId: Scalars['Int']['input'];
  isAlumni: Scalars['Boolean']['input'];
};


export type CommunityConnectionMutationUpdateCommunityRoleArgs = {
  inputType: UpdateCommunityRuleInputType;
};


export type CommunityConnectionMutationUpdateStatusArgs = {
  communityId: Scalars['Int']['input'];
  status: EConnectionStatus;
  userId: Scalars['Int']['input'];
};


export type CommunityConnectionMutationUpdateTrustLevelArgs = {
  communityId: Scalars['Int']['input'];
  trustLevel: ETrustLevel;
  userId: Scalars['Int']['input'];
};

export type CommunityConnectionQuery = {
  /** Get the status between the connected user and the community */
  connectionStatus?: Maybe<CommunityConnectionGraphType>;
  ofUser?: Maybe<Array<Maybe<CommunityConnectionGraphType>>>;
  /** Get the community members */
  users?: Maybe<CommunityConnectionConnection>;
};


export type CommunityConnectionQueryConnectionStatusArgs = {
  communityId: Scalars['Int']['input'];
};


export type CommunityConnectionQueryOfUserArgs = {
  status?: InputMaybe<EConnectionStatus>;
  userId: Scalars['Int']['input'];
};


export type CommunityConnectionQueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  communityId: Scalars['Int']['input'];
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasAcceptedTerms?: InputMaybe<Scalars['Boolean']['input']>;
  searchPrivacy?: InputMaybe<Array<InputMaybe<ESearchPrivacy>>>;
  status?: InputMaybe<Array<InputMaybe<EConnectionStatus>>>;
};

/** An edge in a connection from an object to another object of type `Community`. */
export type CommunityEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CommunityGraphType>;
};

export type CommunityGraphType = {
  bannerImage?: Maybe<AssetGraphType>;
  categoryId?: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  key?: Maybe<Scalars['String']['output']>;
  privacy?: Maybe<ECommunityPrivacy>;
  profileImage?: Maybe<AssetGraphType>;
  status?: Maybe<ECommunityStatus>;
  title: Scalars['String']['output'];
  /** Return the connection object between the connected user and the community */
  userConnection?: Maybe<CommunityConnectionGraphType>;
};


export type CommunityGraphTypeUserConnectionArgs = {
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type CommunityMutation = {
  create?: Maybe<CommunityGraphType>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<CommunityGraphType>;
};


export type CommunityMutationCreateArgs = {
  inputType: CreateCommunityInputType;
};


export type CommunityMutationDeleteArgs = {
  communityId: Scalars['Int']['input'];
};


export type CommunityMutationUpdateArgs = {
  inputType: UpdateCommunityInputType;
};

export type CommunityQuery = {
  /** Get all public communities */
  allPublic?: Maybe<CommunityConnection>;
  /** Get available communities for the connected user */
  availableCommunities?: Maybe<CommunityConnection>;
  /** Get the communities for a specified project */
  byProject?: Maybe<CommunityConnection>;
  /** Get a community */
  get: CommunityGraphType;
  searchByCategory?: Maybe<CommunityConnection>;
  tagsByCommunity?: Maybe<Array<Maybe<TagGraphType>>>;
  /** Search the communities for the specified user */
  userCommunities?: Maybe<CommunityConnection>;
};


export type CommunityQueryAllPublicArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type CommunityQueryAvailableCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type CommunityQueryByProjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['String']['input'];
};


export type CommunityQueryGetArgs = {
  communityId?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};


export type CommunityQuerySearchByCategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type CommunityQueryTagsByCommunityArgs = {
  communityId: Scalars['Int']['input'];
};


export type CommunityQueryUserCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection from an object to a list of objects of type `Connection`. */
export type ConnectionConnection = {
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<ConnectionEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<ConnectionGraphType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `Connection`. */
export type ConnectionEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ConnectionGraphType>;
};

export type ConnectionGraphType = {
  connectionStatus?: Maybe<EConnectionStatus>;
  createdDate: Scalars['Date']['output'];
  friendId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  updatedDate: Scalars['Date']['output'];
  /** User details */
  user?: Maybe<UserGraphType>;
  userId: Scalars['Int']['output'];
};

export type CraeteCommunityCategoryInputType = {
  title: Scalars['String']['input'];
};

export type CreateAssetBaseInputType = {
  alt?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSizeInBytes: Scalars['Int']['input'];
  tags?: InputMaybe<Scalars['String']['input']>;
  transcript?: InputMaybe<Scalars['String']['input']>;
  type: EAssetType;
  xAxisFocus?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateAssetGraphType = {
  asset?: Maybe<AssetGraphType>;
  signedUrl?: Maybe<Scalars['String']['output']>;
};

export type CreateCommentInputType = {
  message?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateCommunityAssetInputType = {
  alt?: InputMaybe<Scalars['String']['input']>;
  communityId: Scalars['Int']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSizeInBytes: Scalars['Int']['input'];
  tags?: InputMaybe<Scalars['String']['input']>;
  transcript?: InputMaybe<Scalars['String']['input']>;
  type: EAssetType;
  usage: ECommunityAssetUsage;
  xAxisFocus?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateCommunityInputType = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  privacy?: InputMaybe<ECommunityPrivacy>;
  status?: InputMaybe<ECommunityStatus>;
  title: Scalars['String']['input'];
};

export type CreateMessageAssetInputType = {
  alt?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSizeInBytes: Scalars['Int']['input'];
  messageId: Scalars['Int']['input'];
  tags?: InputMaybe<Scalars['String']['input']>;
  transcript?: InputMaybe<Scalars['String']['input']>;
  type: EAssetType;
  xAxisFocus?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatePostAssetInputType = {
  alt?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSizeInBytes: Scalars['Int']['input'];
  postId: Scalars['Int']['input'];
  tags?: InputMaybe<Scalars['String']['input']>;
  transcript?: InputMaybe<Scalars['String']['input']>;
  type: EAssetType;
  xAxisFocus?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatePostInputType = {
  anonymousMode?: InputMaybe<EPostAnonymousMode>;
  communities?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  communityId?: InputMaybe<Scalars['Int']['input']>;
  feeling?: InputMaybe<EPostFeeling>;
  message: Scalars['String']['input'];
  postType: EPostType;
  shareOption: EShareOption;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topicId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateSharePostInptuType = {
  communities?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  communityId?: InputMaybe<Scalars['Int']['input']>;
  message: Scalars['String']['input'];
  postId: Scalars['Int']['input'];
  postType: EPostType;
  shareOption: EShareOption;
};

export type CreateSubCommentInputType = {
  commentId?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export enum EAssetType {
  Audio = 'AUDIO',
  Code = 'CODE',
  Document = 'DOCUMENT',
  Font = 'FONT',
  Image = 'IMAGE',
  Script = 'SCRIPT',
  Template = 'TEMPLATE',
  Video = 'VIDEO'
}

export enum ECommunityAssetUsage {
  Banner = 'BANNER',
  Profile = 'PROFILE'
}

export enum ECommunityPrivacy {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export enum ECommunityRole {
  Member = 'MEMBER',
  Moderator = 'MODERATOR',
  Owner = 'OWNER'
}

export enum ECommunityStatus {
  Disabled = 'DISABLED',
  Pending = 'PENDING',
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export enum EConnectionStatus {
  Accepted = 'ACCEPTED',
  Alumni = 'ALUMNI',
  Blocked = 'BLOCKED',
  Declined = 'DECLINED',
  Requested = 'REQUESTED'
}

export enum EEntryStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Embargo = 'EMBARGO',
  Reported = 'REPORTED',
  Unpublished = 'UNPUBLISHED'
}

export enum ELanguageFilterType {
  MultipleWays = 'MULTIPLE_WAYS',
  Strict = 'STRICT',
  Tricked = 'TRICKED'
}

export enum EMessageStatus {
  Deleted = 'DELETED',
  Delivered = 'DELIVERED',
  Falied = 'FALIED',
  Sent = 'SENT'
}

export enum EPostAnonymousMode {
  HideAll = 'HIDE_ALL',
  HideGroup = 'HIDE_GROUP',
  HideName = 'HIDE_NAME',
  NotAnonymous = 'NOT_ANONYMOUS'
}

export enum EPostFeeling {
  Afraid = 'AFRAID',
  AllOrNothing = 'ALL_OR_NOTHING',
  Angry = 'ANGRY',
  Antisocial = 'ANTISOCIAL',
  Anxious = 'ANXIOUS',
  Ashamed = 'ASHAMED',
  Calm = 'CALM',
  Catastrophising = 'CATASTROPHISING',
  Craving = 'CRAVING',
  Depressed = 'DEPRESSED',
  Determined = 'DETERMINED',
  Distressed = 'DISTRESSED',
  Excited = 'EXCITED',
  Grateful = 'GRATEFUL',
  Guilty = 'GUILTY',
  Happy = 'HAPPY',
  Heroic = 'HEROIC',
  Hopeful = 'HOPEFUL',
  Inspired = 'INSPIRED',
  Irritable = 'IRRITABLE',
  Lonely = 'LONELY',
  Lovestruct = 'LOVESTRUCT',
  Misunderstood = 'MISUNDERSTOOD',
  Needy = 'NEEDY',
  Neutral = 'NEUTRAL',
  None = 'NONE',
  Obsessed = 'OBSESSED',
  Pain = 'PAIN',
  Personalising = 'PERSONALISING',
  Resentful = 'RESENTFUL',
  Restless = 'RESTLESS',
  Sad = 'SAD',
  Sarcastic = 'SARCASTIC',
  Scattered = 'SCATTERED',
  Snarky = 'SNARKY',
  Spent = 'SPENT',
  Strong = 'STRONG',
  Subversive = 'SUBVERSIVE',
  Thoughtful = 'THOUGHTFUL',
  Tired = 'TIRED',
  Wonky = 'WONKY'
}

export enum EPostSorting {
  DescendingDate = 'DESCENDING_DATE',
  Popular = 'POPULAR',
  RecentActivity = 'RECENT_ACTIVITY'
}

export enum EPostType {
  Blog = 'BLOG',
  Community = 'COMMUNITY',
  Feed = 'FEED',
  Shared = 'SHARED',
  Story = 'STORY'
}

export enum EProjectFeature {
  DeIdentifyReports = 'DE_IDENTIFY_REPORTS',
  DisplayFirstLetter = 'DISPLAY_FIRST_LETTER',
  DisplayLastLetter = 'DISPLAY_LAST_LETTER',
  DisplayName = 'DISPLAY_NAME',
  HashTag = 'HASH_TAG',
  HasLanguageFilter = 'HAS_LANGUAGE_FILTER',
  None = 'NONE',
  NotifyModeratorsOnSensitiveContent = 'NOTIFY_MODERATORS_ON_SENSITIVE_CONTENT',
  NotifyOnEveryContent = 'NOTIFY_ON_EVERY_CONTENT'
}

export enum ERelateType {
  FeltLikeThatToo = 'FELT_LIKE_THAT_TOO',
  LaughtOutLoud = 'LAUGHT_OUT_LOUD',
  Like = 'LIKE',
  Relate = 'RELATE',
  ThankYouForSharing = 'THANK_YOU_FOR_SHARING',
  Understand = 'UNDERSTAND'
}

export enum EReportType {
  Harassment = 'HARASSMENT',
  HateSpeech = 'HATE_SPEECH',
  Inappropriate = 'INAPPROPRIATE',
  Other = 'OTHER',
  Spam = 'SPAM',
  SuicideOrSelfInjury = 'SUICIDE_OR_SELF_INJURY',
  Violence = 'VIOLENCE'
}

export enum ESearchPrivacy {
  IncludeDisplayedName = 'INCLUDE_DISPLAYED_NAME',
  IncludeFirstName = 'INCLUDE_FIRST_NAME',
  IncludeLastName = 'INCLUDE_LAST_NAME'
}

export enum EShareOption {
  Communities = 'COMMUNITIES',
  Connections = 'CONNECTIONS',
  Everyone = 'EVERYONE'
}

export enum ESorting {
  NewestFirst = 'NEWEST_FIRST',
  OldestFirst = 'OLDEST_FIRST'
}

export enum ETopicStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Unpublished = 'UNPUBLISHED'
}

export enum ETrustLevel {
  Compliant = 'COMPLIANT',
  Reported = 'REPORTED'
}

export enum EUserSettings {
  CalenderEvent = 'CALENDER_EVENT',
  CommentedComment = 'COMMENTED_COMMENT',
  CommentedPost = 'COMMENTED_POST',
  CommunityConnectedRequested = 'COMMUNITY_CONNECTED_REQUESTED',
  ConnectionInactive = 'CONNECTION_INACTIVE',
  InteractPostCommented = 'INTERACT_POST_COMMENTED',
  LikedComment = 'LIKED_COMMENT',
  LikedWallPost = 'LIKED_WALL_POST',
  MessageReceive = 'MESSAGE_RECEIVE',
  None = 'NONE',
  ReceivedConnectionAccept = 'RECEIVED_CONNECTION_ACCEPT',
  ReceivedConnectionRequest = 'RECEIVED_CONNECTION_REQUEST',
  ResetCommitmentClock = 'RESET_COMMITMENT_CLOCK',
  SharedRedFeeling = 'SHARED_RED_FEELING',
  SharedWallPost = 'SHARED_WALL_POST',
  WallPost = 'WALL_POST'
}

export enum EUserStatus {
  Active = 'ACTIVE',
  Banned = 'BANNED',
  Reported = 'REPORTED'
}

export enum EmoticonEnumType {
  /** Positive */
  Happy = 'happy',
  /** Neutral */
  Neutral = 'neutral',
  /** Negative */
  Sad = 'sad'
}

export type EmoticonQuery = {
  getEmoticons?: Maybe<EmoticonEnumType>;
};

/** A connection from an object to a list of objects of type `Feedback`. */
export type FeedbackConnection = {
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<FeedbackEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<FeedbackGraphType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `Feedback`. */
export type FeedbackEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FeedbackGraphType>;
};

export type FeedbackGraphType = {
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type FeedbackMutation = {
  /** Create a feedback by the user */
  create?: Maybe<FeedbackGraphType>;
};


export type FeedbackMutationCreateArgs = {
  message: Scalars['String']['input'];
};

export type FeedbackQuery = {
  /** Get all feedbacks */
  getFeedbacks?: Maybe<FeedbackConnection>;
  /** Get all feedback by a user */
  getFeedbacksByUser?: Maybe<FeedbackConnection>;
};


export type FeedbackQueryGetFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type FeedbackQueryGetFeedbacksByUserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export enum FileType {
  Csv = 'CSV',
  Excel = 'EXCEL'
}

/** A connection from an object to a list of objects of type `LanguageFilter`. */
export type LanguageFilterConnection = {
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<LanguageFilterEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<LanguageFilterGraphType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `LanguageFilter`. */
export type LanguageFilterEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LanguageFilterGraphType>;
};

export type LanguageFilterGraphType = {
  content: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isEmbargoingContent: Scalars['Boolean']['output'];
  isNegative: Scalars['Boolean']['output'];
  projectId: Scalars['String']['output'];
  type?: Maybe<ELanguageFilterType>;
};

export type LanguageFilterItemInputType = {
  /** Content */
  content: Scalars['String']['input'];
  /** Id */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Define if the content is embargoed */
  isEmbargoingContent: Scalars['Boolean']['input'];
  /** Define if the content is negative */
  isNegative: Scalars['Boolean']['input'];
  /** Project id */
  projectId: Scalars['String']['input'];
  /** Type */
  type: ELanguageFilterType;
};

export type LanguageFilterMutation = {
  /** Add language filter */
  add?: Maybe<Scalars['Boolean']['output']>;
  /** Bulk add or update many items */
  bulkAddOrUpdate?: Maybe<Scalars['Boolean']['output']>;
  /** Delete many language filter items */
  bulkDelete?: Maybe<Scalars['Boolean']['output']>;
  /** Delete language filter */
  delete?: Maybe<Scalars['Boolean']['output']>;
  /** Update language filter */
  update?: Maybe<Scalars['Boolean']['output']>;
};


export type LanguageFilterMutationAddArgs = {
  content: Scalars['String']['input'];
  isEmbargoingContent?: InputMaybe<Scalars['Boolean']['input']>;
  isNegative?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['String']['input'];
  type: ELanguageFilterType;
};


export type LanguageFilterMutationBulkAddOrUpdateArgs = {
  items: Array<InputMaybe<LanguageFilterItemInputType>>;
};


export type LanguageFilterMutationBulkDeleteArgs = {
  ids: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type LanguageFilterMutationDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type LanguageFilterMutationUpdateArgs = {
  content: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  isEmbargoingContent?: InputMaybe<Scalars['Boolean']['input']>;
  isNegative?: InputMaybe<Scalars['Boolean']['input']>;
  type: ELanguageFilterType;
};

export type LanguageFilterQuery = {
  /** get a language filter item */
  get?: Maybe<LanguageFilterGraphType>;
  /** get all language filter items for a project */
  list?: Maybe<LanguageFilterConnection>;
};


export type LanguageFilterQueryGetArgs = {
  itemId: Scalars['Int']['input'];
};


export type LanguageFilterQueryListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['String']['input'];
  type?: InputMaybe<ELanguageFilterType>;
};

/** A connection from an object to a list of objects of type `Message`. */
export type MessageConnection = {
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<MessageEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<MessageGraphType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `Message`. */
export type MessageEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MessageGraphType>;
};

export type MessageGraphType = {
  createdDate: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isSeenByReceiver: Scalars['Boolean']['output'];
  receiver?: Maybe<UserGraphType>;
  sender?: Maybe<UserGraphType>;
  status?: Maybe<EMessageStatus>;
  text: Scalars['String']['output'];
};

/** A connection from an object to a list of objects of type `MessageList`. */
export type MessageListConnection = {
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<MessageListEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<MessageListGraphType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `MessageList`. */
export type MessageListEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MessageListGraphType>;
};

export type MessageListGraphType = {
  lastMessage?: Maybe<MessageGraphType>;
  receiver?: Maybe<UserGraphType>;
  unReadCount?: Maybe<Scalars['Int']['output']>;
};

export type MessageMutation = {
  /** Create a conversation between two users */
  createConversation?: Maybe<MessageGraphType>;
  /** Create a conversation between two users */
  createConversations?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a conversation between two users */
  deleteConversation?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a message by id */
  deleteMessageById?: Maybe<Scalars['Boolean']['output']>;
  /** Make a message read by receiver */
  makeMessageReadByReceiver?: Maybe<Scalars['Boolean']['output']>;
  /** Make the whole conversation between two users read/seen */
  makeWholeConversationRead?: Maybe<Scalars['Boolean']['output']>;
  /** Update a message by message id */
  updateMessage?: Maybe<Scalars['Boolean']['output']>;
};


export type MessageMutationCreateConversationArgs = {
  message: Scalars['String']['input'];
  receiverId: Scalars['Int']['input'];
};


export type MessageMutationCreateConversationsArgs = {
  message: Scalars['String']['input'];
  receivers: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type MessageMutationDeleteConversationArgs = {
  messageId: Scalars['Int']['input'];
};


export type MessageMutationDeleteMessageByIdArgs = {
  messageId: Scalars['Int']['input'];
};


export type MessageMutationMakeMessageReadByReceiverArgs = {
  messageId: Scalars['Int']['input'];
};


export type MessageMutationMakeWholeConversationReadArgs = {
  senderId: Scalars['Int']['input'];
};


export type MessageMutationUpdateMessageArgs = {
  message: Scalars['String']['input'];
  messageId: Scalars['Int']['input'];
};

export type MessageQuery = {
  /** Get a conversation between two users */
  getConversation?: Maybe<MessageConnection>;
  /** Get a list of coversations for the user */
  getConversationList?: Maybe<MessageListConnection>;
  tagsByCommunity?: Maybe<Array<Maybe<TagGraphType>>>;
  /** Get a count of unread messages for the connected user */
  unreadMessagesCount?: Maybe<Scalars['Int']['output']>;
};


export type MessageQueryGetConversationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  otherUserId?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ESorting>;
};


export type MessageQueryGetConversationListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type MessageQueryTagsByCommunityArgs = {
  communityId: Scalars['Int']['input'];
};

export type Mutations = {
  asset?: Maybe<AssetMutation>;
  comment?: Maybe<CommentMutation>;
  commentRelate?: Maybe<RelateCommentMutation>;
  community?: Maybe<CommunityMutation>;
  communityCategory?: Maybe<CommunityCategoryMutation>;
  communityConnection?: Maybe<CommunityConnectionMutation>;
  feedback?: Maybe<FeedbackMutation>;
  languageFilter?: Maybe<LanguageFilterMutation>;
  message?: Maybe<MessageMutation>;
  poll?: Maybe<PollMutation>;
  post?: Maybe<PostMutation>;
  postRelate?: Maybe<RelatePostMutation>;
  report?: Maybe<ReportMutation>;
  topic?: Maybe<TopicMutation>;
  user?: Maybe<UserMutation>;
  userConnection?: Maybe<UserConnectionMutation>;
  userNotifiedOnContent?: Maybe<UserNotifiedOnContentMutation>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PollGraphType = {
  /** End date */
  end?: Maybe<Scalars['DateTime']['output']>;
  /** Poll id */
  id: Scalars['Int']['output'];
  /** Items */
  items?: Maybe<Array<Maybe<PollItemGraphType>>>;
  /** Post id */
  postId: Scalars['Int']['output'];
  /** Start date */
  start?: Maybe<Scalars['DateTime']['output']>;
  /** Title */
  title: Scalars['String']['output'];
  /** User's vote */
  userVote?: Maybe<VoteGraphType>;
};

export type PollItemGraphType = {
  /** Poll item id */
  id: Scalars['Int']['output'];
  /** Title */
  title: Scalars['String']['output'];
  /** Votes */
  votes: Array<Maybe<VoteGraphType>>;
  /** Vote count */
  votesCount: Scalars['Int']['output'];
};

export type PollItemInputType = {
  /** Poll item id */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Poll item title */
  title: Scalars['String']['input'];
};

export type PollMutation = {
  /** Add a poll to a post */
  add?: Maybe<PollGraphType>;
  /** Add a poll to posts */
  addPollToPosts?: Maybe<Array<Maybe<PollGraphType>>>;
  /** Delete a poll from a post */
  delete?: Maybe<Scalars['Boolean']['output']>;
  /** Update a poll */
  update?: Maybe<PostGraphType>;
  /** Vote for a poll */
  vote?: Maybe<PollGraphType>;
};


export type PollMutationAddArgs = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  items: Array<InputMaybe<PollItemInputType>>;
  postId: Scalars['Int']['input'];
  start?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
};


export type PollMutationAddPollToPostsArgs = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  items: Array<InputMaybe<PollItemInputType>>;
  postIds: Array<InputMaybe<Scalars['Int']['input']>>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
};


export type PollMutationDeleteArgs = {
  postId: Scalars['Int']['input'];
};


export type PollMutationUpdateArgs = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  items: Array<InputMaybe<PollItemInputType>>;
  postId: Scalars['Int']['input'];
  start?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
};


export type PollMutationVoteArgs = {
  itemId: Scalars['Int']['input'];
  pollId: Scalars['Int']['input'];
};

export type PostGraphType = PostInterfaceGraphType & {
  /** anonymousMode */
  anonymousMode?: Maybe<EPostAnonymousMode>;
  /** assets */
  assets?: Maybe<Array<Maybe<AssetGraphType>>>;
  /** Post author */
  author?: Maybe<UserGraphType>;
  /** User community role */
  authorCommunityRole?: Maybe<ECommunityRole>;
  /** Author id */
  authorId: Scalars['Int']['output'];
  /** commentCount */
  commentCount?: Maybe<Scalars['Int']['output']>;
  /** Get all the comments of the post */
  comments?: Maybe<CommentConnection>;
  /** Community */
  community?: Maybe<CommunityGraphType>;
  /** communityId */
  communityId?: Maybe<Scalars['Int']['output']>;
  /** Created date */
  createdDate: Scalars['DateTime']['output'];
  /** createdDateTime */
  createdDateTime?: Maybe<Scalars['DateTime']['output']>;
  /** feeling */
  feeling?: Maybe<EPostFeeling>;
  /** hasRelated */
  hasRelated?: Maybe<Scalars['Boolean']['output']>;
  /** Id */
  id: Scalars['Int']['output'];
  /** Ip address */
  ipAddress?: Maybe<Scalars['String']['output']>;
  /** Define if the post is negative or not */
  isNegative?: Maybe<Scalars['Boolean']['output']>;
  /** Message */
  message?: Maybe<Scalars['String']['output']>;
  /** Define if the post is pinned */
  pinned: Scalars['Boolean']['output'];
  /** Poll */
  poll?: Maybe<PollGraphType>;
  /** Relate */
  relate?: Maybe<RelateInterfaceGraphType>;
  /** relateCount */
  relateCount?: Maybe<Scalars['Int']['output']>;
  /** Reports */
  reports?: Maybe<Array<Maybe<ReportGraphType>>>;
  /** Share count */
  shareCount?: Maybe<Scalars['Int']['output']>;
  /** shareOption */
  shareOption?: Maybe<EShareOption>;
  /** status */
  status?: Maybe<EEntryStatus>;
  /** Tagged users */
  taggedUsers?: Maybe<Array<Maybe<TagUserGraphType>>>;
  /** tags */
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** topic */
  topic?: Maybe<TopicGraphType>;
  /** Topic id */
  topicId?: Maybe<Scalars['Int']['output']>;
  /** Updated date */
  updatedDate: Scalars['DateTime']['output'];
};


export type PostGraphTypeCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type PostGraphTypeMessageArgs = {
  areObscenityFiltered?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A connection from an object to a list of objects of type `PostInterface`. */
export type PostInterfaceConnection = {
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<PostInterfaceEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<PostInterfaceGraphType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `PostInterface`. */
export type PostInterfaceEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PostInterfaceGraphType>;
};

export type PostInterfaceGraphType = {
  anonymousMode?: Maybe<EPostAnonymousMode>;
  assets?: Maybe<Array<Maybe<AssetGraphType>>>;
  author?: Maybe<UserGraphType>;
  authorCommunityRole?: Maybe<ECommunityRole>;
  authorId: Scalars['Int']['output'];
  commentCount?: Maybe<Scalars['Int']['output']>;
  /** Get all the comments of the post */
  comments?: Maybe<CommentConnection>;
  communityId?: Maybe<Scalars['Int']['output']>;
  createdDate: Scalars['DateTime']['output'];
  createdDateTime?: Maybe<Scalars['DateTime']['output']>;
  feeling?: Maybe<EPostFeeling>;
  hasRelated?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  pinned: Scalars['Boolean']['output'];
  relateCount?: Maybe<Scalars['Int']['output']>;
  shareCount?: Maybe<Scalars['Int']['output']>;
  shareOption?: Maybe<EShareOption>;
  status?: Maybe<EEntryStatus>;
  taggedUsers?: Maybe<Array<Maybe<TagUserGraphType>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  topic?: Maybe<TopicGraphType>;
  topicId?: Maybe<Scalars['Int']['output']>;
  updatedDate: Scalars['DateTime']['output'];
};


export type PostInterfaceGraphTypeCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type PostInterfaceGraphTypeMessageArgs = {
  areObscenityFiltered?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PostMutation = {
  /** Change the anonymous mode for a specific post */
  changeAnonymousMode?: Maybe<Scalars['Boolean']['output']>;
  /** Create a single post */
  create?: Maybe<PostGraphType>;
  /** Create multi community posts */
  createMultiCommunityPosts?: Maybe<Array<Maybe<PostGraphType>>>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  sharePost?: Maybe<PostShareGraphType>;
  togglePinned?: Maybe<PostGraphType>;
  toggleVisibility?: Maybe<PostGraphType>;
  update?: Maybe<PostGraphType>;
  /** Update status of a post */
  updateStatus?: Maybe<Scalars['Boolean']['output']>;
  updateTopic?: Maybe<PostGraphType>;
};


export type PostMutationChangeAnonymousModeArgs = {
  mode: EPostAnonymousMode;
  postId: Scalars['Int']['input'];
};


export type PostMutationCreateArgs = {
  request: CreatePostInputType;
};


export type PostMutationCreateMultiCommunityPostsArgs = {
  request: CreatePostInputType;
};


export type PostMutationDeleteArgs = {
  postId: Scalars['Int']['input'];
};


export type PostMutationSharePostArgs = {
  request: CreateSharePostInptuType;
};


export type PostMutationTogglePinnedArgs = {
  postId: Scalars['Int']['input'];
};


export type PostMutationToggleVisibilityArgs = {
  postId: Scalars['Int']['input'];
};


export type PostMutationUpdateArgs = {
  request: UpdatePostInputType;
};


export type PostMutationUpdateStatusArgs = {
  postId: Scalars['Int']['input'];
  status: EEntryStatus;
};


export type PostMutationUpdateTopicArgs = {
  postId: Scalars['Int']['input'];
  topicId: Scalars['Int']['input'];
};

export type PostQuery = {
  /** Get connections posts of the user */
  connectionPosts?: Maybe<PostInterfaceConnection>;
  embargoPosts?: Maybe<PostInterfaceConnection>;
  /** Get embargoed post count */
  embargoedCount: Scalars['Int']['output'];
  /** Get community posts */
  getCommunityPosts?: Maybe<PostInterfaceConnection>;
  /** Get feed posts of the user */
  getFeedPosts?: Maybe<PostInterfaceConnection>;
  /** Get the liked post of the connected user */
  getLikedPost?: Maybe<PostInterfaceConnection>;
  /** Get personal posts of the user */
  getPersonalPosts?: Maybe<PostInterfaceConnection>;
  /** Get a post by the postId */
  getPost?: Maybe<PostInterfaceGraphType>;
  /** Get moderators posts of the user */
  moderatorsPosts?: Maybe<PostInterfaceConnection>;
  post?: Maybe<PostGraphType>;
  postShare?: Maybe<PostShareGraphType>;
  sharedPosts?: Maybe<PostInterfaceConnection>;
};


export type PostQueryConnectionPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<EPostSorting>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type PostQueryEmbargoPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  communityId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type PostQueryEmbargoedCountArgs = {
  communityId: Scalars['Int']['input'];
};


export type PostQueryGetCommunityPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  communityId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};


export type PostQueryGetFeedPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  authorId?: InputMaybe<Scalars['Int']['input']>;
  communityId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  postStatus?: InputMaybe<EEntryStatus>;
  sort?: InputMaybe<EPostSorting>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  to?: InputMaybe<Scalars['Date']['input']>;
  topicStatus?: InputMaybe<ETopicStatus>;
  topics?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type PostQueryGetLikedPostArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type PostQueryGetPersonalPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type PostQueryGetPostArgs = {
  postId: Scalars['Int']['input'];
};


export type PostQueryModeratorsPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<EPostSorting>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type PostQuerySharedPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  postId: Scalars['Int']['input'];
};

/** A connection from an object to a list of objects of type `PostRelate`. */
export type PostRelateConnection = {
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<PostRelateEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<PostRelateGraphType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `PostRelate`. */
export type PostRelateEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PostRelateGraphType>;
};

export type PostRelateGraphType = RelateInterfaceGraphType & {
  id: Scalars['Int']['output'];
  /** Post details */
  post?: Maybe<PostGraphType>;
  /** Post id */
  postId?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<ERelateType>;
  /** User details */
  user?: Maybe<UserGraphType>;
  userId: Scalars['Int']['output'];
};

export type PostRelateQuery = {
  /** Get all relates of a posts */
  get?: Maybe<PostRelateConnection>;
};


export type PostRelateQueryGetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  postId: Scalars['Int']['input'];
};

export type PostShareGraphType = PostInterfaceGraphType & {
  anonymousMode?: Maybe<EPostAnonymousMode>;
  assets?: Maybe<Array<Maybe<AssetGraphType>>>;
  author?: Maybe<UserGraphType>;
  /** User community role */
  authorCommunityRole?: Maybe<ECommunityRole>;
  authorId: Scalars['Int']['output'];
  commentCount?: Maybe<Scalars['Int']['output']>;
  /** Get all the comments of the post */
  comments?: Maybe<CommentConnection>;
  communityId?: Maybe<Scalars['Int']['output']>;
  /** Created date */
  createdDate: Scalars['DateTime']['output'];
  createdDateTime?: Maybe<Scalars['DateTime']['output']>;
  feeling?: Maybe<EPostFeeling>;
  hasRelated?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** Ip address */
  ipAddress?: Maybe<Scalars['String']['output']>;
  /** Message */
  message?: Maybe<Scalars['String']['output']>;
  /** Original post details */
  originalPost?: Maybe<PostGraphType>;
  pinned: Scalars['Boolean']['output'];
  relateCount?: Maybe<Scalars['Int']['output']>;
  shareCount?: Maybe<Scalars['Int']['output']>;
  shareOption?: Maybe<EShareOption>;
  status?: Maybe<EEntryStatus>;
  taggedUsers?: Maybe<Array<Maybe<TagUserGraphType>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  topic?: Maybe<TopicGraphType>;
  topicId?: Maybe<Scalars['Int']['output']>;
  /** Updated date */
  updatedDate: Scalars['DateTime']['output'];
};


export type PostShareGraphTypeCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type PostShareGraphTypeMessageArgs = {
  areObscenityFiltered?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectQuery = {
  /** Get features for a project */
  listFeatures?: Maybe<Array<Maybe<EProjectFeature>>>;
};


export type ProjectQueryListFeaturesArgs = {
  projectId: Scalars['String']['input'];
};

export type Queries = {
  comment?: Maybe<CommentQuery>;
  commentRelate?: Maybe<RelateCommentQuery>;
  community?: Maybe<CommunityQuery>;
  communityCategory?: Maybe<CommunityCategoryQuery>;
  communityConnection?: Maybe<CommunityConnectionQuery>;
  emoticon?: Maybe<EmoticonQuery>;
  feedback?: Maybe<FeedbackQuery>;
  languageFilter?: Maybe<LanguageFilterQuery>;
  message?: Maybe<MessageQuery>;
  post?: Maybe<PostQuery>;
  postRelate?: Maybe<PostRelateQuery>;
  project?: Maybe<ProjectQuery>;
  report?: Maybe<ReportQuery>;
  topic?: Maybe<TopicQuery>;
  user?: Maybe<UserQuery>;
  userConnection?: Maybe<UserConnectionQuery>;
};

export type RelateCommentMutation = {
  /** Create a comment related by the user */
  create?: Maybe<Scalars['Boolean']['output']>;
  /** Remove a comment relate by the user */
  delete?: Maybe<Scalars['Boolean']['output']>;
  deletePerComment?: Maybe<Scalars['Boolean']['output']>;
  /** Update relate to a comment */
  update?: Maybe<Scalars['Boolean']['output']>;
};


export type RelateCommentMutationCreateArgs = {
  commentId: Scalars['Int']['input'];
  type: ERelateType;
};


export type RelateCommentMutationDeleteArgs = {
  commentRelateId: Scalars['Int']['input'];
};


export type RelateCommentMutationDeletePerCommentArgs = {
  commentId: Scalars['Int']['input'];
};


export type RelateCommentMutationUpdateArgs = {
  commentRelateId: Scalars['Int']['input'];
  type: ERelateType;
};

export type RelateCommentQuery = {
  get?: Maybe<CommentRelateConnection>;
};


export type RelateCommentQueryGetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  commentId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type RelateInterfaceGraphType = {
  id: Scalars['Int']['output'];
  type?: Maybe<ERelateType>;
  userId: Scalars['Int']['output'];
};

export type RelatePostMutation = {
  /** Relate to a post */
  create?: Maybe<Scalars['Boolean']['output']>;
  /** Remove a relate by the user */
  delete?: Maybe<Scalars['Boolean']['output']>;
};


export type RelatePostMutationCreateArgs = {
  postId: Scalars['Int']['input'];
  type: ERelateType;
};


export type RelatePostMutationDeleteArgs = {
  postId: Scalars['Int']['input'];
};

/** A connection from an object to a list of objects of type `ReportComment`. */
export type ReportCommentConnection = {
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<ReportCommentEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<ReportCommentGraphType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `ReportComment`. */
export type ReportCommentEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ReportCommentGraphType>;
};

export type ReportCommentGraphType = ReportInterfaceGraphType & {
  comment?: Maybe<CommentGraphType>;
  commentId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  reporter?: Maybe<UserGraphType>;
  reporterId: Scalars['Int']['output'];
  type?: Maybe<EReportType>;
  viewed: Scalars['Boolean']['output'];
};

export type ReportGraphType = {
  id: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  post?: Maybe<PostGraphType>;
  reporter?: Maybe<UserGraphType>;
  type?: Maybe<EReportType>;
};

/** A connection from an object to a list of objects of type `ReportInterface`. */
export type ReportInterfaceConnection = {
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<ReportInterfaceEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<ReportInterfaceGraphType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `ReportInterface`. */
export type ReportInterfaceEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ReportInterfaceGraphType>;
};

export type ReportInterfaceGraphType = {
  id: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  reporter?: Maybe<UserGraphType>;
  reporterId: Scalars['Int']['output'];
  type?: Maybe<EReportType>;
  viewed: Scalars['Boolean']['output'];
};

export type ReportMutation = {
  /** Report about a post by the user */
  create?: Maybe<ReportGraphType>;
  /** Delete a report about a post by an Admin */
  deleteByAdmin?: Maybe<ReportGraphType>;
  /** Delete a report about a post by the user */
  deleteByUser?: Maybe<ReportGraphType>;
  /** Report about a comment by the user */
  reportComment?: Maybe<ReportCommentGraphType>;
  /** Report about a post by the user */
  reportPost?: Maybe<ReportPostGraphType>;
  /** Report about a user in a community */
  reportUser?: Maybe<ReportUserGraphType>;
};


export type ReportMutationCreateArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
  postId: Scalars['Int']['input'];
  type: EReportType;
};


export type ReportMutationDeleteByAdminArgs = {
  reporterId: Scalars['Int']['input'];
};


export type ReportMutationDeleteByUserArgs = {
  reporterId: Scalars['Int']['input'];
};


export type ReportMutationReportCommentArgs = {
  commentId: Scalars['Int']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  type: EReportType;
};


export type ReportMutationReportPostArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
  postId: Scalars['Int']['input'];
  type: EReportType;
};


export type ReportMutationReportUserArgs = {
  communityId: Scalars['Int']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  type: EReportType;
  userId: Scalars['Int']['input'];
};

/** A connection from an object to a list of objects of type `ReportPost`. */
export type ReportPostConnection = {
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<ReportPostEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<ReportPostGraphType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `ReportPost`. */
export type ReportPostEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ReportPostGraphType>;
};

export type ReportPostGraphType = ReportInterfaceGraphType & {
  id: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  post?: Maybe<PostGraphType>;
  postId: Scalars['Int']['output'];
  reporter?: Maybe<UserGraphType>;
  reporterId: Scalars['Int']['output'];
  type?: Maybe<EReportType>;
  viewed: Scalars['Boolean']['output'];
};

export type ReportQuery = {
  exportCommentLogs?: Maybe<AssetGraphType>;
  exportComments?: Maybe<AssetGraphType>;
  exportPostLogs?: Maybe<AssetGraphType>;
  exportPosts?: Maybe<AssetGraphType>;
  /** Get all comment reports */
  getCommentReports?: Maybe<ReportCommentConnection>;
  /** Get all post reports */
  getPostReports?: Maybe<ReportPostConnection>;
  /** Get a report by report id */
  getReportById?: Maybe<ReportGraphType>;
  /** Get all reports for the admin */
  getReports?: Maybe<ReportInterfaceConnection>;
  /** Get reports by post id */
  getReportsByPostId?: Maybe<Array<Maybe<ReportGraphType>>>;
  /** Get reports by user id */
  getReportsByUserId?: Maybe<Array<Maybe<ReportGraphType>>>;
  /** Get all user reports */
  getUserReports?: Maybe<ReportUserConnection>;
};


export type ReportQueryExportCommentLogsArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  fileType?: InputMaybe<FileType>;
  ianaTimeZone: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type ReportQueryExportCommentsArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  fileType?: InputMaybe<FileType>;
  ianaTimeZone: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type ReportQueryExportPostLogsArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  fileType?: InputMaybe<FileType>;
  ianaTimeZone: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type ReportQueryExportPostsArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  fileType?: InputMaybe<FileType>;
  ianaTimeZone: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type ReportQueryGetCommentReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  communityId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type ReportQueryGetPostReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  communityId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type ReportQueryGetReportByIdArgs = {
  reportId: Scalars['Int']['input'];
};


export type ReportQueryGetReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  communityId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type ReportQueryGetReportsByPostIdArgs = {
  postId: Scalars['Int']['input'];
};


export type ReportQueryGetReportsByUserIdArgs = {
  userId: Scalars['Int']['input'];
};


export type ReportQueryGetUserReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  communityId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection from an object to a list of objects of type `ReportUser`. */
export type ReportUserConnection = {
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<ReportUserEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<ReportUserGraphType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `ReportUser`. */
export type ReportUserEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ReportUserGraphType>;
};

export type ReportUserGraphType = ReportInterfaceGraphType & {
  id: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  reporter?: Maybe<UserGraphType>;
  reporterId: Scalars['Int']['output'];
  type?: Maybe<EReportType>;
  user?: Maybe<UserGraphType>;
  userId: Scalars['Int']['output'];
  viewed: Scalars['Boolean']['output'];
};

export type TagGraphType = {
  count?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type TagUserGraphType = {
  /** Placeholder in content */
  placeholder: Scalars['String']['output'];
  /** User tagged */
  user: UserGraphType;
};

/** A connection from an object to a list of objects of type `Topic`. */
export type TopicConnection = {
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<TopicEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<TopicGraphType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `Topic`. */
export type TopicEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TopicGraphType>;
};

export type TopicGraphType = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  postsCount?: Maybe<Scalars['Int']['output']>;
  projectId: Scalars['String']['output'];
  status?: Maybe<ETopicStatus>;
  title: Scalars['String']['output'];
  userTopic?: Maybe<UserTopicGraphType>;
};

export type TopicMutation = {
  addTopic?: Maybe<TopicGraphType>;
  /** Bulk subscribe to topics. Existing subscriptions are ignored */
  bulkSubscribe?: Maybe<Array<Maybe<UserTopicGraphType>>>;
  editTopic?: Maybe<TopicGraphType>;
  removeTopic?: Maybe<Scalars['Boolean']['output']>;
  sortTopic?: Maybe<TopicGraphType>;
  subscribeToATopic?: Maybe<UserTopicGraphType>;
  unSubscribeFromATopic?: Maybe<Scalars['Boolean']['output']>;
  updateTopicStatus?: Maybe<TopicGraphType>;
};


export type TopicMutationAddTopicArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
  status?: InputMaybe<ETopicStatus>;
  title: Scalars['String']['input'];
};


export type TopicMutationBulkSubscribeArgs = {
  projectId: Scalars['String']['input'];
  topicIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type TopicMutationEditTopicArgs = {
  status?: InputMaybe<ETopicStatus>;
  title: Scalars['String']['input'];
  topicId: Scalars['Int']['input'];
};


export type TopicMutationRemoveTopicArgs = {
  topicId: Scalars['Int']['input'];
};


export type TopicMutationSortTopicArgs = {
  sort: Scalars['Int']['input'];
  topicId: Scalars['Int']['input'];
};


export type TopicMutationSubscribeToATopicArgs = {
  projectId: Scalars['String']['input'];
  topicId: Scalars['Int']['input'];
};


export type TopicMutationUnSubscribeFromATopicArgs = {
  userTopicId: Scalars['Int']['input'];
};


export type TopicMutationUpdateTopicStatusArgs = {
  status: ETopicStatus;
  topicId: Scalars['Int']['input'];
};

export type TopicQuery = {
  /** Get a topic */
  getTopic?: Maybe<TopicGraphType>;
  /** Get all the project topics */
  getTopics?: Maybe<TopicConnection>;
  /**
   * Get topic list
   * @deprecated Use getTopics instead
   */
  getTopicsPerProject?: Maybe<Array<Maybe<TopicGraphType>>>;
};


export type TopicQueryGetTopicArgs = {
  topicId: Scalars['Int']['input'];
};


export type TopicQueryGetTopicsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['String']['input'];
  status?: InputMaybe<ETopicStatus>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type TopicQueryGetTopicsPerProjectArgs = {
  projectId: Scalars['String']['input'];
  status?: InputMaybe<ETopicStatus>;
};

export type UpdateCommentInputType = {
  id: Scalars['Int']['input'];
  message: Scalars['String']['input'];
};

export type UpdateCommunityConnectionStatusInputType = {
  communityId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  status?: InputMaybe<EConnectionStatus>;
  userId: Scalars['Int']['input'];
};

export type UpdateCommunityInputType = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  privacy?: InputMaybe<ECommunityPrivacy>;
  status?: InputMaybe<ECommunityStatus>;
  title: Scalars['String']['input'];
};

export type UpdateCommunityRuleInputType = {
  communityId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  role?: InputMaybe<ECommunityRole>;
};

export type UpdatePostInputType = {
  feeling?: InputMaybe<EPostFeeling>;
  id: Scalars['Int']['input'];
  message: Scalars['String']['input'];
  postType: EPostType;
  shareOption: EShareOption;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** A connection from an object to a list of objects of type `User`. */
export type UserConnection = {
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<UserGraphType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UserConnectionMutation = {
  acceptOrDecline?: Maybe<ConnectionGraphType>;
  /** Bulk connection requests. Existing connections are ignored */
  bulkConnect?: Maybe<Array<Maybe<ConnectionGraphType>>>;
  create?: Maybe<ConnectionGraphType>;
  delete?: Maybe<ConnectionGraphType>;
};


export type UserConnectionMutationAcceptOrDeclineArgs = {
  connectionId: Scalars['Int']['input'];
  connectionStatus: EConnectionStatus;
};


export type UserConnectionMutationBulkConnectArgs = {
  items: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type UserConnectionMutationCreateArgs = {
  friendId: Scalars['Int']['input'];
};


export type UserConnectionMutationDeleteArgs = {
  connectionId: Scalars['Int']['input'];
};

export type UserConnectionQuery = {
  /** Get a connection by the connection id */
  get?: Maybe<ConnectionGraphType>;
  /** Get connection between query requester id and userId */
  getUserConnection?: Maybe<ConnectionGraphType>;
  /** Get all the connections by the user */
  getUserConnections?: Maybe<ConnectionConnection>;
};


export type UserConnectionQueryGetArgs = {
  connectionId: Scalars['Int']['input'];
};


export type UserConnectionQueryGetUserConnectionArgs = {
  userId: Scalars['Int']['input'];
};


export type UserConnectionQueryGetUserConnectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<EConnectionStatus>>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** An edge in a connection from an object to another object of type `User`. */
export type UserEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<UserGraphType>;
};

export type UserGraphType = {
  about?: Maybe<Scalars['String']['output']>;
  activeCommunities?: Maybe<CommunityConnection>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  communityConnections?: Maybe<CommunityConnectionConnection>;
  connections?: Maybe<ConnectionConnection>;
  coverImage?: Maybe<AssetGraphType>;
  displayedName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Define if the user has interacted with the website */
  hasInteracted?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isAnonymous?: Maybe<Scalars['Boolean']['output']>;
  /** Define if the user is online */
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  isTermsAndConditionsAccepted?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  latestInteraction?: Maybe<Scalars['DateTime']['output']>;
  /** Post count */
  postCount?: Maybe<Scalars['Int']['output']>;
  posts?: Maybe<Array<Maybe<PostInterfaceGraphType>>>;
  profileImage?: Maybe<AssetGraphType>;
  settings?: Maybe<Array<Maybe<EUserSettings>>>;
  status?: Maybe<EUserStatus>;
  /** Connection between the user and the connected user */
  userConnection?: Maybe<ConnectionGraphType>;
  /** User topics of the user */
  userTopics?: Maybe<UserTopicConnection>;
  /** Username */
  username?: Maybe<Scalars['String']['output']>;
};


export type UserGraphTypeActiveCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type UserGraphTypeCommunityConnectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type UserGraphTypeConnectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<EConnectionStatus>>>;
};


export type UserGraphTypeHasInteractedArgs = {
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserGraphTypePostCountArgs = {
  postedFrom?: InputMaybe<Scalars['Date']['input']>;
  postedTo?: InputMaybe<Scalars['Date']['input']>;
};


export type UserGraphTypeUserTopicsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type UserMutation = {
  /** Accept the terms and conditions for Bonobo */
  acceptTermsAndConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Enable user account */
  enableAccount?: Maybe<Scalars['Boolean']['output']>;
  /** Set if the connected user is online or not */
  setIsOnline?: Maybe<UserGraphType>;
  toggleAnonymousMode?: Maybe<Scalars['Boolean']['output']>;
  /** Update about */
  updateAbout?: Maybe<Scalars['Boolean']['output']>;
  /** Update the settings of an user */
  updateSettings?: Maybe<UserGraphType>;
  /** Update user profile and cover images */
  updateUserImages?: Maybe<Scalars['Boolean']['output']>;
  updateUserName?: Maybe<UserGraphType>;
  /** Update user status */
  updateUserStatus?: Maybe<Scalars['Boolean']['output']>;
  /** Allow the user to update his user name */
  updateUsername?: Maybe<Scalars['Boolean']['output']>;
};


export type UserMutationEnableAccountArgs = {
  displayedName?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
};


export type UserMutationSetIsOnlineArgs = {
  isOnline: Scalars['Boolean']['input'];
};


export type UserMutationToggleAnonymousModeArgs = {
  isAnonymous: Scalars['Boolean']['input'];
};


export type UserMutationUpdateAboutArgs = {
  about: Scalars['String']['input'];
};


export type UserMutationUpdateSettingsArgs = {
  inputType: Array<InputMaybe<EUserSettings>>;
};


export type UserMutationUpdateUserImagesArgs = {
  coverImage?: InputMaybe<Scalars['String']['input']>;
  profileImage?: InputMaybe<Scalars['String']['input']>;
};


export type UserMutationUpdateUserNameArgs = {
  firstname: Scalars['String']['input'];
};


export type UserMutationUpdateUserStatusArgs = {
  status: EUserStatus;
  userId: Scalars['Int']['input'];
};


export type UserMutationUpdateUsernameArgs = {
  username: Scalars['String']['input'];
};

export type UserNotifiedOnContentMutation = {
  /** Toggle a user from Not Notified to Notified when something is posted or commented */
  toggleUser?: Maybe<Scalars['Boolean']['output']>;
};


export type UserNotifiedOnContentMutationToggleUserArgs = {
  userId: Scalars['Int']['input'];
};

export type UserQuery = {
  /** User that are either in connection with the connected user or in the same communities */
  connectedUsers?: Maybe<UserConnection>;
  get?: Maybe<UserGraphType>;
  getUser?: Maybe<UserGraphType>;
  getUserInformation?: Maybe<UserGraphType>;
  /** Get the users */
  getUsers?: Maybe<UserConnection>;
  /** Get possible connections */
  possibleConnections?: Maybe<UserConnection>;
};


export type UserQueryConnectedUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeConnections?: InputMaybe<Scalars['Boolean']['input']>;
  includeSharedCommunity?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserQueryGetArgs = {
  key: Scalars['String']['input'];
};


export type UserQueryGetUserInformationArgs = {
  userId: Scalars['Int']['input'];
};


export type UserQueryGetUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  communityId?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  postedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  postedTo?: InputMaybe<Scalars['DateTime']['input']>;
};


export type UserQueryPossibleConnectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection from an object to a list of objects of type `UserTopic`. */
export type UserTopicConnection = {
  /** Information to aid in pagination. */
  edges?: Maybe<Array<Maybe<UserTopicEdge>>>;
  /** A list of all of the objects returned in the connection. This is a convenience field provided for quickly exploring the API; rather than querying for "{ edges { node } }" when no edge data is needed, this field can be used instead. Note that when clients like Relay need to fetch the "cursor" field on the edge to enable efficient pagination, this shortcut cannot be used, and the full "{ edges { node } } " version should be used instead. */
  items?: Maybe<Array<Maybe<UserTopicGraphType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A count of the total number of objects in this connection, ignoring pagination. This allows a client to fetch the first five objects by passing "5" as the argument to `first`, then fetch the total count so it could display "5 of 83", for example. In cases where we employ infinite scrolling or don't have an exact count of entries, this field will return `null`. */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection from an object to another object of type `UserTopic`. */
export type UserTopicEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<UserTopicGraphType>;
};

export type UserTopicGraphType = {
  createdDate: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  topic?: Maybe<TopicGraphType>;
  topicId: Scalars['Int']['output'];
  updatedDate: Scalars['DateTime']['output'];
  user?: Maybe<UserGraphType>;
  userId: Scalars['Int']['output'];
};

export type VoteGraphType = {
  /** Poll item id */
  pollItemId: Scalars['Int']['output'];
  /** User details */
  user: UserGraphType;
  /** User id */
  userId: Scalars['Int']['output'];
};

export type UserBasicFragment = { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } };

type PostInterface_PostGraphType_Fragment = { id: number, commentCount?: number, createdDate: Date, createdDateTime?: Date, feeling?: EPostFeeling, hasRelated?: boolean, message?: string, pinned: boolean, relateCount?: number, shareCount?: number, shareOption?: EShareOption, status?: EEntryStatus, tags?: Array<string>, updatedDate: Date, authorCommunityRole?: ECommunityRole, isNegative?: boolean, assets?: Array<{ postId?: number, assetId: string, contentType: string, fileName: string, presignedUrl?: string, s3Key: string }>, author?: { id: number, displayedName?: string, firstName?: string, lastName?: string, isAnonymous?: boolean }, topic?: { id: number, title: string, description?: string, postsCount?: number }, community?: { id: number, key?: string, title: string, description: string, userConnection?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } }, poll?: { id: number, start?: Date, end?: Date, postId: number, title: string, items?: Array<{ id: number, title: string, votesCount: number, votes: Array<{ pollItemId: number, userId: number }> }>, userVote?: { pollItemId: number, userId: number } }, relate?: { id: number, type?: ERelateType, userId: number } | { id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } };

type PostInterface_PostShareGraphType_Fragment = { id: number, commentCount?: number, createdDate: Date, createdDateTime?: Date, feeling?: EPostFeeling, hasRelated?: boolean, message?: string, pinned: boolean, relateCount?: number, shareCount?: number, shareOption?: EShareOption, status?: EEntryStatus, tags?: Array<string>, updatedDate: Date, assets?: Array<{ postId?: number, assetId: string, contentType: string, fileName: string, presignedUrl?: string, s3Key: string }>, author?: { id: number, displayedName?: string, firstName?: string, lastName?: string, isAnonymous?: boolean }, topic?: { id: number, title: string, description?: string, postsCount?: number } };

export type PostInterfaceFragment = PostInterface_PostGraphType_Fragment | PostInterface_PostShareGraphType_Fragment;

export type PostFragment = { id: number, authorCommunityRole?: ECommunityRole, isNegative?: boolean, pinned: boolean, community?: { id: number, key?: string, title: string, description: string, userConnection?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } }, poll?: { id: number, start?: Date, end?: Date, postId: number, title: string, items?: Array<{ id: number, title: string, votesCount: number, votes: Array<{ pollItemId: number, userId: number }> }>, userVote?: { pollItemId: number, userId: number } }, relate?: { id: number, type?: ERelateType, userId: number } | { id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } };

export type PollFragment = { id: number, start?: Date, end?: Date, postId: number, title: string, items?: Array<{ id: number, title: string, votesCount: number, votes: Array<{ pollItemId: number, userId: number }> }>, userVote?: { pollItemId: number, userId: number } };

export type UserVoteGraphFragment = { pollItemId: number, userId: number };

export type RelateOnPostFragment = { id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } };

export type PostShareGraphTypeFragment = { id: number, originalPost?: { anonymousMode?: EPostAnonymousMode, commentCount?: number, communityId?: number, createdDate: Date, createdDateTime?: Date, feeling?: EPostFeeling, hasRelated?: boolean, message?: string, pinned: boolean, relateCount?: number, shareCount?: number, shareOption?: EShareOption, status?: EEntryStatus, tags?: Array<string>, topicId?: number, updatedDate: Date, id: number, authorCommunityRole?: ECommunityRole, isNegative?: boolean, assets?: Array<{ postId?: number, assetId: string, contentType: string, fileName: string, presignedUrl?: string }>, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, taggedUsers?: Array<{ placeholder: string, user: { id: number, displayedName?: string, firstName?: string, lastName?: string, profileImage?: { presignedUrl?: string } } }>, topic?: { id: number, title: string, description?: string, postsCount?: number }, community?: { id: number, key?: string, title: string, description: string, userConnection?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } }, poll?: { id: number, start?: Date, end?: Date, postId: number, title: string, items?: Array<{ id: number, title: string, votesCount: number, votes: Array<{ pollItemId: number, userId: number }> }>, userVote?: { pollItemId: number, userId: number } }, relate?: { id: number, type?: ERelateType, userId: number } | { id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } } };

export type UserConnectionFragment = { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number, user?: { about?: string, displayedName?: string, email?: string, firstName?: string, hasInteracted?: boolean, id: number, isAnonymous?: boolean, isOnline?: boolean, isTermsAndConditionsAccepted?: boolean, key?: string, lastName?: string, settings?: Array<EUserSettings>, username?: string, activeCommunities?: { totalCount?: number, edges?: Array<{ node?: { categoryId?: number, description: string, id: number, privacy?: ECommunityPrivacy, status?: ECommunityStatus, title: string, userConnection?: { role?: ECommunityRole } } }> }, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, connections?: { totalCount?: number }, coverImage?: { presignedUrl?: string, id: string }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } };

export type UserFragment = { about?: string, displayedName?: string, email?: string, firstName?: string, hasInteracted?: boolean, id: number, isAnonymous?: boolean, isOnline?: boolean, isTermsAndConditionsAccepted?: boolean, key?: string, lastName?: string, settings?: Array<EUserSettings>, username?: string, activeCommunities?: { totalCount?: number, edges?: Array<{ node?: { categoryId?: number, description: string, id: number, privacy?: ECommunityPrivacy, status?: ECommunityStatus, title: string, userConnection?: { role?: ECommunityRole } } }> }, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, connections?: { totalCount?: number }, coverImage?: { presignedUrl?: string, id: string }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } };

export type ReportCommentFragmentFragment = { id: number, message?: string, reporterId: number, type?: EReportType, viewed: boolean, commentId: number, reporter?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, comment?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } };

export type CommentGraphTypeFragment = { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } };

export type BonoboAssetFragment = { assetId: string, contentType: string, fileName: string, fileSizeInBytes?: number, presignedUrl?: string, s3Key: string, uploaded?: string };

export type ReportPostFragmentFragment = { id: number, message?: string, reporterId: number, type?: EReportType, viewed: boolean, postId: number, reporter?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, post?: { anonymousMode?: EPostAnonymousMode, commentCount?: number, communityId?: number, createdDate: Date, createdDateTime?: Date, feeling?: EPostFeeling, hasRelated?: boolean, message?: string, pinned: boolean, relateCount?: number, shareCount?: number, shareOption?: EShareOption, status?: EEntryStatus, tags?: Array<string>, topicId?: number, id: number, authorCommunityRole?: ECommunityRole, isNegative?: boolean, assets?: Array<{ postId?: number, assetId: string, contentType: string, fileName: string, presignedUrl?: string }>, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, taggedUsers?: Array<{ placeholder: string, user: { id: number, displayedName?: string, firstName?: string, lastName?: string, profileImage?: { presignedUrl?: string } } }>, topic?: { id: number, title: string, description?: string, postsCount?: number }, community?: { id: number, key?: string, title: string, description: string, userConnection?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } }, poll?: { id: number, start?: Date, end?: Date, postId: number, title: string, items?: Array<{ id: number, title: string, votesCount: number, votes: Array<{ pollItemId: number, userId: number }> }>, userVote?: { pollItemId: number, userId: number } }, relate?: { id: number, type?: ERelateType, userId: number } | { id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } } };

export type ReportPostGraphTypeFragment = { id: number, message?: string, reporterId: number, type?: EReportType, viewed: boolean, postId: number, reporter?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, post?: { id: number, authorCommunityRole?: ECommunityRole, isNegative?: boolean, pinned: boolean, community?: { id: number, key?: string, title: string, description: string, userConnection?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } }, poll?: { id: number, start?: Date, end?: Date, postId: number, title: string, items?: Array<{ id: number, title: string, votesCount: number, votes: Array<{ pollItemId: number, userId: number }> }>, userVote?: { pollItemId: number, userId: number } }, relate?: { id: number, type?: ERelateType, userId: number } | { id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } } };

export type ReportCommentGraphTypeFragment = { id: number, message?: string, reporterId: number, type?: EReportType, viewed: boolean, commentId: number, reporter?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, comment?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } };

export type UserDetailsFragment = { about?: string, displayedName?: string, email?: string, firstName?: string, hasInteracted?: boolean, id: number, isAnonymous?: boolean, isOnline?: boolean, isTermsAndConditionsAccepted?: boolean, key?: string, lastName?: string, settings?: Array<EUserSettings>, username?: string, activeCommunities?: { totalCount?: number, edges?: Array<{ node?: { id: number, title: string, userConnection?: { role?: ECommunityRole } } }> }, connections?: { totalCount?: number }, coverImage?: { assetId: string, contentType: string, fileName: string, fileSizeInBytes?: number, presignedUrl?: string, s3Key: string, uploaded?: string }, profileImage?: { assetId: string, contentType: string, fileName: string, fileSizeInBytes?: number, presignedUrl?: string, s3Key: string, uploaded?: string }, userConnection?: { connectionStatus?: EConnectionStatus } };

export type AcceptOrDeclineMutationVariables = Exact<{
  inputType: UpdateCommunityConnectionStatusInputType;
}>;


export type AcceptOrDeclineMutation = { communityConnection?: { acceptOrDecline?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } } };

export type AcceptOrDeclineUserConnectionMutationVariables = Exact<{
  connectionId: Scalars['Int']['input'];
  connectionStatus: EConnectionStatus;
}>;


export type AcceptOrDeclineUserConnectionMutation = { userConnection?: { acceptOrDecline?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number, user?: { id: number, key?: string, displayedName?: string, profileImage?: { presignedUrl?: string } } } } };

export type AcceptTermsAndConditionsMutationVariables = Exact<{ [key: string]: never; }>;


export type AcceptTermsAndConditionsMutation = { user?: { acceptTermsAndConditions?: boolean } };

export type CommentRelateMutationVariables = Exact<{
  commentId: Scalars['Int']['input'];
  type: ERelateType;
}>;


export type CommentRelateMutation = { commentRelate?: { create?: boolean } };

export type CreateAssetsForMultiplePostsMutationVariables = Exact<{
  type: EAssetType;
  fileName: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  alt?: InputMaybe<Scalars['String']['input']>;
  fileSizeInBytes: Scalars['Int']['input'];
  postIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  shouldIncludeAsset?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateAssetsForMultiplePostsMutation = { asset?: { createAssetsForMultiplePosts?: Array<{ signedUrl?: string, asset?: { assetId: string, contentType: string, fileName: string, fileSizeInBytes?: number, messId?: number, postId?: number, presignedUrl?: string, s3Key: string, uploaded?: string } }> } };

export type CreateCommentMutationVariables = Exact<{
  request: CreateCommentInputType;
}>;


export type CreateCommentMutation = { comment?: { create?: { id: number, createdDateTime?: Date, message?: string, postId?: number, author?: { displayedName?: string, firstName?: string, isOnline?: boolean, lastName?: string, profileImage?: { presignedUrl?: string }, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> } }, comments?: { edges?: Array<{ node?: { id: number, createdDateTime?: Date, message?: string, author?: { displayedName?: string, firstName?: string, lastName?: string, profileImage?: { presignedUrl?: string } } } }> } } } };

export type CreateCommunityMutationVariables = Exact<{
  inputType: CreateCommunityInputType;
}>;


export type CreateCommunityMutation = { community?: { create?: { categoryId?: number, description: string, id: number, privacy?: ECommunityPrivacy, status?: ECommunityStatus, title: string } } };

export type CreateCommunityAssetMutationVariables = Exact<{
  type: EAssetType;
  fileName: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  communityId: Scalars['Int']['input'];
  alt?: InputMaybe<Scalars['String']['input']>;
  fileSizeInBytes: Scalars['Int']['input'];
  usage: ECommunityAssetUsage;
  shouldIncludeAsset?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateCommunityAssetMutation = { asset?: { createCommunityAsset?: { signedUrl?: string, asset?: { assetId: string, contentType: string, fileName: string, fileSizeInBytes?: number, presignedUrl?: string, s3Key: string, uploaded?: string } } } };

export type CreateCommunityCategoryMutationVariables = Exact<{
  inputType: CraeteCommunityCategoryInputType;
}>;


export type CreateCommunityCategoryMutation = { communityCategory?: { create?: { id: number, title: string } } };

export type CreateConversationMutationVariables = Exact<{
  receiverId: Scalars['Int']['input'];
  message: Scalars['String']['input'];
}>;


export type CreateConversationMutation = { message?: { createConversation?: { createdDate: Date, id: number, isSeenByReceiver: boolean, status?: EMessageStatus, text: string, receiver?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, sender?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } } };

export type CreateConversationsMutationVariables = Exact<{
  receivers: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  message: Scalars['String']['input'];
}>;


export type CreateConversationsMutation = { message?: { createConversations?: boolean } };

export type CreateFeedbackMutationVariables = Exact<{
  message: Scalars['String']['input'];
}>;


export type CreateFeedbackMutation = { feedback?: { create?: { id: number, message: string, userId: number } } };

export type CreateMessageAssetMutationVariables = Exact<{
  type: EAssetType;
  fileName: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  messageId: Scalars['Int']['input'];
  alt?: InputMaybe<Scalars['String']['input']>;
  fileSizeInBytes: Scalars['Int']['input'];
  shouldIncludeAsset?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateMessageAssetMutation = { asset?: { createMessageAsset?: { signedUrl?: string, asset?: { assetId: string, contentType: string, fileName: string, fileSizeInBytes?: number, messId?: number, postId?: number, presignedUrl?: string, s3Key: string, uploaded?: string } } } };

export type CreateMultiCommunityPostsMutationVariables = Exact<{
  request: CreatePostInputType;
}>;


export type CreateMultiCommunityPostsMutation = { post?: { createMultiCommunityPosts?: Array<{ id: number, communityId?: number }> } };

export type CreatePollMutationVariables = Exact<{
  postId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  items: Array<InputMaybe<PollItemInputType>> | InputMaybe<PollItemInputType>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type CreatePollMutation = { poll?: { add?: { id: number, title: string } } };

export type CreatePollToPostsMutationVariables = Exact<{
  postIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  items: Array<InputMaybe<PollItemInputType>> | InputMaybe<PollItemInputType>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type CreatePollToPostsMutation = { poll?: { addPollToPosts?: Array<{ id: number, title: string }> } };

export type CreatePostMutationVariables = Exact<{
  request: CreatePostInputType;
}>;


export type CreatePostMutation = { post?: { create?: { id: number, commentCount?: number, createdDate: Date, createdDateTime?: Date, feeling?: EPostFeeling, hasRelated?: boolean, message?: string, pinned: boolean, relateCount?: number, shareCount?: number, shareOption?: EShareOption, status?: EEntryStatus, tags?: Array<string>, updatedDate: Date, authorCommunityRole?: ECommunityRole, isNegative?: boolean, assets?: Array<{ postId?: number, assetId: string, contentType: string, fileName: string, presignedUrl?: string, s3Key: string }>, author?: { id: number, displayedName?: string, firstName?: string, lastName?: string, isAnonymous?: boolean }, topic?: { id: number, title: string, description?: string, postsCount?: number }, community?: { id: number, key?: string, title: string, description: string, userConnection?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } }, poll?: { id: number, start?: Date, end?: Date, postId: number, title: string, items?: Array<{ id: number, title: string, votesCount: number, votes: Array<{ pollItemId: number, userId: number }> }>, userVote?: { pollItemId: number, userId: number } }, relate?: { id: number, type?: ERelateType, userId: number } | { id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } } } };

export type CreatePostAssetMutationVariables = Exact<{
  type: EAssetType;
  fileName: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  alt?: InputMaybe<Scalars['String']['input']>;
  fileSizeInBytes: Scalars['Int']['input'];
  postId: Scalars['Int']['input'];
  shouldIncludeAsset?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatePostAssetMutation = { asset?: { createPostAsset?: { signedUrl?: string, asset?: { assetId: string, contentType: string, fileName: string, fileSizeInBytes?: number, messId?: number, postId?: number, presignedUrl?: string, s3Key: string, uploaded?: string } } } };

export type CreatePostReportMutationVariables = Exact<{
  postId: Scalars['Int']['input'];
  type: EReportType;
}>;


export type CreatePostReportMutation = { report?: { create?: { id: number, post?: { anonymousMode?: EPostAnonymousMode, commentCount?: number, communityId?: number, createdDate: Date, createdDateTime?: Date, feeling?: EPostFeeling, hasRelated?: boolean, message?: string, pinned: boolean, relateCount?: number, shareCount?: number, shareOption?: EShareOption, status?: EEntryStatus, tags?: Array<string>, topicId?: number, updatedDate: Date, id: number, authorCommunityRole?: ECommunityRole, isNegative?: boolean, assets?: Array<{ postId?: number, assetId: string, contentType: string, fileName: string, presignedUrl?: string }>, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, taggedUsers?: Array<{ placeholder: string, user: { id: number, displayedName?: string, firstName?: string, lastName?: string, profileImage?: { presignedUrl?: string } } }>, topic?: { id: number, title: string, description?: string, postsCount?: number }, community?: { id: number, key?: string, title: string, description: string, userConnection?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } }, poll?: { id: number, start?: Date, end?: Date, postId: number, title: string, items?: Array<{ id: number, title: string, votesCount: number, votes: Array<{ pollItemId: number, userId: number }> }>, userVote?: { pollItemId: number, userId: number } }, relate?: { id: number, type?: ERelateType, userId: number } | { id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } }, reporter?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } } };

export type CreateSharePostMutationVariables = Exact<{
  request: CreateSharePostInptuType;
}>;


export type CreateSharePostMutation = { post?: { sharePost?: { id: number, originalPost?: { anonymousMode?: EPostAnonymousMode, commentCount?: number, communityId?: number, createdDate: Date, createdDateTime?: Date, feeling?: EPostFeeling, hasRelated?: boolean, message?: string, pinned: boolean, relateCount?: number, shareCount?: number, shareOption?: EShareOption, status?: EEntryStatus, tags?: Array<string>, topicId?: number, updatedDate: Date, id: number, authorCommunityRole?: ECommunityRole, isNegative?: boolean, assets?: Array<{ postId?: number, assetId: string, contentType: string, fileName: string, presignedUrl?: string }>, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, taggedUsers?: Array<{ placeholder: string, user: { id: number, displayedName?: string, firstName?: string, lastName?: string, profileImage?: { presignedUrl?: string } } }>, topic?: { id: number, title: string, description?: string, postsCount?: number }, community?: { id: number, key?: string, title: string, description: string, userConnection?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } }, poll?: { id: number, start?: Date, end?: Date, postId: number, title: string, items?: Array<{ id: number, title: string, votesCount: number, votes: Array<{ pollItemId: number, userId: number }> }>, userVote?: { pollItemId: number, userId: number } }, relate?: { id: number, type?: ERelateType, userId: number } | { id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } } } } };

export type CreateSubCommentMutationVariables = Exact<{
  request: CreateSubCommentInputType;
}>;


export type CreateSubCommentMutation = { comment?: { createSubComment?: { id: number, createdDateTime?: Date, message?: string, parentCommentId?: number, postId?: number, author?: { displayedName?: string, firstName?: string, isOnline?: boolean, lastName?: string, profileImage?: { presignedUrl?: string }, communityConnections?: { edges?: Array<{ node?: { communityId: number, role?: ECommunityRole } }> } } } } };

export type CreateUserAssetMutationVariables = Exact<{
  type: EAssetType;
  fileName: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  alt?: InputMaybe<Scalars['String']['input']>;
  fileSizeInBytes: Scalars['Int']['input'];
  shouldIncludeAsset?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateUserAssetMutation = { asset?: { createUserAsset?: { signedUrl?: string, asset?: { assetId: string, contentType: string, fileName: string, fileSizeInBytes?: number, presignedUrl?: string, s3Key: string, uploaded?: string } } } };

export type CreateUserConnectionMutationVariables = Exact<{
  friendId: Scalars['Int']['input'];
}>;


export type CreateUserConnectionMutation = { userConnection?: { create?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } };

export type DeleteAssetMutationVariables = Exact<{
  assetId: Scalars['String']['input'];
}>;


export type DeleteAssetMutation = { asset?: { deleteAsset?: boolean } };

export type DeleteCommentMutationVariables = Exact<{
  commentId: Scalars['Int']['input'];
}>;


export type DeleteCommentMutation = { comment?: { delete?: boolean } };

export type DeleteCommentRelateMutationVariables = Exact<{
  commentRelateId: Scalars['Int']['input'];
}>;


export type DeleteCommentRelateMutation = { commentRelate?: { delete?: boolean } };

export type DeleteCommentRelateByCommentIdMutationVariables = Exact<{
  commentId: Scalars['Int']['input'];
}>;


export type DeleteCommentRelateByCommentIdMutation = { commentRelate?: { deletePerComment?: boolean } };

export type DeleteCommunityMutationVariables = Exact<{
  communityId: Scalars['Int']['input'];
}>;


export type DeleteCommunityMutation = { community?: { delete?: boolean } };

export type DeleteConversationMutationVariables = Exact<{
  messageId: Scalars['Int']['input'];
}>;


export type DeleteConversationMutation = { message?: { deleteConversation?: boolean } };

export type DeletePollMutationVariables = Exact<{
  postId: Scalars['Int']['input'];
}>;


export type DeletePollMutation = { poll?: { delete?: boolean } };

export type DeletePostMutationVariables = Exact<{
  postId: Scalars['Int']['input'];
}>;


export type DeletePostMutation = { post?: { delete?: boolean } };

export type DeleteRelatePostMutationVariables = Exact<{
  postId: Scalars['Int']['input'];
}>;


export type DeleteRelatePostMutation = { postRelate?: { delete?: boolean } };

export type DeleteUserConnectionMutationVariables = Exact<{
  connectionId: Scalars['Int']['input'];
}>;


export type DeleteUserConnectionMutation = { userConnection?: { delete?: { connectionStatus?: EConnectionStatus, createdDate: Date, id: number, updatedDate: Date, userId: number } } };

export type EnableAccountMutationVariables = Exact<{
  displayedName?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
}>;


export type EnableAccountMutation = { user?: { enableAccount?: boolean } };

export type JoinCommunityMutationVariables = Exact<{
  communityId: Scalars['Int']['input'];
}>;


export type JoinCommunityMutation = { communityConnection?: { joinCommunity?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus } } };

export type JoinCommunityWithKeyMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  key: Scalars['String']['input'];
}>;


export type JoinCommunityWithKeyMutation = { communityConnection?: { joinCommunityWithKey?: boolean } };

export type LeaveCommunityMutationVariables = Exact<{
  connectionId: Scalars['Int']['input'];
}>;


export type LeaveCommunityMutation = { communityConnection?: { leaveCommunity?: boolean } };

export type MakeMessageReadByReceiverMutationVariables = Exact<{
  messageId: Scalars['Int']['input'];
}>;


export type MakeMessageReadByReceiverMutation = { message?: { makeMessageReadByReceiver?: boolean } };

export type MakeWholeConversationReadMutationVariables = Exact<{
  senderId: Scalars['Int']['input'];
}>;


export type MakeWholeConversationReadMutation = { message?: { makeWholeConversationRead?: boolean } };

export type PostRelateMutationVariables = Exact<{
  postId: Scalars['Int']['input'];
  type: ERelateType;
}>;


export type PostRelateMutation = { postRelate?: { create?: boolean } };

export type RemoveMemberByAuthorityMutationVariables = Exact<{
  communityId: Scalars['Int']['input'];
  connectionId: Scalars['Int']['input'];
  memberId: Scalars['Int']['input'];
}>;


export type RemoveMemberByAuthorityMutation = { communityConnection?: { removeMemberByAuthority?: boolean } };

export type ReportCommentMutationVariables = Exact<{
  commentId: Scalars['Int']['input'];
  type: EReportType;
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportCommentMutation = { report?: { reportComment?: { id: number, type?: EReportType, message?: string } } };

export type ReportPostMutationVariables = Exact<{
  postId: Scalars['Int']['input'];
  type: EReportType;
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportPostMutation = { report?: { reportPost?: { id: number, type?: EReportType, message?: string } } };

export type SetIsOnlineMutationVariables = Exact<{
  isOnline: Scalars['Boolean']['input'];
}>;


export type SetIsOnlineMutation = { user?: { setIsOnline?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } };

export type SharePostMutationVariables = Exact<{
  request: CreateSharePostInptuType;
}>;


export type SharePostMutation = { post?: { sharePost?: { id: number } } };

export type ToggleAlumniMutationVariables = Exact<{
  communityId: Scalars['Int']['input'];
  isAlumni: Scalars['Boolean']['input'];
}>;


export type ToggleAlumniMutation = { communityConnection?: { toggleAlumni?: boolean } };

export type TogglePinnedPostMutationVariables = Exact<{
  postId: Scalars['Int']['input'];
}>;


export type TogglePinnedPostMutation = { post?: { togglePinned?: { id: number, authorCommunityRole?: ECommunityRole, isNegative?: boolean, pinned: boolean, community?: { id: number, key?: string, title: string, description: string, userConnection?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } }, poll?: { id: number, start?: Date, end?: Date, postId: number, title: string, items?: Array<{ id: number, title: string, votesCount: number, votes: Array<{ pollItemId: number, userId: number }> }>, userVote?: { pollItemId: number, userId: number } }, relate?: { id: number, type?: ERelateType, userId: number } | { id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } } } };

export type TogglePostVisibilityMutationVariables = Exact<{
  postId: Scalars['Int']['input'];
}>;


export type TogglePostVisibilityMutation = { post?: { toggleVisibility?: { id: number } } };

export type UpdateCommentMutationVariables = Exact<{
  request: UpdateCommentInputType;
}>;


export type UpdateCommentMutation = { comment?: { update?: { id: number } } };

export type UpdateCommentStatusMutationVariables = Exact<{
  commentId: Scalars['Int']['input'];
  status: EEntryStatus;
}>;


export type UpdateCommentStatusMutation = { comment?: { updateStatus?: boolean } };

export type UpdateCommunityMutationVariables = Exact<{
  inputType: UpdateCommunityInputType;
}>;


export type UpdateCommunityMutation = { community?: { update?: { categoryId?: number, description: string, id: number, privacy?: ECommunityPrivacy, status?: ECommunityStatus, title: string } } };

export type UpdateCommunityRoleMutationVariables = Exact<{
  inputType: UpdateCommunityRuleInputType;
}>;


export type UpdateCommunityRoleMutation = { communityConnection?: { updateCommunityRole?: { id: number } } };

export type UpdatePollMutationVariables = Exact<{
  postId: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  items: Array<InputMaybe<PollItemInputType>> | InputMaybe<PollItemInputType>;
}>;


export type UpdatePollMutation = { poll?: { update?: { id: number } } };

export type UpdatePostMutationVariables = Exact<{
  request: UpdatePostInputType;
}>;


export type UpdatePostMutation = { post?: { update?: { id: number, authorCommunityRole?: ECommunityRole, isNegative?: boolean, pinned: boolean, community?: { id: number, key?: string, title: string, description: string, userConnection?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } }, poll?: { id: number, start?: Date, end?: Date, postId: number, title: string, items?: Array<{ id: number, title: string, votesCount: number, votes: Array<{ pollItemId: number, userId: number }> }>, userVote?: { pollItemId: number, userId: number } }, relate?: { id: number, type?: ERelateType, userId: number } | { id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } } } };

export type UpdatePostStatusMutationVariables = Exact<{
  postId: Scalars['Int']['input'];
  status: EEntryStatus;
}>;


export type UpdatePostStatusMutation = { post?: { updateStatus?: boolean } };

export type UpdateSettingsMutationVariables = Exact<{
  inputType: Array<InputMaybe<EUserSettings>> | InputMaybe<EUserSettings>;
}>;


export type UpdateSettingsMutation = { user?: { updateSettings?: { id: number, settings?: Array<EUserSettings> } } };

export type UpdateUserAboutMutationVariables = Exact<{
  about: Scalars['String']['input'];
}>;


export type UpdateUserAboutMutation = { user?: { updateAbout?: boolean } };

export type UpdateUserImagesMutationVariables = Exact<{
  profileImage?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserImagesMutation = { user?: { updateUserImages?: boolean } };

export type VoteAPollMutationVariables = Exact<{
  pollId: Scalars['Int']['input'];
  itemId: Scalars['Int']['input'];
}>;


export type VoteAPollMutation = { poll?: { vote?: { id: number, start?: Date, end?: Date, postId: number, title: string, items?: Array<{ id: number, title: string, votesCount: number, votes: Array<{ pollItemId: number, userId: number }> }>, userVote?: { pollItemId: number, userId: number } } } };

export type GetAllPublicCommunitiesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllPublicCommunitiesQuery = { community?: { allPublic?: { totalCount?: number, pageInfo: { endCursor?: string, hasNextPage: boolean }, edges?: Array<{ cursor: string, node?: { categoryId?: number, description: string, id: number, key?: string, title: string, privacy?: ECommunityPrivacy, profileImage?: { presignedUrl?: string }, userConnection?: { status?: EConnectionStatus, user?: { activeCommunities?: { edges?: Array<{ node?: { id: number } }> } } } } }> } } };

export type GetCommentRelatesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  commentId: Scalars['Int']['input'];
}>;


export type GetCommentRelatesQuery = { commentRelate?: { get?: { totalCount?: number, edges?: Array<{ cursor: string, node?: { commentId?: number, id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, lastName?: string, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number, user?: { about?: string, displayedName?: string, email?: string, firstName?: string, hasInteracted?: boolean, id: number, isAnonymous?: boolean, isOnline?: boolean, isTermsAndConditionsAccepted?: boolean, key?: string, lastName?: string, settings?: Array<EUserSettings>, username?: string, activeCommunities?: { totalCount?: number, edges?: Array<{ node?: { categoryId?: number, description: string, id: number, privacy?: ECommunityPrivacy, status?: ECommunityStatus, title: string, userConnection?: { role?: ECommunityRole } } }> }, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, connections?: { totalCount?: number }, coverImage?: { presignedUrl?: string, id: string }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } } } }> } } };

export type GetCommentReportsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  communityId: Scalars['Int']['input'];
}>;


export type GetCommentReportsQuery = { report?: { getCommentReports?: { edges?: Array<{ cursor: string, node?: { id: number, message?: string, reporterId: number, type?: EReportType, viewed: boolean, commentId: number, reporter?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, comment?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } } }>, pageInfo: { endCursor?: string, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string } } } };

export type GetCommentsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  subCommentsAfter?: InputMaybe<Scalars['String']['input']>;
  subSubCommentsAfter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  postId?: InputMaybe<Scalars['Int']['input']>;
  commentStatus?: InputMaybe<EEntryStatus>;
  shouldIncludeSubComments?: InputMaybe<Scalars['Boolean']['input']>;
  shouldIncludeSubSubComments?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<ESorting>;
}>;


export type GetCommentsQuery = { comment?: { getComments?: { totalCount?: number, edges?: Array<{ cursor: string, node?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, comments?: { totalCount?: number, edges?: Array<{ cursor: string, node?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, comments?: { totalCount?: number, edges?: Array<{ cursor: string, node?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } }>, pageInfo: { endCursor?: string, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string } } } }>, pageInfo: { endCursor?: string, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string } } } }>, pageInfo: { endCursor?: string, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string } } } };

export type SearchByCategoryQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  categoryId: Scalars['Int']['input'];
  shouldIncludeUserConnection?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchByCategoryQuery = { community?: { searchByCategory?: { totalCount?: number, pageInfo: { endCursor?: string, hasNextPage: boolean }, edges?: Array<{ cursor: string, node?: { categoryId?: number, description: string, id: number, privacy?: ECommunityPrivacy, status?: ECommunityStatus, title: string, bannerImage?: { presignedUrl?: string }, profileImage?: { presignedUrl?: string }, userConnection?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } } }> } } };

export type GetCommunitiesByUserQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  shouldIncludeCommunities?: InputMaybe<Scalars['Boolean']['input']>;
  shouldIncludeProfileImage?: InputMaybe<Scalars['Boolean']['input']>;
  shouldIncludeUserConnection?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCommunitiesByUserQuery = { community?: { userCommunities?: { totalCount?: number, edges?: Array<{ cursor: string, node?: { categoryId?: number, description: string, id: number, key?: string, privacy?: ECommunityPrivacy, status?: ECommunityStatus, title: string, profileImage?: { presignedUrl?: string }, userConnection?: { communityId: number, createdDate: Date, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } } }> } } };

export type GetCommunitiesOfUserQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  status?: InputMaybe<EConnectionStatus>;
  shouldIncludeProfileImage?: InputMaybe<Scalars['Boolean']['input']>;
  shouldIncludeUserConnection?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCommunitiesOfUserQuery = { communityConnection?: { ofUser?: Array<{ community?: { categoryId?: number, description: string, id: number, key?: string, privacy?: ECommunityPrivacy, status?: ECommunityStatus, title: string, profileImage?: { presignedUrl?: string }, userConnection?: { communityId: number, createdDate: Date, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } } }> } };

export type GetCommunityQueryVariables = Exact<{
  communityId?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  shouldIncludeUserConnection?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCommunityQuery = { community?: { get: { categoryId?: number, description: string, key?: string, id: number, privacy?: ECommunityPrivacy, status?: ECommunityStatus, title: string, bannerImage?: { presignedUrl?: string }, profileImage?: { presignedUrl?: string }, userConnection?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } } } };

export type GetCommunityCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommunityCategoriesQuery = { communityCategory?: { getCommunityCategories?: Array<{ id: number, title: string }> } };

export type GetCommunityCommentsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  communityId: Scalars['Int']['input'];
  commentStatus?: InputMaybe<EEntryStatus>;
}>;


export type GetCommunityCommentsQuery = { comment?: { getCommunityComments?: { totalCount?: number, pageInfo: { endCursor?: string, hasNextPage: boolean }, edges?: Array<{ cursor: string, node?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } }> } } };

export type GetCommunityConnectionStatusQueryVariables = Exact<{
  communityId: Scalars['Int']['input'];
}>;


export type GetCommunityConnectionStatusQuery = { communityConnection?: { connectionStatus?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } } };

export type GetCommunityPostsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  communityId: Scalars['Int']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  shouldIncludeComments?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCommunityPostsQuery = { post?: { getCommunityPosts?: { pageInfo: { endCursor?: string, hasNextPage: boolean }, edges?: Array<{ cursor: string, node?: { id: number, authorCommunityRole?: ECommunityRole, isNegative?: boolean, anonymousMode?: EPostAnonymousMode, commentCount?: number, communityId?: number, createdDate: Date, createdDateTime?: Date, feeling?: EPostFeeling, hasRelated?: boolean, message?: string, pinned: boolean, relateCount?: number, shareCount?: number, shareOption?: EShareOption, status?: EEntryStatus, tags?: Array<string>, topicId?: number, updatedDate: Date, community?: { id: number, key?: string, title: string, description: string, userConnection?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } }, poll?: { id: number, start?: Date, end?: Date, postId: number, title: string, items?: Array<{ id: number, title: string, votesCount: number, votes: Array<{ pollItemId: number, userId: number }> }>, userVote?: { pollItemId: number, userId: number } }, relate?: { id: number, type?: ERelateType, userId: number } | { id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } }, assets?: Array<{ postId?: number, assetId: string, contentType: string, fileName: string, presignedUrl?: string }>, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, taggedUsers?: Array<{ placeholder: string, user: { id: number, displayedName?: string, firstName?: string, lastName?: string, profileImage?: { presignedUrl?: string } } }>, topic?: { id: number, title: string, description?: string, postsCount?: number }, comments?: { pageInfo: { endCursor?: string, hasNextPage: boolean, hasPreviousPage: boolean }, edges?: Array<{ cursor: string, node?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } }> } } | { id: number, anonymousMode?: EPostAnonymousMode, commentCount?: number, communityId?: number, createdDate: Date, createdDateTime?: Date, feeling?: EPostFeeling, hasRelated?: boolean, message?: string, pinned: boolean, relateCount?: number, shareCount?: number, shareOption?: EShareOption, status?: EEntryStatus, tags?: Array<string>, topicId?: number, updatedDate: Date, originalPost?: { anonymousMode?: EPostAnonymousMode, commentCount?: number, communityId?: number, createdDate: Date, createdDateTime?: Date, feeling?: EPostFeeling, hasRelated?: boolean, message?: string, pinned: boolean, relateCount?: number, shareCount?: number, shareOption?: EShareOption, status?: EEntryStatus, tags?: Array<string>, topicId?: number, updatedDate: Date, id: number, authorCommunityRole?: ECommunityRole, isNegative?: boolean, assets?: Array<{ postId?: number, assetId: string, contentType: string, fileName: string, presignedUrl?: string }>, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, taggedUsers?: Array<{ placeholder: string, user: { id: number, displayedName?: string, firstName?: string, lastName?: string, profileImage?: { presignedUrl?: string } } }>, topic?: { id: number, title: string, description?: string, postsCount?: number }, community?: { id: number, key?: string, title: string, description: string, userConnection?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } }, poll?: { id: number, start?: Date, end?: Date, postId: number, title: string, items?: Array<{ id: number, title: string, votesCount: number, votes: Array<{ pollItemId: number, userId: number }> }>, userVote?: { pollItemId: number, userId: number } }, relate?: { id: number, type?: ERelateType, userId: number } | { id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } }, assets?: Array<{ postId?: number, assetId: string, contentType: string, fileName: string, presignedUrl?: string }>, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, taggedUsers?: Array<{ placeholder: string, user: { id: number, displayedName?: string, firstName?: string, lastName?: string, profileImage?: { presignedUrl?: string } } }>, topic?: { id: number, title: string, description?: string, postsCount?: number }, comments?: { pageInfo: { endCursor?: string, hasNextPage: boolean, hasPreviousPage: boolean }, edges?: Array<{ cursor: string, node?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } }> } } }> } } };

export type GetCommunityUsersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  communityId: Scalars['Int']['input'];
  searchPrivacy?: InputMaybe<Array<InputMaybe<ESearchPrivacy>> | InputMaybe<ESearchPrivacy>>;
  status?: InputMaybe<Array<InputMaybe<EConnectionStatus>> | InputMaybe<EConnectionStatus>>;
  shouldIncludeUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasAcceptedTerms?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCommunityUsersQuery = { communityConnection?: { users?: { totalCount?: number, edges?: Array<{ cursor: string, node?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, updatedDate: Date, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } }> } } };

export type GetConnectedUsersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeConnections?: InputMaybe<Scalars['Boolean']['input']>;
  includeSharedCommunity?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetConnectedUsersQuery = { user?: { connectedUsers?: { totalCount?: number, pageInfo: { endCursor?: string, hasNextPage: boolean }, edges?: Array<{ cursor: string, node?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isTermsAndConditionsAccepted?: boolean, key?: string, lastName?: string, activeCommunities?: { edges?: Array<{ node?: { id: number } }> }, profileImage?: { presignedUrl?: string } } }> } } };

export type GetConnectionQueryVariables = Exact<{
  connectionId: Scalars['Int']['input'];
}>;


export type GetConnectionQuery = { userConnection?: { get?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } };

export type GetConnectionPostsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  sort?: InputMaybe<EPostSorting>;
  shouldIncludeComments?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetConnectionPostsQuery = { post?: { connectionPosts?: { totalCount?: number, pageInfo: { endCursor?: string, hasNextPage: boolean }, edges?: Array<{ cursor: string, node?: { id: number, authorCommunityRole?: ECommunityRole, isNegative?: boolean, anonymousMode?: EPostAnonymousMode, commentCount?: number, communityId?: number, createdDate: Date, createdDateTime?: Date, feeling?: EPostFeeling, hasRelated?: boolean, message?: string, pinned: boolean, relateCount?: number, shareCount?: number, shareOption?: EShareOption, status?: EEntryStatus, tags?: Array<string>, topicId?: number, updatedDate: Date, community?: { id: number, key?: string, title: string, description: string, userConnection?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } }, poll?: { id: number, start?: Date, end?: Date, postId: number, title: string, items?: Array<{ id: number, title: string, votesCount: number, votes: Array<{ pollItemId: number, userId: number }> }>, userVote?: { pollItemId: number, userId: number } }, relate?: { id: number, type?: ERelateType, userId: number } | { id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } }, assets?: Array<{ postId?: number, assetId: string, contentType: string, fileName: string, presignedUrl?: string }>, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, taggedUsers?: Array<{ placeholder: string, user: { id: number, displayedName?: string, firstName?: string, lastName?: string, profileImage?: { presignedUrl?: string } } }>, topic?: { id: number, title: string, description?: string, postsCount?: number }, comments?: { pageInfo: { endCursor?: string, hasNextPage: boolean, hasPreviousPage: boolean }, edges?: Array<{ cursor: string, node?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } }> } } | { id: number, anonymousMode?: EPostAnonymousMode, commentCount?: number, communityId?: number, createdDate: Date, createdDateTime?: Date, feeling?: EPostFeeling, hasRelated?: boolean, message?: string, pinned: boolean, relateCount?: number, shareCount?: number, shareOption?: EShareOption, status?: EEntryStatus, tags?: Array<string>, topicId?: number, updatedDate: Date, originalPost?: { anonymousMode?: EPostAnonymousMode, commentCount?: number, communityId?: number, createdDate: Date, createdDateTime?: Date, feeling?: EPostFeeling, hasRelated?: boolean, message?: string, pinned: boolean, relateCount?: number, shareCount?: number, shareOption?: EShareOption, status?: EEntryStatus, tags?: Array<string>, topicId?: number, updatedDate: Date, id: number, authorCommunityRole?: ECommunityRole, isNegative?: boolean, assets?: Array<{ postId?: number, assetId: string, contentType: string, fileName: string, presignedUrl?: string }>, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, taggedUsers?: Array<{ placeholder: string, user: { id: number, displayedName?: string, firstName?: string, lastName?: string, profileImage?: { presignedUrl?: string } } }>, topic?: { id: number, title: string, description?: string, postsCount?: number }, community?: { id: number, key?: string, title: string, description: string, userConnection?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } }, poll?: { id: number, start?: Date, end?: Date, postId: number, title: string, items?: Array<{ id: number, title: string, votesCount: number, votes: Array<{ pollItemId: number, userId: number }> }>, userVote?: { pollItemId: number, userId: number } }, relate?: { id: number, type?: ERelateType, userId: number } | { id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } }, assets?: Array<{ postId?: number, assetId: string, contentType: string, fileName: string, presignedUrl?: string }>, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, taggedUsers?: Array<{ placeholder: string, user: { id: number, displayedName?: string, firstName?: string, lastName?: string, profileImage?: { presignedUrl?: string } } }>, topic?: { id: number, title: string, description?: string, postsCount?: number }, comments?: { pageInfo: { endCursor?: string, hasNextPage: boolean, hasPreviousPage: boolean }, edges?: Array<{ cursor: string, node?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } }> } } }> } } };

export type GetConversationQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  otherUserId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetConversationQuery = { message?: { getConversation?: { totalCount?: number, pageInfo: { endCursor?: string, hasNextPage: boolean }, edges?: Array<{ cursor: string, node?: { createdDate: Date, id: number, isSeenByReceiver: boolean, status?: EMessageStatus, text: string, receiver?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, sender?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } }> } } };

export type GetConversationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetConversationsQuery = { message?: { getConversationList?: { totalCount?: number, pageInfo: { endCursor?: string, hasNextPage: boolean }, edges?: Array<{ cursor: string, node?: { unReadCount?: number, lastMessage?: { id: number, createdDate: Date, isSeenByReceiver: boolean, status?: EMessageStatus, text: string, sender?: { __typename: 'UserGraphType', displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } }, receiver?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } }> } } };

export type GetEmbargoCommentsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  communityId: Scalars['Int']['input'];
}>;


export type GetEmbargoCommentsQuery = { comment?: { embargoComments?: { totalCount?: number, pageInfo: { endCursor?: string, hasNextPage: boolean }, edges?: Array<{ cursor: string, node?: { id: number, message?: string, createdDate: Date, author?: { id: number, displayedName?: string, profileImage?: { presignedUrl?: string } } } }> } } };

export type GetEmbargoPostsQueryVariables = Exact<{
  communityId: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
}>;


export type GetEmbargoPostsQuery = { post?: { embargoPosts?: { totalCount?: number, pageInfo: { endCursor?: string, hasNextPage: boolean }, edges?: Array<{ cursor: string, node?: { id: number, message?: string, createdDate: Date, status?: EEntryStatus, topic?: { id: number, title: string }, author?: { id: number, displayedName?: string, profileImage?: { presignedUrl?: string } } } | { id: number, message?: string, createdDate: Date, status?: EEntryStatus, topic?: { id: number, title: string }, author?: { id: number, displayedName?: string, profileImage?: { presignedUrl?: string } } } }> } } };

export type GetIsOnlineQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIsOnlineQuery = { user?: { getUser?: { id: number, isOnline?: boolean } } };

export type GetModeratorsPostsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  sort?: InputMaybe<EPostSorting>;
  shouldIncludeComments?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetModeratorsPostsQuery = { post?: { moderatorsPosts?: { totalCount?: number, pageInfo: { endCursor?: string, hasNextPage: boolean }, edges?: Array<{ cursor: string, node?: { id: number, authorCommunityRole?: ECommunityRole, isNegative?: boolean, anonymousMode?: EPostAnonymousMode, commentCount?: number, communityId?: number, createdDate: Date, createdDateTime?: Date, feeling?: EPostFeeling, hasRelated?: boolean, message?: string, pinned: boolean, relateCount?: number, shareCount?: number, shareOption?: EShareOption, status?: EEntryStatus, tags?: Array<string>, topicId?: number, updatedDate: Date, community?: { id: number, key?: string, title: string, description: string, userConnection?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } }, poll?: { id: number, start?: Date, end?: Date, postId: number, title: string, items?: Array<{ id: number, title: string, votesCount: number, votes: Array<{ pollItemId: number, userId: number }> }>, userVote?: { pollItemId: number, userId: number } }, relate?: { id: number, type?: ERelateType, userId: number } | { id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } }, assets?: Array<{ postId?: number, assetId: string, contentType: string, fileName: string, presignedUrl?: string }>, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, taggedUsers?: Array<{ placeholder: string, user: { id: number, displayedName?: string, firstName?: string, lastName?: string, profileImage?: { presignedUrl?: string } } }>, topic?: { id: number, title: string, description?: string, postsCount?: number }, comments?: { pageInfo: { endCursor?: string, hasNextPage: boolean, hasPreviousPage: boolean }, edges?: Array<{ cursor: string, node?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } }> } } | { id: number, anonymousMode?: EPostAnonymousMode, commentCount?: number, communityId?: number, createdDate: Date, createdDateTime?: Date, feeling?: EPostFeeling, hasRelated?: boolean, message?: string, pinned: boolean, relateCount?: number, shareCount?: number, shareOption?: EShareOption, status?: EEntryStatus, tags?: Array<string>, topicId?: number, updatedDate: Date, originalPost?: { anonymousMode?: EPostAnonymousMode, commentCount?: number, communityId?: number, createdDate: Date, createdDateTime?: Date, feeling?: EPostFeeling, hasRelated?: boolean, message?: string, pinned: boolean, relateCount?: number, shareCount?: number, shareOption?: EShareOption, status?: EEntryStatus, tags?: Array<string>, topicId?: number, updatedDate: Date, id: number, authorCommunityRole?: ECommunityRole, isNegative?: boolean, assets?: Array<{ postId?: number, assetId: string, contentType: string, fileName: string, presignedUrl?: string }>, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, taggedUsers?: Array<{ placeholder: string, user: { id: number, displayedName?: string, firstName?: string, lastName?: string, profileImage?: { presignedUrl?: string } } }>, topic?: { id: number, title: string, description?: string, postsCount?: number }, community?: { id: number, key?: string, title: string, description: string, userConnection?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } }, poll?: { id: number, start?: Date, end?: Date, postId: number, title: string, items?: Array<{ id: number, title: string, votesCount: number, votes: Array<{ pollItemId: number, userId: number }> }>, userVote?: { pollItemId: number, userId: number } }, relate?: { id: number, type?: ERelateType, userId: number } | { id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } }, assets?: Array<{ postId?: number, assetId: string, contentType: string, fileName: string, presignedUrl?: string }>, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, taggedUsers?: Array<{ placeholder: string, user: { id: number, displayedName?: string, firstName?: string, lastName?: string, profileImage?: { presignedUrl?: string } } }>, topic?: { id: number, title: string, description?: string, postsCount?: number }, comments?: { pageInfo: { endCursor?: string, hasNextPage: boolean, hasPreviousPage: boolean }, edges?: Array<{ cursor: string, node?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } }> } } }> } } };

export type GetPossibleConnectionsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPossibleConnectionsQuery = { user?: { possibleConnections?: { totalCount?: number, pageInfo: { endCursor?: string, hasNextPage: boolean }, edges?: Array<{ node?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, lastName?: string, username?: string, profileImage?: { presignedUrl?: string } } }> } } };

export type GetPostQueryVariables = Exact<{
  postId: Scalars['Int']['input'];
}>;


export type GetPostQuery = { post?: { getPost?: { id: number, authorCommunityRole?: ECommunityRole, isNegative?: boolean, anonymousMode?: EPostAnonymousMode, commentCount?: number, communityId?: number, createdDate: Date, createdDateTime?: Date, feeling?: EPostFeeling, hasRelated?: boolean, message?: string, pinned: boolean, relateCount?: number, shareCount?: number, shareOption?: EShareOption, status?: EEntryStatus, tags?: Array<string>, topicId?: number, updatedDate: Date, community?: { id: number, key?: string, title: string, description: string, userConnection?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } }, poll?: { id: number, start?: Date, end?: Date, postId: number, title: string, items?: Array<{ id: number, title: string, votesCount: number, votes: Array<{ pollItemId: number, userId: number }> }>, userVote?: { pollItemId: number, userId: number } }, relate?: { id: number, type?: ERelateType, userId: number } | { id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } }, assets?: Array<{ postId?: number, assetId: string, contentType: string, fileName: string, presignedUrl?: string }>, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, comments?: { totalCount?: number, pageInfo: { endCursor?: string, hasNextPage: boolean, hasPreviousPage: boolean }, edges?: Array<{ cursor: string, node?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, comments?: { totalCount?: number, edges?: Array<{ cursor: string, node?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, comments?: { totalCount?: number, edges?: Array<{ cursor: string, node?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } }>, pageInfo: { endCursor?: string, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string } } } }>, pageInfo: { endCursor?: string, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string } } } }> }, taggedUsers?: Array<{ placeholder: string, user: { id: number, displayedName?: string, firstName?: string, lastName?: string, profileImage?: { presignedUrl?: string } } }>, topic?: { id: number, title: string, description?: string, postsCount?: number } } | { id: number, anonymousMode?: EPostAnonymousMode, commentCount?: number, communityId?: number, createdDate: Date, createdDateTime?: Date, feeling?: EPostFeeling, hasRelated?: boolean, message?: string, pinned: boolean, relateCount?: number, shareCount?: number, shareOption?: EShareOption, status?: EEntryStatus, tags?: Array<string>, topicId?: number, updatedDate: Date, originalPost?: { anonymousMode?: EPostAnonymousMode, commentCount?: number, communityId?: number, createdDate: Date, createdDateTime?: Date, feeling?: EPostFeeling, hasRelated?: boolean, message?: string, pinned: boolean, relateCount?: number, shareCount?: number, shareOption?: EShareOption, status?: EEntryStatus, tags?: Array<string>, topicId?: number, updatedDate: Date, id: number, authorCommunityRole?: ECommunityRole, isNegative?: boolean, assets?: Array<{ postId?: number, assetId: string, contentType: string, fileName: string, presignedUrl?: string }>, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, taggedUsers?: Array<{ placeholder: string, user: { id: number, displayedName?: string, firstName?: string, lastName?: string, profileImage?: { presignedUrl?: string } } }>, topic?: { id: number, title: string, description?: string, postsCount?: number }, community?: { id: number, key?: string, title: string, description: string, userConnection?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } }, poll?: { id: number, start?: Date, end?: Date, postId: number, title: string, items?: Array<{ id: number, title: string, votesCount: number, votes: Array<{ pollItemId: number, userId: number }> }>, userVote?: { pollItemId: number, userId: number } }, relate?: { id: number, type?: ERelateType, userId: number } | { id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } }, assets?: Array<{ postId?: number, assetId: string, contentType: string, fileName: string, presignedUrl?: string }>, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, comments?: { totalCount?: number, pageInfo: { endCursor?: string, hasNextPage: boolean, hasPreviousPage: boolean }, edges?: Array<{ cursor: string, node?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, comments?: { totalCount?: number, edges?: Array<{ cursor: string, node?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, comments?: { totalCount?: number, edges?: Array<{ cursor: string, node?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } }>, pageInfo: { endCursor?: string, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string } } } }>, pageInfo: { endCursor?: string, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string } } } }> }, taggedUsers?: Array<{ placeholder: string, user: { id: number, displayedName?: string, firstName?: string, lastName?: string, profileImage?: { presignedUrl?: string } } }>, topic?: { id: number, title: string, description?: string, postsCount?: number } } } };

export type GetPostRelatesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  postId: Scalars['Int']['input'];
}>;


export type GetPostRelatesQuery = { postRelate?: { get?: { totalCount?: number, pageInfo: { endCursor?: string, hasNextPage: boolean }, edges?: Array<{ cursor: string, node?: { postId?: number, id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, email?: string, id: number, isAnonymous?: boolean, lastName?: string, profileImage?: { assetId: string, contentType: string, fileName: string, fileSizeInBytes?: number, presignedUrl?: string, s3Key: string, uploaded?: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number, user?: { about?: string, displayedName?: string, email?: string, firstName?: string, hasInteracted?: boolean, id: number, isAnonymous?: boolean, isOnline?: boolean, isTermsAndConditionsAccepted?: boolean, key?: string, lastName?: string, settings?: Array<EUserSettings>, username?: string, activeCommunities?: { totalCount?: number, edges?: Array<{ node?: { categoryId?: number, description: string, id: number, privacy?: ECommunityPrivacy, status?: ECommunityStatus, title: string, userConnection?: { role?: ECommunityRole } } }> }, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, connections?: { totalCount?: number }, coverImage?: { presignedUrl?: string, id: string }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } } } }> } } };

export type GetPostReportsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  communityId: Scalars['Int']['input'];
}>;


export type GetPostReportsQuery = { report?: { getPostReports?: { edges?: Array<{ cursor: string, node?: { id: number, message?: string, reporterId: number, type?: EReportType, viewed: boolean, postId: number, reporter?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, post?: { anonymousMode?: EPostAnonymousMode, commentCount?: number, communityId?: number, createdDate: Date, createdDateTime?: Date, feeling?: EPostFeeling, hasRelated?: boolean, message?: string, pinned: boolean, relateCount?: number, shareCount?: number, shareOption?: EShareOption, status?: EEntryStatus, tags?: Array<string>, topicId?: number, id: number, authorCommunityRole?: ECommunityRole, isNegative?: boolean, assets?: Array<{ postId?: number, assetId: string, contentType: string, fileName: string, presignedUrl?: string }>, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, taggedUsers?: Array<{ placeholder: string, user: { id: number, displayedName?: string, firstName?: string, lastName?: string, profileImage?: { presignedUrl?: string } } }>, topic?: { id: number, title: string, description?: string, postsCount?: number }, community?: { id: number, key?: string, title: string, description: string, userConnection?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } }, poll?: { id: number, start?: Date, end?: Date, postId: number, title: string, items?: Array<{ id: number, title: string, votesCount: number, votes: Array<{ pollItemId: number, userId: number }> }>, userVote?: { pollItemId: number, userId: number } }, relate?: { id: number, type?: ERelateType, userId: number } | { id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } } } }>, pageInfo: { endCursor?: string, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string } } } };

export type GetFeedPostsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  commentsAfter?: InputMaybe<Scalars['String']['input']>;
  commentsFirst?: InputMaybe<Scalars['Int']['input']>;
  repliesFirst?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  topics?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  authorId?: InputMaybe<Scalars['Int']['input']>;
  communityId?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
  postStatus?: InputMaybe<EEntryStatus>;
  sort?: InputMaybe<EPostSorting>;
  shouldIncludeComments?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetFeedPostsQuery = { post?: { getFeedPosts?: { pageInfo: { endCursor?: string, hasNextPage: boolean }, edges?: Array<{ cursor: string, node?: { id: number, authorCommunityRole?: ECommunityRole, isNegative?: boolean, anonymousMode?: EPostAnonymousMode, commentCount?: number, communityId?: number, createdDate: Date, createdDateTime?: Date, feeling?: EPostFeeling, hasRelated?: boolean, message?: string, pinned: boolean, relateCount?: number, shareCount?: number, shareOption?: EShareOption, status?: EEntryStatus, tags?: Array<string>, topicId?: number, updatedDate: Date, community?: { id: number, key?: string, title: string, description: string, userConnection?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } }, poll?: { id: number, start?: Date, end?: Date, postId: number, title: string, items?: Array<{ id: number, title: string, votesCount: number, votes: Array<{ pollItemId: number, userId: number }> }>, userVote?: { pollItemId: number, userId: number } }, relate?: { id: number, type?: ERelateType, userId: number } | { id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } }, assets?: Array<{ postId?: number, assetId: string, contentType: string, fileName: string, presignedUrl?: string }>, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, comments?: { totalCount?: number, pageInfo: { endCursor?: string, hasNextPage: boolean, hasPreviousPage: boolean }, edges?: Array<{ cursor: string, node?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, comments?: { totalCount?: number, edges?: Array<{ cursor: string, node?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, comments?: { totalCount?: number, edges?: Array<{ cursor: string, node?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } }>, pageInfo: { endCursor?: string, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string } } } }>, pageInfo: { endCursor?: string, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string } } } }> }, taggedUsers?: Array<{ placeholder: string, user: { id: number, displayedName?: string, firstName?: string, lastName?: string, profileImage?: { presignedUrl?: string } } }>, topic?: { id: number, title: string, description?: string, postsCount?: number } } | { id: number, anonymousMode?: EPostAnonymousMode, commentCount?: number, communityId?: number, createdDate: Date, createdDateTime?: Date, feeling?: EPostFeeling, hasRelated?: boolean, message?: string, pinned: boolean, relateCount?: number, shareCount?: number, shareOption?: EShareOption, status?: EEntryStatus, tags?: Array<string>, topicId?: number, updatedDate: Date, originalPost?: { anonymousMode?: EPostAnonymousMode, commentCount?: number, communityId?: number, createdDate: Date, createdDateTime?: Date, feeling?: EPostFeeling, hasRelated?: boolean, message?: string, pinned: boolean, relateCount?: number, shareCount?: number, shareOption?: EShareOption, status?: EEntryStatus, tags?: Array<string>, topicId?: number, updatedDate: Date, id: number, authorCommunityRole?: ECommunityRole, isNegative?: boolean, assets?: Array<{ postId?: number, assetId: string, contentType: string, fileName: string, presignedUrl?: string }>, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, taggedUsers?: Array<{ placeholder: string, user: { id: number, displayedName?: string, firstName?: string, lastName?: string, profileImage?: { presignedUrl?: string } } }>, topic?: { id: number, title: string, description?: string, postsCount?: number }, community?: { id: number, key?: string, title: string, description: string, userConnection?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } }, poll?: { id: number, start?: Date, end?: Date, postId: number, title: string, items?: Array<{ id: number, title: string, votesCount: number, votes: Array<{ pollItemId: number, userId: number }> }>, userVote?: { pollItemId: number, userId: number } }, relate?: { id: number, type?: ERelateType, userId: number } | { id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } }, assets?: Array<{ postId?: number, assetId: string, contentType: string, fileName: string, presignedUrl?: string }>, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, comments?: { totalCount?: number, pageInfo: { endCursor?: string, hasNextPage: boolean, hasPreviousPage: boolean }, edges?: Array<{ cursor: string, node?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, comments?: { totalCount?: number, edges?: Array<{ cursor: string, node?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, comments?: { totalCount?: number, edges?: Array<{ cursor: string, node?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } }>, pageInfo: { endCursor?: string, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string } } } }>, pageInfo: { endCursor?: string, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string } } } }> }, taggedUsers?: Array<{ placeholder: string, user: { id: number, displayedName?: string, firstName?: string, lastName?: string, profileImage?: { presignedUrl?: string } } }>, topic?: { id: number, title: string, description?: string, postsCount?: number } } }> } } };

export type GetReportsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  communityId: Scalars['Int']['input'];
}>;


export type GetReportsQuery = { report?: { getReports?: { edges?: Array<{ cursor: string, node?: { commentId: number, id: number, message?: string, reporterId: number, type?: EReportType, viewed: boolean, comment?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } }, reporter?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } | { postId: number, id: number, message?: string, reporterId: number, type?: EReportType, viewed: boolean, post?: { id: number, authorCommunityRole?: ECommunityRole, isNegative?: boolean, pinned: boolean, community?: { id: number, key?: string, title: string, description: string, userConnection?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } }, poll?: { id: number, start?: Date, end?: Date, postId: number, title: string, items?: Array<{ id: number, title: string, votesCount: number, votes: Array<{ pollItemId: number, userId: number }> }>, userVote?: { pollItemId: number, userId: number } }, relate?: { id: number, type?: ERelateType, userId: number } | { id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } }, reporter?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } | { id: number, message?: string, reporterId: number, type?: EReportType, viewed: boolean, reporter?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } }>, pageInfo: { endCursor?: string, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string } } } };

export type GetSharedPostsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  postId: Scalars['Int']['input'];
}>;


export type GetSharedPostsQuery = { post?: { sharedPosts?: { pageInfo: { endCursor?: string, hasNextPage: boolean }, edges?: Array<{ cursor: string, node?: { id: number, authorCommunityRole?: ECommunityRole, isNegative?: boolean, anonymousMode?: EPostAnonymousMode, commentCount?: number, communityId?: number, createdDate: Date, createdDateTime?: Date, feeling?: EPostFeeling, hasRelated?: boolean, message?: string, pinned: boolean, relateCount?: number, shareCount?: number, shareOption?: EShareOption, status?: EEntryStatus, tags?: Array<string>, topicId?: number, updatedDate: Date, community?: { id: number, key?: string, title: string, description: string, userConnection?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } }, poll?: { id: number, start?: Date, end?: Date, postId: number, title: string, items?: Array<{ id: number, title: string, votesCount: number, votes: Array<{ pollItemId: number, userId: number }> }>, userVote?: { pollItemId: number, userId: number } }, relate?: { id: number, type?: ERelateType, userId: number } | { id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } }, assets?: Array<{ postId?: number, assetId: string, contentType: string, fileName: string, presignedUrl?: string }>, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, taggedUsers?: Array<{ placeholder: string, user: { id: number, displayedName?: string, firstName?: string, lastName?: string, profileImage?: { presignedUrl?: string } } }>, topic?: { id: number, title: string, description?: string, postsCount?: number } } | { id: number, anonymousMode?: EPostAnonymousMode, commentCount?: number, communityId?: number, createdDate: Date, createdDateTime?: Date, feeling?: EPostFeeling, hasRelated?: boolean, message?: string, pinned: boolean, relateCount?: number, shareCount?: number, shareOption?: EShareOption, status?: EEntryStatus, tags?: Array<string>, topicId?: number, updatedDate: Date, originalPost?: { anonymousMode?: EPostAnonymousMode, commentCount?: number, communityId?: number, createdDate: Date, createdDateTime?: Date, feeling?: EPostFeeling, hasRelated?: boolean, message?: string, pinned: boolean, relateCount?: number, shareCount?: number, shareOption?: EShareOption, status?: EEntryStatus, tags?: Array<string>, topicId?: number, updatedDate: Date, id: number, authorCommunityRole?: ECommunityRole, isNegative?: boolean, assets?: Array<{ postId?: number, assetId: string, contentType: string, fileName: string, presignedUrl?: string }>, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, taggedUsers?: Array<{ placeholder: string, user: { id: number, displayedName?: string, firstName?: string, lastName?: string, profileImage?: { presignedUrl?: string } } }>, topic?: { id: number, title: string, description?: string, postsCount?: number }, community?: { id: number, key?: string, title: string, description: string, userConnection?: { communityId: number, id: number, role?: ECommunityRole, status?: EConnectionStatus, userId: number } }, poll?: { id: number, start?: Date, end?: Date, postId: number, title: string, items?: Array<{ id: number, title: string, votesCount: number, votes: Array<{ pollItemId: number, userId: number }> }>, userVote?: { pollItemId: number, userId: number } }, relate?: { id: number, type?: ERelateType, userId: number } | { id: number, type?: ERelateType, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } }, assets?: Array<{ postId?: number, assetId: string, contentType: string, fileName: string, presignedUrl?: string }>, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } }, taggedUsers?: Array<{ placeholder: string, user: { id: number, displayedName?: string, firstName?: string, lastName?: string, profileImage?: { presignedUrl?: string } } }>, topic?: { id: number, title: string, description?: string, postsCount?: number } } }> } } };

export type GetSubCommentsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  commentId: Scalars['Int']['input'];
}>;


export type GetSubCommentsQuery = { comment?: { getSubComments?: { pageInfo: { endCursor?: string, hasNextPage: boolean }, edges?: Array<{ cursor: string, node?: { id: number, parentCommentId?: number, message?: string, authorId: number, createdDate: Date, createdDateTime?: Date, hasRelated?: boolean, postId?: number, isNegative: boolean, relateCount?: number, commentsCount?: number, updatedDate: Date, status?: EEntryStatus, author?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isOnline?: boolean, key?: string, latestInteraction?: Date, lastName?: string, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } }> } } };

export type GetTagsByCommunityQueryVariables = Exact<{
  communityId: Scalars['Int']['input'];
}>;


export type GetTagsByCommunityQuery = { community?: { tagsByCommunity?: Array<{ count?: number, key?: string }> } };

export type MarkWholeConversationReadMutationVariables = Exact<{
  senderId: Scalars['Int']['input'];
}>;


export type MarkWholeConversationReadMutation = { message?: { makeWholeConversationRead?: boolean } };

export type GetUnreadMessagesCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnreadMessagesCountQuery = { message?: { unreadMessagesCount?: number } };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { user?: { getUser?: { about?: string, displayedName?: string, email?: string, firstName?: string, hasInteracted?: boolean, id: number, isAnonymous?: boolean, isOnline?: boolean, isTermsAndConditionsAccepted?: boolean, key?: string, lastName?: string, settings?: Array<EUserSettings>, username?: string, activeCommunities?: { totalCount?: number, edges?: Array<{ node?: { categoryId?: number, description: string, id: number, privacy?: ECommunityPrivacy, status?: ECommunityStatus, title: string, userConnection?: { role?: ECommunityRole } } }> }, communityConnections?: { edges?: Array<{ node?: { communityId: number, id: number, role?: ECommunityRole } }> }, connections?: { totalCount?: number }, coverImage?: { presignedUrl?: string, id: string }, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } };

export type GetUserByKeyQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type GetUserByKeyQuery = { user?: { get?: { about?: string, displayedName?: string, email?: string, firstName?: string, hasInteracted?: boolean, id: number, isAnonymous?: boolean, isOnline?: boolean, isTermsAndConditionsAccepted?: boolean, key?: string, lastName?: string, settings?: Array<EUserSettings>, username?: string, activeCommunities?: { totalCount?: number, edges?: Array<{ node?: { id: number, title: string, userConnection?: { role?: ECommunityRole } } }> }, connections?: { totalCount?: number }, coverImage?: { assetId: string, contentType: string, fileName: string, fileSizeInBytes?: number, presignedUrl?: string, s3Key: string, uploaded?: string }, profileImage?: { assetId: string, contentType: string, fileName: string, fileSizeInBytes?: number, presignedUrl?: string, s3Key: string, uploaded?: string }, userConnection?: { connectionStatus?: EConnectionStatus } } } };

export type GetUserConnectionWithOtherUserQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  shouldIncludeUser?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUserConnectionWithOtherUserQuery = { userConnection?: { getUserConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number, user?: { displayedName?: string, firstName?: string, id: number, isAnonymous?: boolean, isTermsAndConditionsAccepted?: boolean, lastName?: string, connections?: { totalCount?: number }, activeCommunities?: { totalCount?: number } } } } };

export type GetUserConnectionsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<EConnectionStatus>> | InputMaybe<EConnectionStatus>>;
}>;


export type GetUserConnectionsQuery = { userConnection?: { getUserConnections?: { totalCount?: number, pageInfo: { endCursor?: string, hasNextPage: boolean }, edges?: Array<{ cursor: string, node?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number, user?: { displayedName?: string, firstName?: string, id: number, key?: string, isAnonymous?: boolean, isTermsAndConditionsAccepted?: boolean, lastName?: string, profileImage?: { presignedUrl?: string, id: string }, userConnection?: { connectionStatus?: EConnectionStatus, createdDate: Date, friendId: number, id: number, updatedDate: Date, userId: number } } } }> } } };

export type GetUserInformationQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type GetUserInformationQuery = { user?: { getUserInformation?: { about?: string, displayedName?: string, email?: string, firstName?: string, hasInteracted?: boolean, id: number, isAnonymous?: boolean, isOnline?: boolean, isTermsAndConditionsAccepted?: boolean, key?: string, lastName?: string, settings?: Array<EUserSettings>, username?: string, activeCommunities?: { totalCount?: number, edges?: Array<{ node?: { id: number, title: string, userConnection?: { role?: ECommunityRole } } }> }, connections?: { totalCount?: number }, coverImage?: { assetId: string, contentType: string, fileName: string, fileSizeInBytes?: number, presignedUrl?: string, s3Key: string, uploaded?: string }, profileImage?: { assetId: string, contentType: string, fileName: string, fileSizeInBytes?: number, presignedUrl?: string, s3Key: string, uploaded?: string }, userConnection?: { connectionStatus?: EConnectionStatus } } } };

export const UserBasicFragmentDoc = gql`
    fragment userBasic on UserGraphType {
  displayedName
  firstName
  id
  isAnonymous
  isOnline
  key
  latestInteraction
  lastName
  profileImage {
    id: assetId
    presignedUrl
  }
  userConnection {
    connectionStatus
    createdDate
    friendId
    id
    updatedDate
    userId
  }
}
    `;
export const UserVoteGraphFragmentDoc = gql`
    fragment userVoteGraph on VoteGraphType {
  pollItemId
  userId
}
    `;
export const PollFragmentDoc = gql`
    fragment poll on PollGraphType {
  id
  start
  end
  items {
    id
    title
    votes {
      pollItemId
      userId
    }
    votesCount
  }
  postId
  title
  userVote {
    ...userVoteGraph
  }
}
    ${UserVoteGraphFragmentDoc}`;
export const RelateOnPostFragmentDoc = gql`
    fragment relateOnPost on PostRelateGraphType {
  id
  type
  user {
    ...userBasic
  }
  userId
}
    ${UserBasicFragmentDoc}`;
export const PostFragmentDoc = gql`
    fragment post on PostGraphType {
  id
  authorCommunityRole
  community {
    id
    key
    title
    description
    userConnection {
      communityId
      id
      role
      status
      userId
    }
  }
  isNegative
  pinned
  poll {
    ...poll
  }
  relate {
    id
    type
    userId
    ...relateOnPost
  }
}
    ${PollFragmentDoc}
${RelateOnPostFragmentDoc}`;
export const ReportPostGraphTypeFragmentDoc = gql`
    fragment reportPostGraphType on ReportPostGraphType {
  id
  message
  reporterId
  reporter {
    ...userBasic
  }
  type
  viewed
  postId
  post {
    ...post
  }
}
    ${UserBasicFragmentDoc}
${PostFragmentDoc}`;
export const CommentGraphTypeFragmentDoc = gql`
    fragment commentGraphType on CommentGraphType {
  id
  parentCommentId
  message
  authorId
  author {
    ...userBasic
    communityConnections {
      edges {
        node {
          communityId
          id
          role
        }
      }
    }
  }
  createdDate
  createdDateTime
  hasRelated
  postId
  isNegative
  relateCount
  commentsCount
  updatedDate
  status
}
    ${UserBasicFragmentDoc}`;
export const ReportCommentGraphTypeFragmentDoc = gql`
    fragment reportCommentGraphType on ReportCommentGraphType {
  id
  message
  reporterId
  reporter {
    ...userBasic
  }
  type
  viewed
  commentId
  comment {
    ...commentGraphType
  }
}
    ${UserBasicFragmentDoc}
${CommentGraphTypeFragmentDoc}`;
export const ReportCommentFragmentFragmentDoc = gql`
    fragment reportCommentFragment on ReportCommentGraphType {
  id
  message
  reporterId
  reporter {
    ...userBasic
  }
  type
  viewed
  commentId
  comment {
    id
    parentCommentId
    message
    authorId
    author {
      ...userBasic
      communityConnections {
        edges {
          node {
            communityId
            id
            role
          }
        }
      }
    }
    createdDate
    createdDateTime
    hasRelated
    postId
    isNegative
    relateCount
    commentsCount
    updatedDate
    status
    ...commentGraphType
  }
}
    ${UserBasicFragmentDoc}
${CommentGraphTypeFragmentDoc}`;
export const PostInterfaceFragmentDoc = gql`
    fragment postInterface on PostInterfaceGraphType {
  id
  assets {
    postId
    assetId
    contentType
    fileName
    presignedUrl
    s3Key
  }
  author {
    id
    displayedName
    firstName
    lastName
    isAnonymous
  }
  commentCount
  createdDate
  createdDateTime
  feeling
  hasRelated
  message
  pinned
  relateCount
  shareCount
  shareOption
  status
  tags
  topic {
    id
    title
    description
    postsCount
  }
  updatedDate
  ...post
}
    ${PostFragmentDoc}`;
export const ReportPostFragmentFragmentDoc = gql`
    fragment reportPostFragment on ReportPostGraphType {
  id
  message
  reporterId
  reporter {
    ...userBasic
  }
  type
  viewed
  postId
  post {
    anonymousMode
    assets {
      postId
      assetId
      contentType
      fileName
      presignedUrl
    }
    author {
      ...userBasic
      communityConnections {
        edges {
          node {
            communityId
            id
            role
          }
        }
      }
    }
    commentCount
    communityId
    createdDate
    createdDateTime
    feeling
    hasRelated
    message
    pinned
    relateCount
    shareCount
    shareOption
    status
    tags
    taggedUsers {
      placeholder
      user {
        id
        displayedName
        firstName
        lastName
        profileImage {
          presignedUrl
        }
      }
    }
    topicId
    topic {
      id
      title
      description
      postsCount
    }
    ...post
  }
}
    ${UserBasicFragmentDoc}
${PostFragmentDoc}`;
export const PostShareGraphTypeFragmentDoc = gql`
    fragment postShareGraphType on PostShareGraphType {
  id
  originalPost {
    anonymousMode
    assets {
      postId
      assetId
      contentType
      fileName
      presignedUrl
    }
    author {
      ...userBasic
      communityConnections {
        edges {
          node {
            communityId
            id
            role
          }
        }
      }
    }
    commentCount
    communityId
    createdDate
    createdDateTime
    feeling
    hasRelated
    message
    pinned
    relateCount
    shareCount
    shareOption
    status
    tags
    taggedUsers {
      placeholder
      user {
        id
        displayedName
        firstName
        lastName
        profileImage {
          presignedUrl
        }
      }
    }
    topicId
    topic {
      id
      title
      description
      postsCount
    }
    updatedDate
    ...post
  }
}
    ${UserBasicFragmentDoc}
${PostFragmentDoc}`;
export const RelateOnCommentFragmentDoc = gql`
    fragment relateOnComment on CommentRelateGraphType {
  id
  commentId
  type
  user {
    ...userBasic
  }
  userId
}
    ${UserBasicFragmentDoc}`;
export const TopicFragmentDoc = gql`
    fragment topic on TopicGraphType {
  id
  title
  description
  postsCount
}
    `;
export const UserFragmentDoc = gql`
    fragment user on UserGraphType {
  about
  activeCommunities {
    edges {
      node {
        categoryId
        description
        id
        privacy
        status
        title
        userConnection {
          role
        }
      }
    }
    totalCount
  }
  communityConnections {
    edges {
      node {
        communityId
        id
        role
      }
    }
  }
  connections {
    totalCount
  }
  coverImage {
    id: assetId
    presignedUrl
  }
  displayedName
  email
  firstName
  hasInteracted
  id
  isAnonymous
  isOnline
  isTermsAndConditionsAccepted
  key
  lastName
  profileImage {
    id: assetId
    presignedUrl
  }
  settings
  username
  userConnection {
    connectionStatus
    createdDate
    friendId
    id
    updatedDate
    userId
  }
}
    `;
export const UserConnectionFragmentDoc = gql`
    fragment userConnection on ConnectionGraphType {
  connectionStatus
  createdDate
  friendId
  id
  updatedDate
  user {
    ...user
  }
  userId
}
    ${UserFragmentDoc}`;
export const BonoboAssetFragmentDoc = gql`
    fragment bonoboAsset on AssetGraphType {
  assetId
  contentType
  fileName
  fileSizeInBytes
  presignedUrl
  s3Key
  uploaded
}
    `;
export const UserDetailsFragmentDoc = gql`
    fragment userDetails on UserGraphType {
  about
  activeCommunities {
    totalCount
    edges {
      node {
        id
        userConnection {
          role
        }
        title
      }
    }
  }
  connections {
    totalCount
  }
  coverImage {
    ...bonoboAsset
  }
  displayedName
  email
  firstName
  hasInteracted
  id
  isAnonymous
  isOnline
  isTermsAndConditionsAccepted
  key
  lastName
  profileImage {
    ...bonoboAsset
  }
  settings
  userConnection {
    connectionStatus
  }
  username
}
    ${BonoboAssetFragmentDoc}`;
export const AcceptOrDeclineDocument = gql`
    mutation acceptOrDecline($inputType: UpdateCommunityConnectionStatusInputType!) {
  communityConnection {
    acceptOrDecline(inputType: $inputType) {
      communityId
      id
      role
      status
      userId
    }
  }
}
    `;
export type AcceptOrDeclineMutationFn = Apollo.MutationFunction<AcceptOrDeclineMutation, AcceptOrDeclineMutationVariables>;

/**
 * __useAcceptOrDeclineMutation__
 *
 * To run a mutation, you first call `useAcceptOrDeclineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptOrDeclineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptOrDeclineMutation, { data, loading, error }] = useAcceptOrDeclineMutation({
 *   variables: {
 *      inputType: // value for 'inputType'
 *   },
 * });
 */
export function useAcceptOrDeclineMutation(baseOptions?: Apollo.MutationHookOptions<AcceptOrDeclineMutation, AcceptOrDeclineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptOrDeclineMutation, AcceptOrDeclineMutationVariables>(AcceptOrDeclineDocument, options);
      }
export type AcceptOrDeclineMutationHookResult = ReturnType<typeof useAcceptOrDeclineMutation>;
export type AcceptOrDeclineMutationResult = Apollo.MutationResult<AcceptOrDeclineMutation>;
export type AcceptOrDeclineMutationOptions = Apollo.BaseMutationOptions<AcceptOrDeclineMutation, AcceptOrDeclineMutationVariables>;
export const AcceptOrDeclineUserConnectionDocument = gql`
    mutation acceptOrDeclineUserConnection($connectionId: Int!, $connectionStatus: EConnectionStatus!) {
  userConnection {
    acceptOrDecline(
      connectionId: $connectionId
      connectionStatus: $connectionStatus
    ) {
      connectionStatus
      createdDate
      friendId
      id
      updatedDate
      userId
      user {
        id
        key
        displayedName
        profileImage {
          presignedUrl
        }
      }
    }
  }
}
    `;
export type AcceptOrDeclineUserConnectionMutationFn = Apollo.MutationFunction<AcceptOrDeclineUserConnectionMutation, AcceptOrDeclineUserConnectionMutationVariables>;

/**
 * __useAcceptOrDeclineUserConnectionMutation__
 *
 * To run a mutation, you first call `useAcceptOrDeclineUserConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptOrDeclineUserConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptOrDeclineUserConnectionMutation, { data, loading, error }] = useAcceptOrDeclineUserConnectionMutation({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *      connectionStatus: // value for 'connectionStatus'
 *   },
 * });
 */
export function useAcceptOrDeclineUserConnectionMutation(baseOptions?: Apollo.MutationHookOptions<AcceptOrDeclineUserConnectionMutation, AcceptOrDeclineUserConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptOrDeclineUserConnectionMutation, AcceptOrDeclineUserConnectionMutationVariables>(AcceptOrDeclineUserConnectionDocument, options);
      }
export type AcceptOrDeclineUserConnectionMutationHookResult = ReturnType<typeof useAcceptOrDeclineUserConnectionMutation>;
export type AcceptOrDeclineUserConnectionMutationResult = Apollo.MutationResult<AcceptOrDeclineUserConnectionMutation>;
export type AcceptOrDeclineUserConnectionMutationOptions = Apollo.BaseMutationOptions<AcceptOrDeclineUserConnectionMutation, AcceptOrDeclineUserConnectionMutationVariables>;
export const AcceptTermsAndConditionsDocument = gql`
    mutation acceptTermsAndConditions {
  user {
    acceptTermsAndConditions
  }
}
    `;
export type AcceptTermsAndConditionsMutationFn = Apollo.MutationFunction<AcceptTermsAndConditionsMutation, AcceptTermsAndConditionsMutationVariables>;

/**
 * __useAcceptTermsAndConditionsMutation__
 *
 * To run a mutation, you first call `useAcceptTermsAndConditionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTermsAndConditionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTermsAndConditionsMutation, { data, loading, error }] = useAcceptTermsAndConditionsMutation({
 *   variables: {
 *   },
 * });
 */
export function useAcceptTermsAndConditionsMutation(baseOptions?: Apollo.MutationHookOptions<AcceptTermsAndConditionsMutation, AcceptTermsAndConditionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptTermsAndConditionsMutation, AcceptTermsAndConditionsMutationVariables>(AcceptTermsAndConditionsDocument, options);
      }
export type AcceptTermsAndConditionsMutationHookResult = ReturnType<typeof useAcceptTermsAndConditionsMutation>;
export type AcceptTermsAndConditionsMutationResult = Apollo.MutationResult<AcceptTermsAndConditionsMutation>;
export type AcceptTermsAndConditionsMutationOptions = Apollo.BaseMutationOptions<AcceptTermsAndConditionsMutation, AcceptTermsAndConditionsMutationVariables>;
export const CommentRelateDocument = gql`
    mutation commentRelate($commentId: Int!, $type: ERelateType!) {
  commentRelate {
    create(commentId: $commentId, type: $type)
  }
}
    `;
export type CommentRelateMutationFn = Apollo.MutationFunction<CommentRelateMutation, CommentRelateMutationVariables>;

/**
 * __useCommentRelateMutation__
 *
 * To run a mutation, you first call `useCommentRelateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommentRelateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commentRelateMutation, { data, loading, error }] = useCommentRelateMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCommentRelateMutation(baseOptions?: Apollo.MutationHookOptions<CommentRelateMutation, CommentRelateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommentRelateMutation, CommentRelateMutationVariables>(CommentRelateDocument, options);
      }
export type CommentRelateMutationHookResult = ReturnType<typeof useCommentRelateMutation>;
export type CommentRelateMutationResult = Apollo.MutationResult<CommentRelateMutation>;
export type CommentRelateMutationOptions = Apollo.BaseMutationOptions<CommentRelateMutation, CommentRelateMutationVariables>;
export const CreateAssetsForMultiplePostsDocument = gql`
    mutation createAssetsForMultiplePosts($type: EAssetType!, $fileName: String!, $contentType: String!, $alt: String, $fileSizeInBytes: Int!, $postIds: [Int]!, $shouldIncludeAsset: Boolean = false) {
  asset {
    createAssetsForMultiplePosts(
      asset: {type: $type, fileName: $fileName, contentType: $contentType, alt: $alt, fileSizeInBytes: $fileSizeInBytes}
      postIds: $postIds
    ) {
      signedUrl
      asset @include(if: $shouldIncludeAsset) {
        assetId
        contentType
        fileName
        fileSizeInBytes
        messId
        postId
        presignedUrl
        s3Key
        uploaded
      }
    }
  }
}
    `;
export type CreateAssetsForMultiplePostsMutationFn = Apollo.MutationFunction<CreateAssetsForMultiplePostsMutation, CreateAssetsForMultiplePostsMutationVariables>;

/**
 * __useCreateAssetsForMultiplePostsMutation__
 *
 * To run a mutation, you first call `useCreateAssetsForMultiplePostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetsForMultiplePostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssetsForMultiplePostsMutation, { data, loading, error }] = useCreateAssetsForMultiplePostsMutation({
 *   variables: {
 *      type: // value for 'type'
 *      fileName: // value for 'fileName'
 *      contentType: // value for 'contentType'
 *      alt: // value for 'alt'
 *      fileSizeInBytes: // value for 'fileSizeInBytes'
 *      postIds: // value for 'postIds'
 *      shouldIncludeAsset: // value for 'shouldIncludeAsset'
 *   },
 * });
 */
export function useCreateAssetsForMultiplePostsMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssetsForMultiplePostsMutation, CreateAssetsForMultiplePostsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssetsForMultiplePostsMutation, CreateAssetsForMultiplePostsMutationVariables>(CreateAssetsForMultiplePostsDocument, options);
      }
export type CreateAssetsForMultiplePostsMutationHookResult = ReturnType<typeof useCreateAssetsForMultiplePostsMutation>;
export type CreateAssetsForMultiplePostsMutationResult = Apollo.MutationResult<CreateAssetsForMultiplePostsMutation>;
export type CreateAssetsForMultiplePostsMutationOptions = Apollo.BaseMutationOptions<CreateAssetsForMultiplePostsMutation, CreateAssetsForMultiplePostsMutationVariables>;
export const CreateCommentDocument = gql`
    mutation createComment($request: CreateCommentInputType!) {
  comment {
    create(request: $request) {
      id
      author {
        displayedName
        firstName
        isOnline
        lastName
        profileImage {
          presignedUrl
        }
        communityConnections {
          edges {
            node {
              communityId
              id
              role
            }
          }
        }
      }
      comments {
        edges {
          node {
            id
            author {
              displayedName
              firstName
              lastName
              profileImage {
                presignedUrl
              }
            }
            createdDateTime
            message
          }
        }
      }
      createdDateTime
      message
      postId
    }
  }
}
    `;
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>;
export const CreateCommunityDocument = gql`
    mutation createCommunity($inputType: CreateCommunityInputType!) {
  community {
    create(inputType: $inputType) {
      categoryId
      description
      id
      privacy
      status
      title
    }
  }
}
    `;
export type CreateCommunityMutationFn = Apollo.MutationFunction<CreateCommunityMutation, CreateCommunityMutationVariables>;

/**
 * __useCreateCommunityMutation__
 *
 * To run a mutation, you first call `useCreateCommunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommunityMutation, { data, loading, error }] = useCreateCommunityMutation({
 *   variables: {
 *      inputType: // value for 'inputType'
 *   },
 * });
 */
export function useCreateCommunityMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommunityMutation, CreateCommunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommunityMutation, CreateCommunityMutationVariables>(CreateCommunityDocument, options);
      }
export type CreateCommunityMutationHookResult = ReturnType<typeof useCreateCommunityMutation>;
export type CreateCommunityMutationResult = Apollo.MutationResult<CreateCommunityMutation>;
export type CreateCommunityMutationOptions = Apollo.BaseMutationOptions<CreateCommunityMutation, CreateCommunityMutationVariables>;
export const CreateCommunityAssetDocument = gql`
    mutation createCommunityAsset($type: EAssetType!, $fileName: String!, $contentType: String!, $communityId: Int!, $alt: String, $fileSizeInBytes: Int!, $usage: ECommunityAssetUsage!, $shouldIncludeAsset: Boolean = false) {
  asset {
    createCommunityAsset(
      asset: {communityId: $communityId, type: $type, fileName: $fileName, contentType: $contentType, alt: $alt, fileSizeInBytes: $fileSizeInBytes, usage: $usage}
    ) {
      signedUrl
      asset @include(if: $shouldIncludeAsset) {
        assetId
        contentType
        fileName
        fileSizeInBytes
        presignedUrl
        s3Key
        uploaded
      }
    }
  }
}
    `;
export type CreateCommunityAssetMutationFn = Apollo.MutationFunction<CreateCommunityAssetMutation, CreateCommunityAssetMutationVariables>;

/**
 * __useCreateCommunityAssetMutation__
 *
 * To run a mutation, you first call `useCreateCommunityAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommunityAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommunityAssetMutation, { data, loading, error }] = useCreateCommunityAssetMutation({
 *   variables: {
 *      type: // value for 'type'
 *      fileName: // value for 'fileName'
 *      contentType: // value for 'contentType'
 *      communityId: // value for 'communityId'
 *      alt: // value for 'alt'
 *      fileSizeInBytes: // value for 'fileSizeInBytes'
 *      usage: // value for 'usage'
 *      shouldIncludeAsset: // value for 'shouldIncludeAsset'
 *   },
 * });
 */
export function useCreateCommunityAssetMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommunityAssetMutation, CreateCommunityAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommunityAssetMutation, CreateCommunityAssetMutationVariables>(CreateCommunityAssetDocument, options);
      }
export type CreateCommunityAssetMutationHookResult = ReturnType<typeof useCreateCommunityAssetMutation>;
export type CreateCommunityAssetMutationResult = Apollo.MutationResult<CreateCommunityAssetMutation>;
export type CreateCommunityAssetMutationOptions = Apollo.BaseMutationOptions<CreateCommunityAssetMutation, CreateCommunityAssetMutationVariables>;
export const CreateCommunityCategoryDocument = gql`
    mutation createCommunityCategory($inputType: CraeteCommunityCategoryInputType!) {
  communityCategory {
    create(inputType: $inputType) {
      id
      title
    }
  }
}
    `;
export type CreateCommunityCategoryMutationFn = Apollo.MutationFunction<CreateCommunityCategoryMutation, CreateCommunityCategoryMutationVariables>;

/**
 * __useCreateCommunityCategoryMutation__
 *
 * To run a mutation, you first call `useCreateCommunityCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommunityCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommunityCategoryMutation, { data, loading, error }] = useCreateCommunityCategoryMutation({
 *   variables: {
 *      inputType: // value for 'inputType'
 *   },
 * });
 */
export function useCreateCommunityCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommunityCategoryMutation, CreateCommunityCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommunityCategoryMutation, CreateCommunityCategoryMutationVariables>(CreateCommunityCategoryDocument, options);
      }
export type CreateCommunityCategoryMutationHookResult = ReturnType<typeof useCreateCommunityCategoryMutation>;
export type CreateCommunityCategoryMutationResult = Apollo.MutationResult<CreateCommunityCategoryMutation>;
export type CreateCommunityCategoryMutationOptions = Apollo.BaseMutationOptions<CreateCommunityCategoryMutation, CreateCommunityCategoryMutationVariables>;
export const CreateConversationDocument = gql`
    mutation createConversation($receiverId: Int!, $message: String!) {
  message {
    createConversation(receiverId: $receiverId, message: $message) {
      createdDate
      id
      isSeenByReceiver
      receiver {
        ...userBasic
      }
      sender {
        ...userBasic
      }
      status
      text
    }
  }
}
    ${UserBasicFragmentDoc}`;
export type CreateConversationMutationFn = Apollo.MutationFunction<CreateConversationMutation, CreateConversationMutationVariables>;

/**
 * __useCreateConversationMutation__
 *
 * To run a mutation, you first call `useCreateConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversationMutation, { data, loading, error }] = useCreateConversationMutation({
 *   variables: {
 *      receiverId: // value for 'receiverId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useCreateConversationMutation(baseOptions?: Apollo.MutationHookOptions<CreateConversationMutation, CreateConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConversationMutation, CreateConversationMutationVariables>(CreateConversationDocument, options);
      }
export type CreateConversationMutationHookResult = ReturnType<typeof useCreateConversationMutation>;
export type CreateConversationMutationResult = Apollo.MutationResult<CreateConversationMutation>;
export type CreateConversationMutationOptions = Apollo.BaseMutationOptions<CreateConversationMutation, CreateConversationMutationVariables>;
export const CreateConversationsDocument = gql`
    mutation createConversations($receivers: [Int]!, $message: String!) {
  message {
    createConversations(receivers: $receivers, message: $message)
  }
}
    `;
export type CreateConversationsMutationFn = Apollo.MutationFunction<CreateConversationsMutation, CreateConversationsMutationVariables>;

/**
 * __useCreateConversationsMutation__
 *
 * To run a mutation, you first call `useCreateConversationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversationsMutation, { data, loading, error }] = useCreateConversationsMutation({
 *   variables: {
 *      receivers: // value for 'receivers'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useCreateConversationsMutation(baseOptions?: Apollo.MutationHookOptions<CreateConversationsMutation, CreateConversationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConversationsMutation, CreateConversationsMutationVariables>(CreateConversationsDocument, options);
      }
export type CreateConversationsMutationHookResult = ReturnType<typeof useCreateConversationsMutation>;
export type CreateConversationsMutationResult = Apollo.MutationResult<CreateConversationsMutation>;
export type CreateConversationsMutationOptions = Apollo.BaseMutationOptions<CreateConversationsMutation, CreateConversationsMutationVariables>;
export const CreateFeedbackDocument = gql`
    mutation createFeedback($message: String!) {
  feedback {
    create(message: $message) {
      id
      message
      userId
    }
  }
}
    `;
export type CreateFeedbackMutationFn = Apollo.MutationFunction<CreateFeedbackMutation, CreateFeedbackMutationVariables>;

/**
 * __useCreateFeedbackMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackMutation, { data, loading, error }] = useCreateFeedbackMutation({
 *   variables: {
 *      message: // value for 'message'
 *   },
 * });
 */
export function useCreateFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeedbackMutation, CreateFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeedbackMutation, CreateFeedbackMutationVariables>(CreateFeedbackDocument, options);
      }
export type CreateFeedbackMutationHookResult = ReturnType<typeof useCreateFeedbackMutation>;
export type CreateFeedbackMutationResult = Apollo.MutationResult<CreateFeedbackMutation>;
export type CreateFeedbackMutationOptions = Apollo.BaseMutationOptions<CreateFeedbackMutation, CreateFeedbackMutationVariables>;
export const CreateMessageAssetDocument = gql`
    mutation createMessageAsset($type: EAssetType!, $fileName: String!, $contentType: String!, $messageId: Int!, $alt: String, $fileSizeInBytes: Int!, $shouldIncludeAsset: Boolean = false) {
  asset {
    createMessageAsset(
      asset: {messageId: $messageId, type: $type, fileName: $fileName, contentType: $contentType, alt: $alt, fileSizeInBytes: $fileSizeInBytes}
    ) {
      signedUrl
      asset @include(if: $shouldIncludeAsset) {
        assetId
        contentType
        fileName
        fileSizeInBytes
        messId
        postId
        presignedUrl
        s3Key
        uploaded
      }
    }
  }
}
    `;
export type CreateMessageAssetMutationFn = Apollo.MutationFunction<CreateMessageAssetMutation, CreateMessageAssetMutationVariables>;

/**
 * __useCreateMessageAssetMutation__
 *
 * To run a mutation, you first call `useCreateMessageAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageAssetMutation, { data, loading, error }] = useCreateMessageAssetMutation({
 *   variables: {
 *      type: // value for 'type'
 *      fileName: // value for 'fileName'
 *      contentType: // value for 'contentType'
 *      messageId: // value for 'messageId'
 *      alt: // value for 'alt'
 *      fileSizeInBytes: // value for 'fileSizeInBytes'
 *      shouldIncludeAsset: // value for 'shouldIncludeAsset'
 *   },
 * });
 */
export function useCreateMessageAssetMutation(baseOptions?: Apollo.MutationHookOptions<CreateMessageAssetMutation, CreateMessageAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMessageAssetMutation, CreateMessageAssetMutationVariables>(CreateMessageAssetDocument, options);
      }
export type CreateMessageAssetMutationHookResult = ReturnType<typeof useCreateMessageAssetMutation>;
export type CreateMessageAssetMutationResult = Apollo.MutationResult<CreateMessageAssetMutation>;
export type CreateMessageAssetMutationOptions = Apollo.BaseMutationOptions<CreateMessageAssetMutation, CreateMessageAssetMutationVariables>;
export const CreateMultiCommunityPostsDocument = gql`
    mutation createMultiCommunityPosts($request: CreatePostInputType!) {
  post {
    createMultiCommunityPosts(request: $request) {
      id
      communityId
    }
  }
}
    `;
export type CreateMultiCommunityPostsMutationFn = Apollo.MutationFunction<CreateMultiCommunityPostsMutation, CreateMultiCommunityPostsMutationVariables>;

/**
 * __useCreateMultiCommunityPostsMutation__
 *
 * To run a mutation, you first call `useCreateMultiCommunityPostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMultiCommunityPostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMultiCommunityPostsMutation, { data, loading, error }] = useCreateMultiCommunityPostsMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useCreateMultiCommunityPostsMutation(baseOptions?: Apollo.MutationHookOptions<CreateMultiCommunityPostsMutation, CreateMultiCommunityPostsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMultiCommunityPostsMutation, CreateMultiCommunityPostsMutationVariables>(CreateMultiCommunityPostsDocument, options);
      }
export type CreateMultiCommunityPostsMutationHookResult = ReturnType<typeof useCreateMultiCommunityPostsMutation>;
export type CreateMultiCommunityPostsMutationResult = Apollo.MutationResult<CreateMultiCommunityPostsMutation>;
export type CreateMultiCommunityPostsMutationOptions = Apollo.BaseMutationOptions<CreateMultiCommunityPostsMutation, CreateMultiCommunityPostsMutationVariables>;
export const CreatePollDocument = gql`
    mutation createPoll($postId: Int!, $title: String!, $items: [PollItemInputType]!, $start: DateTime, $end: DateTime) {
  poll {
    add(postId: $postId, title: $title, items: $items, start: $start, end: $end) {
      id
      title
    }
  }
}
    `;
export type CreatePollMutationFn = Apollo.MutationFunction<CreatePollMutation, CreatePollMutationVariables>;

/**
 * __useCreatePollMutation__
 *
 * To run a mutation, you first call `useCreatePollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPollMutation, { data, loading, error }] = useCreatePollMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      title: // value for 'title'
 *      items: // value for 'items'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useCreatePollMutation(baseOptions?: Apollo.MutationHookOptions<CreatePollMutation, CreatePollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePollMutation, CreatePollMutationVariables>(CreatePollDocument, options);
      }
export type CreatePollMutationHookResult = ReturnType<typeof useCreatePollMutation>;
export type CreatePollMutationResult = Apollo.MutationResult<CreatePollMutation>;
export type CreatePollMutationOptions = Apollo.BaseMutationOptions<CreatePollMutation, CreatePollMutationVariables>;
export const CreatePollToPostsDocument = gql`
    mutation createPollToPosts($postIds: [Int]!, $title: String!, $items: [PollItemInputType]!, $start: DateTime, $end: DateTime) {
  poll {
    addPollToPosts(
      postIds: $postIds
      title: $title
      items: $items
      start: $start
      end: $end
    ) {
      id
      title
    }
  }
}
    `;
export type CreatePollToPostsMutationFn = Apollo.MutationFunction<CreatePollToPostsMutation, CreatePollToPostsMutationVariables>;

/**
 * __useCreatePollToPostsMutation__
 *
 * To run a mutation, you first call `useCreatePollToPostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePollToPostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPollToPostsMutation, { data, loading, error }] = useCreatePollToPostsMutation({
 *   variables: {
 *      postIds: // value for 'postIds'
 *      title: // value for 'title'
 *      items: // value for 'items'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useCreatePollToPostsMutation(baseOptions?: Apollo.MutationHookOptions<CreatePollToPostsMutation, CreatePollToPostsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePollToPostsMutation, CreatePollToPostsMutationVariables>(CreatePollToPostsDocument, options);
      }
export type CreatePollToPostsMutationHookResult = ReturnType<typeof useCreatePollToPostsMutation>;
export type CreatePollToPostsMutationResult = Apollo.MutationResult<CreatePollToPostsMutation>;
export type CreatePollToPostsMutationOptions = Apollo.BaseMutationOptions<CreatePollToPostsMutation, CreatePollToPostsMutationVariables>;
export const CreatePostDocument = gql`
    mutation createPost($request: CreatePostInputType!) {
  post {
    create(request: $request) {
      ...postInterface
    }
  }
}
    ${PostInterfaceFragmentDoc}`;
export type CreatePostMutationFn = Apollo.MutationFunction<CreatePostMutation, CreatePostMutationVariables>;

/**
 * __useCreatePostMutation__
 *
 * To run a mutation, you first call `useCreatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostMutation, { data, loading, error }] = useCreatePostMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useCreatePostMutation(baseOptions?: Apollo.MutationHookOptions<CreatePostMutation, CreatePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePostMutation, CreatePostMutationVariables>(CreatePostDocument, options);
      }
export type CreatePostMutationHookResult = ReturnType<typeof useCreatePostMutation>;
export type CreatePostMutationResult = Apollo.MutationResult<CreatePostMutation>;
export type CreatePostMutationOptions = Apollo.BaseMutationOptions<CreatePostMutation, CreatePostMutationVariables>;
export const CreatePostAssetDocument = gql`
    mutation createPostAsset($type: EAssetType!, $fileName: String!, $contentType: String!, $alt: String, $fileSizeInBytes: Int!, $postId: Int!, $shouldIncludeAsset: Boolean = false) {
  asset {
    createPostAsset(
      asset: {type: $type, fileName: $fileName, contentType: $contentType, alt: $alt, fileSizeInBytes: $fileSizeInBytes, postId: $postId}
    ) {
      signedUrl
      asset @include(if: $shouldIncludeAsset) {
        assetId
        contentType
        fileName
        fileSizeInBytes
        messId
        postId
        presignedUrl
        s3Key
        uploaded
      }
    }
  }
}
    `;
export type CreatePostAssetMutationFn = Apollo.MutationFunction<CreatePostAssetMutation, CreatePostAssetMutationVariables>;

/**
 * __useCreatePostAssetMutation__
 *
 * To run a mutation, you first call `useCreatePostAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostAssetMutation, { data, loading, error }] = useCreatePostAssetMutation({
 *   variables: {
 *      type: // value for 'type'
 *      fileName: // value for 'fileName'
 *      contentType: // value for 'contentType'
 *      alt: // value for 'alt'
 *      fileSizeInBytes: // value for 'fileSizeInBytes'
 *      postId: // value for 'postId'
 *      shouldIncludeAsset: // value for 'shouldIncludeAsset'
 *   },
 * });
 */
export function useCreatePostAssetMutation(baseOptions?: Apollo.MutationHookOptions<CreatePostAssetMutation, CreatePostAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePostAssetMutation, CreatePostAssetMutationVariables>(CreatePostAssetDocument, options);
      }
export type CreatePostAssetMutationHookResult = ReturnType<typeof useCreatePostAssetMutation>;
export type CreatePostAssetMutationResult = Apollo.MutationResult<CreatePostAssetMutation>;
export type CreatePostAssetMutationOptions = Apollo.BaseMutationOptions<CreatePostAssetMutation, CreatePostAssetMutationVariables>;
export const CreatePostReportDocument = gql`
    mutation createPostReport($postId: Int!, $type: EReportType!) {
  report {
    create(postId: $postId, type: $type) {
      id
      post {
        anonymousMode
        assets {
          postId
          assetId
          contentType
          fileName
          presignedUrl
        }
        author {
          ...userBasic
          communityConnections {
            edges {
              node {
                communityId
                id
                role
              }
            }
          }
        }
        commentCount
        communityId
        createdDate
        createdDateTime
        feeling
        hasRelated
        message
        pinned
        relateCount
        shareCount
        shareOption
        status
        tags
        taggedUsers {
          placeholder
          user {
            id
            displayedName
            firstName
            lastName
            profileImage {
              presignedUrl
            }
          }
        }
        topicId
        topic {
          id
          title
          description
          postsCount
        }
        updatedDate
        ...post
      }
      reporter {
        ...userBasic
      }
    }
  }
}
    ${UserBasicFragmentDoc}
${PostFragmentDoc}`;
export type CreatePostReportMutationFn = Apollo.MutationFunction<CreatePostReportMutation, CreatePostReportMutationVariables>;

/**
 * __useCreatePostReportMutation__
 *
 * To run a mutation, you first call `useCreatePostReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostReportMutation, { data, loading, error }] = useCreatePostReportMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreatePostReportMutation(baseOptions?: Apollo.MutationHookOptions<CreatePostReportMutation, CreatePostReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePostReportMutation, CreatePostReportMutationVariables>(CreatePostReportDocument, options);
      }
export type CreatePostReportMutationHookResult = ReturnType<typeof useCreatePostReportMutation>;
export type CreatePostReportMutationResult = Apollo.MutationResult<CreatePostReportMutation>;
export type CreatePostReportMutationOptions = Apollo.BaseMutationOptions<CreatePostReportMutation, CreatePostReportMutationVariables>;
export const CreateSharePostDocument = gql`
    mutation createSharePost($request: CreateSharePostInptuType!) {
  post {
    sharePost(request: $request) {
      ...postShareGraphType
    }
  }
}
    ${PostShareGraphTypeFragmentDoc}`;
export type CreateSharePostMutationFn = Apollo.MutationFunction<CreateSharePostMutation, CreateSharePostMutationVariables>;

/**
 * __useCreateSharePostMutation__
 *
 * To run a mutation, you first call `useCreateSharePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSharePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSharePostMutation, { data, loading, error }] = useCreateSharePostMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useCreateSharePostMutation(baseOptions?: Apollo.MutationHookOptions<CreateSharePostMutation, CreateSharePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSharePostMutation, CreateSharePostMutationVariables>(CreateSharePostDocument, options);
      }
export type CreateSharePostMutationHookResult = ReturnType<typeof useCreateSharePostMutation>;
export type CreateSharePostMutationResult = Apollo.MutationResult<CreateSharePostMutation>;
export type CreateSharePostMutationOptions = Apollo.BaseMutationOptions<CreateSharePostMutation, CreateSharePostMutationVariables>;
export const CreateSubCommentDocument = gql`
    mutation createSubComment($request: CreateSubCommentInputType!) {
  comment {
    createSubComment(request: $request) {
      id
      author {
        displayedName
        firstName
        isOnline
        lastName
        profileImage {
          presignedUrl
        }
        communityConnections {
          edges {
            node {
              communityId
              role
            }
          }
        }
      }
      createdDateTime
      message
      parentCommentId
      postId
    }
  }
}
    `;
export type CreateSubCommentMutationFn = Apollo.MutationFunction<CreateSubCommentMutation, CreateSubCommentMutationVariables>;

/**
 * __useCreateSubCommentMutation__
 *
 * To run a mutation, you first call `useCreateSubCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubCommentMutation, { data, loading, error }] = useCreateSubCommentMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useCreateSubCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubCommentMutation, CreateSubCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubCommentMutation, CreateSubCommentMutationVariables>(CreateSubCommentDocument, options);
      }
export type CreateSubCommentMutationHookResult = ReturnType<typeof useCreateSubCommentMutation>;
export type CreateSubCommentMutationResult = Apollo.MutationResult<CreateSubCommentMutation>;
export type CreateSubCommentMutationOptions = Apollo.BaseMutationOptions<CreateSubCommentMutation, CreateSubCommentMutationVariables>;
export const CreateUserAssetDocument = gql`
    mutation createUserAsset($type: EAssetType!, $fileName: String!, $contentType: String!, $alt: String, $fileSizeInBytes: Int!, $shouldIncludeAsset: Boolean = false) {
  asset {
    createUserAsset(
      asset: {type: $type, fileName: $fileName, contentType: $contentType, alt: $alt, fileSizeInBytes: $fileSizeInBytes}
    ) {
      signedUrl
      asset @include(if: $shouldIncludeAsset) {
        assetId
        contentType
        fileName
        fileSizeInBytes
        presignedUrl
        s3Key
        uploaded
      }
    }
  }
}
    `;
export type CreateUserAssetMutationFn = Apollo.MutationFunction<CreateUserAssetMutation, CreateUserAssetMutationVariables>;

/**
 * __useCreateUserAssetMutation__
 *
 * To run a mutation, you first call `useCreateUserAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserAssetMutation, { data, loading, error }] = useCreateUserAssetMutation({
 *   variables: {
 *      type: // value for 'type'
 *      fileName: // value for 'fileName'
 *      contentType: // value for 'contentType'
 *      alt: // value for 'alt'
 *      fileSizeInBytes: // value for 'fileSizeInBytes'
 *      shouldIncludeAsset: // value for 'shouldIncludeAsset'
 *   },
 * });
 */
export function useCreateUserAssetMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserAssetMutation, CreateUserAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserAssetMutation, CreateUserAssetMutationVariables>(CreateUserAssetDocument, options);
      }
export type CreateUserAssetMutationHookResult = ReturnType<typeof useCreateUserAssetMutation>;
export type CreateUserAssetMutationResult = Apollo.MutationResult<CreateUserAssetMutation>;
export type CreateUserAssetMutationOptions = Apollo.BaseMutationOptions<CreateUserAssetMutation, CreateUserAssetMutationVariables>;
export const CreateUserConnectionDocument = gql`
    mutation createUserConnection($friendId: Int!) {
  userConnection {
    create(friendId: $friendId) {
      connectionStatus
      createdDate
      friendId
      updatedDate
      id
      userId
    }
  }
}
    `;
export type CreateUserConnectionMutationFn = Apollo.MutationFunction<CreateUserConnectionMutation, CreateUserConnectionMutationVariables>;

/**
 * __useCreateUserConnectionMutation__
 *
 * To run a mutation, you first call `useCreateUserConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserConnectionMutation, { data, loading, error }] = useCreateUserConnectionMutation({
 *   variables: {
 *      friendId: // value for 'friendId'
 *   },
 * });
 */
export function useCreateUserConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserConnectionMutation, CreateUserConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserConnectionMutation, CreateUserConnectionMutationVariables>(CreateUserConnectionDocument, options);
      }
export type CreateUserConnectionMutationHookResult = ReturnType<typeof useCreateUserConnectionMutation>;
export type CreateUserConnectionMutationResult = Apollo.MutationResult<CreateUserConnectionMutation>;
export type CreateUserConnectionMutationOptions = Apollo.BaseMutationOptions<CreateUserConnectionMutation, CreateUserConnectionMutationVariables>;
export const DeleteAssetDocument = gql`
    mutation deleteAsset($assetId: String!) {
  asset {
    deleteAsset(assetId: $assetId)
  }
}
    `;
export type DeleteAssetMutationFn = Apollo.MutationFunction<DeleteAssetMutation, DeleteAssetMutationVariables>;

/**
 * __useDeleteAssetMutation__
 *
 * To run a mutation, you first call `useDeleteAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssetMutation, { data, loading, error }] = useDeleteAssetMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useDeleteAssetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssetMutation, DeleteAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssetMutation, DeleteAssetMutationVariables>(DeleteAssetDocument, options);
      }
export type DeleteAssetMutationHookResult = ReturnType<typeof useDeleteAssetMutation>;
export type DeleteAssetMutationResult = Apollo.MutationResult<DeleteAssetMutation>;
export type DeleteAssetMutationOptions = Apollo.BaseMutationOptions<DeleteAssetMutation, DeleteAssetMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation deleteComment($commentId: Int!) {
  comment {
    delete(commentId: $commentId)
  }
}
    `;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const DeleteCommentRelateDocument = gql`
    mutation deleteCommentRelate($commentRelateId: Int!) {
  commentRelate {
    delete(commentRelateId: $commentRelateId)
  }
}
    `;
export type DeleteCommentRelateMutationFn = Apollo.MutationFunction<DeleteCommentRelateMutation, DeleteCommentRelateMutationVariables>;

/**
 * __useDeleteCommentRelateMutation__
 *
 * To run a mutation, you first call `useDeleteCommentRelateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentRelateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentRelateMutation, { data, loading, error }] = useDeleteCommentRelateMutation({
 *   variables: {
 *      commentRelateId: // value for 'commentRelateId'
 *   },
 * });
 */
export function useDeleteCommentRelateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentRelateMutation, DeleteCommentRelateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentRelateMutation, DeleteCommentRelateMutationVariables>(DeleteCommentRelateDocument, options);
      }
export type DeleteCommentRelateMutationHookResult = ReturnType<typeof useDeleteCommentRelateMutation>;
export type DeleteCommentRelateMutationResult = Apollo.MutationResult<DeleteCommentRelateMutation>;
export type DeleteCommentRelateMutationOptions = Apollo.BaseMutationOptions<DeleteCommentRelateMutation, DeleteCommentRelateMutationVariables>;
export const DeleteCommentRelateByCommentIdDocument = gql`
    mutation deleteCommentRelateByCommentId($commentId: Int!) {
  commentRelate {
    deletePerComment(commentId: $commentId)
  }
}
    `;
export type DeleteCommentRelateByCommentIdMutationFn = Apollo.MutationFunction<DeleteCommentRelateByCommentIdMutation, DeleteCommentRelateByCommentIdMutationVariables>;

/**
 * __useDeleteCommentRelateByCommentIdMutation__
 *
 * To run a mutation, you first call `useDeleteCommentRelateByCommentIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentRelateByCommentIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentRelateByCommentIdMutation, { data, loading, error }] = useDeleteCommentRelateByCommentIdMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useDeleteCommentRelateByCommentIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentRelateByCommentIdMutation, DeleteCommentRelateByCommentIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentRelateByCommentIdMutation, DeleteCommentRelateByCommentIdMutationVariables>(DeleteCommentRelateByCommentIdDocument, options);
      }
export type DeleteCommentRelateByCommentIdMutationHookResult = ReturnType<typeof useDeleteCommentRelateByCommentIdMutation>;
export type DeleteCommentRelateByCommentIdMutationResult = Apollo.MutationResult<DeleteCommentRelateByCommentIdMutation>;
export type DeleteCommentRelateByCommentIdMutationOptions = Apollo.BaseMutationOptions<DeleteCommentRelateByCommentIdMutation, DeleteCommentRelateByCommentIdMutationVariables>;
export const DeleteCommunityDocument = gql`
    mutation deleteCommunity($communityId: Int!) {
  community {
    delete(communityId: $communityId)
  }
}
    `;
export type DeleteCommunityMutationFn = Apollo.MutationFunction<DeleteCommunityMutation, DeleteCommunityMutationVariables>;

/**
 * __useDeleteCommunityMutation__
 *
 * To run a mutation, you first call `useDeleteCommunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommunityMutation, { data, loading, error }] = useDeleteCommunityMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useDeleteCommunityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommunityMutation, DeleteCommunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommunityMutation, DeleteCommunityMutationVariables>(DeleteCommunityDocument, options);
      }
export type DeleteCommunityMutationHookResult = ReturnType<typeof useDeleteCommunityMutation>;
export type DeleteCommunityMutationResult = Apollo.MutationResult<DeleteCommunityMutation>;
export type DeleteCommunityMutationOptions = Apollo.BaseMutationOptions<DeleteCommunityMutation, DeleteCommunityMutationVariables>;
export const DeleteConversationDocument = gql`
    mutation deleteConversation($messageId: Int!) {
  message {
    deleteConversation(messageId: $messageId)
  }
}
    `;
export type DeleteConversationMutationFn = Apollo.MutationFunction<DeleteConversationMutation, DeleteConversationMutationVariables>;

/**
 * __useDeleteConversationMutation__
 *
 * To run a mutation, you first call `useDeleteConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConversationMutation, { data, loading, error }] = useDeleteConversationMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useDeleteConversationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteConversationMutation, DeleteConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteConversationMutation, DeleteConversationMutationVariables>(DeleteConversationDocument, options);
      }
export type DeleteConversationMutationHookResult = ReturnType<typeof useDeleteConversationMutation>;
export type DeleteConversationMutationResult = Apollo.MutationResult<DeleteConversationMutation>;
export type DeleteConversationMutationOptions = Apollo.BaseMutationOptions<DeleteConversationMutation, DeleteConversationMutationVariables>;
export const DeletePollDocument = gql`
    mutation deletePoll($postId: Int!) {
  poll {
    delete(postId: $postId)
  }
}
    `;
export type DeletePollMutationFn = Apollo.MutationFunction<DeletePollMutation, DeletePollMutationVariables>;

/**
 * __useDeletePollMutation__
 *
 * To run a mutation, you first call `useDeletePollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePollMutation, { data, loading, error }] = useDeletePollMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useDeletePollMutation(baseOptions?: Apollo.MutationHookOptions<DeletePollMutation, DeletePollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePollMutation, DeletePollMutationVariables>(DeletePollDocument, options);
      }
export type DeletePollMutationHookResult = ReturnType<typeof useDeletePollMutation>;
export type DeletePollMutationResult = Apollo.MutationResult<DeletePollMutation>;
export type DeletePollMutationOptions = Apollo.BaseMutationOptions<DeletePollMutation, DeletePollMutationVariables>;
export const DeletePostDocument = gql`
    mutation deletePost($postId: Int!) {
  post {
    delete(postId: $postId)
  }
}
    `;
export type DeletePostMutationFn = Apollo.MutationFunction<DeletePostMutation, DeletePostMutationVariables>;

/**
 * __useDeletePostMutation__
 *
 * To run a mutation, you first call `useDeletePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostMutation, { data, loading, error }] = useDeletePostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useDeletePostMutation(baseOptions?: Apollo.MutationHookOptions<DeletePostMutation, DeletePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePostMutation, DeletePostMutationVariables>(DeletePostDocument, options);
      }
export type DeletePostMutationHookResult = ReturnType<typeof useDeletePostMutation>;
export type DeletePostMutationResult = Apollo.MutationResult<DeletePostMutation>;
export type DeletePostMutationOptions = Apollo.BaseMutationOptions<DeletePostMutation, DeletePostMutationVariables>;
export const DeleteRelatePostDocument = gql`
    mutation deleteRelatePost($postId: Int!) {
  postRelate {
    delete(postId: $postId)
  }
}
    `;
export type DeleteRelatePostMutationFn = Apollo.MutationFunction<DeleteRelatePostMutation, DeleteRelatePostMutationVariables>;

/**
 * __useDeleteRelatePostMutation__
 *
 * To run a mutation, you first call `useDeleteRelatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRelatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRelatePostMutation, { data, loading, error }] = useDeleteRelatePostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useDeleteRelatePostMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRelatePostMutation, DeleteRelatePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRelatePostMutation, DeleteRelatePostMutationVariables>(DeleteRelatePostDocument, options);
      }
export type DeleteRelatePostMutationHookResult = ReturnType<typeof useDeleteRelatePostMutation>;
export type DeleteRelatePostMutationResult = Apollo.MutationResult<DeleteRelatePostMutation>;
export type DeleteRelatePostMutationOptions = Apollo.BaseMutationOptions<DeleteRelatePostMutation, DeleteRelatePostMutationVariables>;
export const DeleteUserConnectionDocument = gql`
    mutation deleteUserConnection($connectionId: Int!) {
  userConnection {
    delete(connectionId: $connectionId) {
      connectionStatus
      createdDate
      id
      updatedDate
      userId
    }
  }
}
    `;
export type DeleteUserConnectionMutationFn = Apollo.MutationFunction<DeleteUserConnectionMutation, DeleteUserConnectionMutationVariables>;

/**
 * __useDeleteUserConnectionMutation__
 *
 * To run a mutation, you first call `useDeleteUserConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserConnectionMutation, { data, loading, error }] = useDeleteUserConnectionMutation({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useDeleteUserConnectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserConnectionMutation, DeleteUserConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserConnectionMutation, DeleteUserConnectionMutationVariables>(DeleteUserConnectionDocument, options);
      }
export type DeleteUserConnectionMutationHookResult = ReturnType<typeof useDeleteUserConnectionMutation>;
export type DeleteUserConnectionMutationResult = Apollo.MutationResult<DeleteUserConnectionMutation>;
export type DeleteUserConnectionMutationOptions = Apollo.BaseMutationOptions<DeleteUserConnectionMutation, DeleteUserConnectionMutationVariables>;
export const EnableAccountDocument = gql`
    mutation enableAccount($displayedName: String, $firstName: String!, $lastName: String!) {
  user {
    enableAccount(
      displayedName: $displayedName
      firstname: $firstName
      lastname: $lastName
    )
  }
}
    `;
export type EnableAccountMutationFn = Apollo.MutationFunction<EnableAccountMutation, EnableAccountMutationVariables>;

/**
 * __useEnableAccountMutation__
 *
 * To run a mutation, you first call `useEnableAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableAccountMutation, { data, loading, error }] = useEnableAccountMutation({
 *   variables: {
 *      displayedName: // value for 'displayedName'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useEnableAccountMutation(baseOptions?: Apollo.MutationHookOptions<EnableAccountMutation, EnableAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableAccountMutation, EnableAccountMutationVariables>(EnableAccountDocument, options);
      }
export type EnableAccountMutationHookResult = ReturnType<typeof useEnableAccountMutation>;
export type EnableAccountMutationResult = Apollo.MutationResult<EnableAccountMutation>;
export type EnableAccountMutationOptions = Apollo.BaseMutationOptions<EnableAccountMutation, EnableAccountMutationVariables>;
export const JoinCommunityDocument = gql`
    mutation joinCommunity($communityId: Int!) {
  communityConnection {
    joinCommunity(communityId: $communityId) {
      communityId
      id
      role
      status
    }
  }
}
    `;
export type JoinCommunityMutationFn = Apollo.MutationFunction<JoinCommunityMutation, JoinCommunityMutationVariables>;

/**
 * __useJoinCommunityMutation__
 *
 * To run a mutation, you first call `useJoinCommunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinCommunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinCommunityMutation, { data, loading, error }] = useJoinCommunityMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useJoinCommunityMutation(baseOptions?: Apollo.MutationHookOptions<JoinCommunityMutation, JoinCommunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinCommunityMutation, JoinCommunityMutationVariables>(JoinCommunityDocument, options);
      }
export type JoinCommunityMutationHookResult = ReturnType<typeof useJoinCommunityMutation>;
export type JoinCommunityMutationResult = Apollo.MutationResult<JoinCommunityMutation>;
export type JoinCommunityMutationOptions = Apollo.BaseMutationOptions<JoinCommunityMutation, JoinCommunityMutationVariables>;
export const JoinCommunityWithKeyDocument = gql`
    mutation joinCommunityWithKey($projectId: String!, $key: String!) {
  communityConnection {
    joinCommunityWithKey(key: $key, projectId: $projectId)
  }
}
    `;
export type JoinCommunityWithKeyMutationFn = Apollo.MutationFunction<JoinCommunityWithKeyMutation, JoinCommunityWithKeyMutationVariables>;

/**
 * __useJoinCommunityWithKeyMutation__
 *
 * To run a mutation, you first call `useJoinCommunityWithKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinCommunityWithKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinCommunityWithKeyMutation, { data, loading, error }] = useJoinCommunityWithKeyMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useJoinCommunityWithKeyMutation(baseOptions?: Apollo.MutationHookOptions<JoinCommunityWithKeyMutation, JoinCommunityWithKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinCommunityWithKeyMutation, JoinCommunityWithKeyMutationVariables>(JoinCommunityWithKeyDocument, options);
      }
export type JoinCommunityWithKeyMutationHookResult = ReturnType<typeof useJoinCommunityWithKeyMutation>;
export type JoinCommunityWithKeyMutationResult = Apollo.MutationResult<JoinCommunityWithKeyMutation>;
export type JoinCommunityWithKeyMutationOptions = Apollo.BaseMutationOptions<JoinCommunityWithKeyMutation, JoinCommunityWithKeyMutationVariables>;
export const LeaveCommunityDocument = gql`
    mutation leaveCommunity($connectionId: Int!) {
  communityConnection {
    leaveCommunity(connectionId: $connectionId)
  }
}
    `;
export type LeaveCommunityMutationFn = Apollo.MutationFunction<LeaveCommunityMutation, LeaveCommunityMutationVariables>;

/**
 * __useLeaveCommunityMutation__
 *
 * To run a mutation, you first call `useLeaveCommunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveCommunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveCommunityMutation, { data, loading, error }] = useLeaveCommunityMutation({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useLeaveCommunityMutation(baseOptions?: Apollo.MutationHookOptions<LeaveCommunityMutation, LeaveCommunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveCommunityMutation, LeaveCommunityMutationVariables>(LeaveCommunityDocument, options);
      }
export type LeaveCommunityMutationHookResult = ReturnType<typeof useLeaveCommunityMutation>;
export type LeaveCommunityMutationResult = Apollo.MutationResult<LeaveCommunityMutation>;
export type LeaveCommunityMutationOptions = Apollo.BaseMutationOptions<LeaveCommunityMutation, LeaveCommunityMutationVariables>;
export const MakeMessageReadByReceiverDocument = gql`
    mutation makeMessageReadByReceiver($messageId: Int!) {
  message {
    makeMessageReadByReceiver(messageId: $messageId)
  }
}
    `;
export type MakeMessageReadByReceiverMutationFn = Apollo.MutationFunction<MakeMessageReadByReceiverMutation, MakeMessageReadByReceiverMutationVariables>;

/**
 * __useMakeMessageReadByReceiverMutation__
 *
 * To run a mutation, you first call `useMakeMessageReadByReceiverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeMessageReadByReceiverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeMessageReadByReceiverMutation, { data, loading, error }] = useMakeMessageReadByReceiverMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useMakeMessageReadByReceiverMutation(baseOptions?: Apollo.MutationHookOptions<MakeMessageReadByReceiverMutation, MakeMessageReadByReceiverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeMessageReadByReceiverMutation, MakeMessageReadByReceiverMutationVariables>(MakeMessageReadByReceiverDocument, options);
      }
export type MakeMessageReadByReceiverMutationHookResult = ReturnType<typeof useMakeMessageReadByReceiverMutation>;
export type MakeMessageReadByReceiverMutationResult = Apollo.MutationResult<MakeMessageReadByReceiverMutation>;
export type MakeMessageReadByReceiverMutationOptions = Apollo.BaseMutationOptions<MakeMessageReadByReceiverMutation, MakeMessageReadByReceiverMutationVariables>;
export const MakeWholeConversationReadDocument = gql`
    mutation makeWholeConversationRead($senderId: Int!) {
  message {
    makeWholeConversationRead(senderId: $senderId)
  }
}
    `;
export type MakeWholeConversationReadMutationFn = Apollo.MutationFunction<MakeWholeConversationReadMutation, MakeWholeConversationReadMutationVariables>;

/**
 * __useMakeWholeConversationReadMutation__
 *
 * To run a mutation, you first call `useMakeWholeConversationReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeWholeConversationReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeWholeConversationReadMutation, { data, loading, error }] = useMakeWholeConversationReadMutation({
 *   variables: {
 *      senderId: // value for 'senderId'
 *   },
 * });
 */
export function useMakeWholeConversationReadMutation(baseOptions?: Apollo.MutationHookOptions<MakeWholeConversationReadMutation, MakeWholeConversationReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeWholeConversationReadMutation, MakeWholeConversationReadMutationVariables>(MakeWholeConversationReadDocument, options);
      }
export type MakeWholeConversationReadMutationHookResult = ReturnType<typeof useMakeWholeConversationReadMutation>;
export type MakeWholeConversationReadMutationResult = Apollo.MutationResult<MakeWholeConversationReadMutation>;
export type MakeWholeConversationReadMutationOptions = Apollo.BaseMutationOptions<MakeWholeConversationReadMutation, MakeWholeConversationReadMutationVariables>;
export const PostRelateDocument = gql`
    mutation postRelate($postId: Int!, $type: ERelateType!) {
  postRelate {
    create(postId: $postId, type: $type)
  }
}
    `;
export type PostRelateMutationFn = Apollo.MutationFunction<PostRelateMutation, PostRelateMutationVariables>;

/**
 * __usePostRelateMutation__
 *
 * To run a mutation, you first call `usePostRelateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostRelateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postRelateMutation, { data, loading, error }] = usePostRelateMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function usePostRelateMutation(baseOptions?: Apollo.MutationHookOptions<PostRelateMutation, PostRelateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostRelateMutation, PostRelateMutationVariables>(PostRelateDocument, options);
      }
export type PostRelateMutationHookResult = ReturnType<typeof usePostRelateMutation>;
export type PostRelateMutationResult = Apollo.MutationResult<PostRelateMutation>;
export type PostRelateMutationOptions = Apollo.BaseMutationOptions<PostRelateMutation, PostRelateMutationVariables>;
export const RemoveMemberByAuthorityDocument = gql`
    mutation removeMemberByAuthority($communityId: Int!, $connectionId: Int!, $memberId: Int!) {
  communityConnection {
    removeMemberByAuthority(
      communityId: $communityId
      connectionId: $connectionId
      memberId: $memberId
    )
  }
}
    `;
export type RemoveMemberByAuthorityMutationFn = Apollo.MutationFunction<RemoveMemberByAuthorityMutation, RemoveMemberByAuthorityMutationVariables>;

/**
 * __useRemoveMemberByAuthorityMutation__
 *
 * To run a mutation, you first call `useRemoveMemberByAuthorityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMemberByAuthorityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMemberByAuthorityMutation, { data, loading, error }] = useRemoveMemberByAuthorityMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      connectionId: // value for 'connectionId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useRemoveMemberByAuthorityMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMemberByAuthorityMutation, RemoveMemberByAuthorityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMemberByAuthorityMutation, RemoveMemberByAuthorityMutationVariables>(RemoveMemberByAuthorityDocument, options);
      }
export type RemoveMemberByAuthorityMutationHookResult = ReturnType<typeof useRemoveMemberByAuthorityMutation>;
export type RemoveMemberByAuthorityMutationResult = Apollo.MutationResult<RemoveMemberByAuthorityMutation>;
export type RemoveMemberByAuthorityMutationOptions = Apollo.BaseMutationOptions<RemoveMemberByAuthorityMutation, RemoveMemberByAuthorityMutationVariables>;
export const ReportCommentDocument = gql`
    mutation reportComment($commentId: Int!, $type: EReportType!, $message: String) {
  report {
    reportComment(commentId: $commentId, type: $type, message: $message) {
      id
      type
      message
    }
  }
}
    `;
export type ReportCommentMutationFn = Apollo.MutationFunction<ReportCommentMutation, ReportCommentMutationVariables>;

/**
 * __useReportCommentMutation__
 *
 * To run a mutation, you first call `useReportCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportCommentMutation, { data, loading, error }] = useReportCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      type: // value for 'type'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useReportCommentMutation(baseOptions?: Apollo.MutationHookOptions<ReportCommentMutation, ReportCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportCommentMutation, ReportCommentMutationVariables>(ReportCommentDocument, options);
      }
export type ReportCommentMutationHookResult = ReturnType<typeof useReportCommentMutation>;
export type ReportCommentMutationResult = Apollo.MutationResult<ReportCommentMutation>;
export type ReportCommentMutationOptions = Apollo.BaseMutationOptions<ReportCommentMutation, ReportCommentMutationVariables>;
export const ReportPostDocument = gql`
    mutation reportPost($postId: Int!, $type: EReportType!, $message: String) {
  report {
    reportPost(postId: $postId, type: $type, message: $message) {
      id
      type
      message
    }
  }
}
    `;
export type ReportPostMutationFn = Apollo.MutationFunction<ReportPostMutation, ReportPostMutationVariables>;

/**
 * __useReportPostMutation__
 *
 * To run a mutation, you first call `useReportPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportPostMutation, { data, loading, error }] = useReportPostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      type: // value for 'type'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useReportPostMutation(baseOptions?: Apollo.MutationHookOptions<ReportPostMutation, ReportPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportPostMutation, ReportPostMutationVariables>(ReportPostDocument, options);
      }
export type ReportPostMutationHookResult = ReturnType<typeof useReportPostMutation>;
export type ReportPostMutationResult = Apollo.MutationResult<ReportPostMutation>;
export type ReportPostMutationOptions = Apollo.BaseMutationOptions<ReportPostMutation, ReportPostMutationVariables>;
export const SetIsOnlineDocument = gql`
    mutation setIsOnline($isOnline: Boolean!) {
  user {
    setIsOnline(isOnline: $isOnline) {
      ...userBasic
    }
  }
}
    ${UserBasicFragmentDoc}`;
export type SetIsOnlineMutationFn = Apollo.MutationFunction<SetIsOnlineMutation, SetIsOnlineMutationVariables>;

/**
 * __useSetIsOnlineMutation__
 *
 * To run a mutation, you first call `useSetIsOnlineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIsOnlineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIsOnlineMutation, { data, loading, error }] = useSetIsOnlineMutation({
 *   variables: {
 *      isOnline: // value for 'isOnline'
 *   },
 * });
 */
export function useSetIsOnlineMutation(baseOptions?: Apollo.MutationHookOptions<SetIsOnlineMutation, SetIsOnlineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetIsOnlineMutation, SetIsOnlineMutationVariables>(SetIsOnlineDocument, options);
      }
export type SetIsOnlineMutationHookResult = ReturnType<typeof useSetIsOnlineMutation>;
export type SetIsOnlineMutationResult = Apollo.MutationResult<SetIsOnlineMutation>;
export type SetIsOnlineMutationOptions = Apollo.BaseMutationOptions<SetIsOnlineMutation, SetIsOnlineMutationVariables>;
export const SharePostDocument = gql`
    mutation sharePost($request: CreateSharePostInptuType!) {
  post {
    sharePost(request: $request) {
      id
    }
  }
}
    `;
export type SharePostMutationFn = Apollo.MutationFunction<SharePostMutation, SharePostMutationVariables>;

/**
 * __useSharePostMutation__
 *
 * To run a mutation, you first call `useSharePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSharePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sharePostMutation, { data, loading, error }] = useSharePostMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useSharePostMutation(baseOptions?: Apollo.MutationHookOptions<SharePostMutation, SharePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SharePostMutation, SharePostMutationVariables>(SharePostDocument, options);
      }
export type SharePostMutationHookResult = ReturnType<typeof useSharePostMutation>;
export type SharePostMutationResult = Apollo.MutationResult<SharePostMutation>;
export type SharePostMutationOptions = Apollo.BaseMutationOptions<SharePostMutation, SharePostMutationVariables>;
export const ToggleAlumniDocument = gql`
    mutation toggleAlumni($communityId: Int!, $isAlumni: Boolean!) {
  communityConnection {
    toggleAlumni(communityId: $communityId, isAlumni: $isAlumni)
  }
}
    `;
export type ToggleAlumniMutationFn = Apollo.MutationFunction<ToggleAlumniMutation, ToggleAlumniMutationVariables>;

/**
 * __useToggleAlumniMutation__
 *
 * To run a mutation, you first call `useToggleAlumniMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleAlumniMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleAlumniMutation, { data, loading, error }] = useToggleAlumniMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      isAlumni: // value for 'isAlumni'
 *   },
 * });
 */
export function useToggleAlumniMutation(baseOptions?: Apollo.MutationHookOptions<ToggleAlumniMutation, ToggleAlumniMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleAlumniMutation, ToggleAlumniMutationVariables>(ToggleAlumniDocument, options);
      }
export type ToggleAlumniMutationHookResult = ReturnType<typeof useToggleAlumniMutation>;
export type ToggleAlumniMutationResult = Apollo.MutationResult<ToggleAlumniMutation>;
export type ToggleAlumniMutationOptions = Apollo.BaseMutationOptions<ToggleAlumniMutation, ToggleAlumniMutationVariables>;
export const TogglePinnedPostDocument = gql`
    mutation togglePinnedPost($postId: Int!) {
  post {
    togglePinned(postId: $postId) {
      ...post
    }
  }
}
    ${PostFragmentDoc}`;
export type TogglePinnedPostMutationFn = Apollo.MutationFunction<TogglePinnedPostMutation, TogglePinnedPostMutationVariables>;

/**
 * __useTogglePinnedPostMutation__
 *
 * To run a mutation, you first call `useTogglePinnedPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTogglePinnedPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [togglePinnedPostMutation, { data, loading, error }] = useTogglePinnedPostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useTogglePinnedPostMutation(baseOptions?: Apollo.MutationHookOptions<TogglePinnedPostMutation, TogglePinnedPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TogglePinnedPostMutation, TogglePinnedPostMutationVariables>(TogglePinnedPostDocument, options);
      }
export type TogglePinnedPostMutationHookResult = ReturnType<typeof useTogglePinnedPostMutation>;
export type TogglePinnedPostMutationResult = Apollo.MutationResult<TogglePinnedPostMutation>;
export type TogglePinnedPostMutationOptions = Apollo.BaseMutationOptions<TogglePinnedPostMutation, TogglePinnedPostMutationVariables>;
export const TogglePostVisibilityDocument = gql`
    mutation togglePostVisibility($postId: Int!) {
  post {
    toggleVisibility(postId: $postId) {
      id
    }
  }
}
    `;
export type TogglePostVisibilityMutationFn = Apollo.MutationFunction<TogglePostVisibilityMutation, TogglePostVisibilityMutationVariables>;

/**
 * __useTogglePostVisibilityMutation__
 *
 * To run a mutation, you first call `useTogglePostVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTogglePostVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [togglePostVisibilityMutation, { data, loading, error }] = useTogglePostVisibilityMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useTogglePostVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<TogglePostVisibilityMutation, TogglePostVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TogglePostVisibilityMutation, TogglePostVisibilityMutationVariables>(TogglePostVisibilityDocument, options);
      }
export type TogglePostVisibilityMutationHookResult = ReturnType<typeof useTogglePostVisibilityMutation>;
export type TogglePostVisibilityMutationResult = Apollo.MutationResult<TogglePostVisibilityMutation>;
export type TogglePostVisibilityMutationOptions = Apollo.BaseMutationOptions<TogglePostVisibilityMutation, TogglePostVisibilityMutationVariables>;
export const UpdateCommentDocument = gql`
    mutation updateComment($request: UpdateCommentInputType!) {
  comment {
    update(request: $request) {
      id
    }
  }
}
    `;
export type UpdateCommentMutationFn = Apollo.MutationFunction<UpdateCommentMutation, UpdateCommentMutationVariables>;

/**
 * __useUpdateCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutation, { data, loading, error }] = useUpdateCommentMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useUpdateCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentMutation, UpdateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentMutation, UpdateCommentMutationVariables>(UpdateCommentDocument, options);
      }
export type UpdateCommentMutationHookResult = ReturnType<typeof useUpdateCommentMutation>;
export type UpdateCommentMutationResult = Apollo.MutationResult<UpdateCommentMutation>;
export type UpdateCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const UpdateCommentStatusDocument = gql`
    mutation UpdateCommentStatus($commentId: Int!, $status: EEntryStatus!) {
  comment {
    updateStatus(commentId: $commentId, status: $status)
  }
}
    `;
export type UpdateCommentStatusMutationFn = Apollo.MutationFunction<UpdateCommentStatusMutation, UpdateCommentStatusMutationVariables>;

/**
 * __useUpdateCommentStatusMutation__
 *
 * To run a mutation, you first call `useUpdateCommentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentStatusMutation, { data, loading, error }] = useUpdateCommentStatusMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateCommentStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentStatusMutation, UpdateCommentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentStatusMutation, UpdateCommentStatusMutationVariables>(UpdateCommentStatusDocument, options);
      }
export type UpdateCommentStatusMutationHookResult = ReturnType<typeof useUpdateCommentStatusMutation>;
export type UpdateCommentStatusMutationResult = Apollo.MutationResult<UpdateCommentStatusMutation>;
export type UpdateCommentStatusMutationOptions = Apollo.BaseMutationOptions<UpdateCommentStatusMutation, UpdateCommentStatusMutationVariables>;
export const UpdateCommunityDocument = gql`
    mutation updateCommunity($inputType: UpdateCommunityInputType!) {
  community {
    update(inputType: $inputType) {
      categoryId
      description
      id
      privacy
      status
      title
    }
  }
}
    `;
export type UpdateCommunityMutationFn = Apollo.MutationFunction<UpdateCommunityMutation, UpdateCommunityMutationVariables>;

/**
 * __useUpdateCommunityMutation__
 *
 * To run a mutation, you first call `useUpdateCommunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommunityMutation, { data, loading, error }] = useUpdateCommunityMutation({
 *   variables: {
 *      inputType: // value for 'inputType'
 *   },
 * });
 */
export function useUpdateCommunityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommunityMutation, UpdateCommunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommunityMutation, UpdateCommunityMutationVariables>(UpdateCommunityDocument, options);
      }
export type UpdateCommunityMutationHookResult = ReturnType<typeof useUpdateCommunityMutation>;
export type UpdateCommunityMutationResult = Apollo.MutationResult<UpdateCommunityMutation>;
export type UpdateCommunityMutationOptions = Apollo.BaseMutationOptions<UpdateCommunityMutation, UpdateCommunityMutationVariables>;
export const UpdateCommunityRoleDocument = gql`
    mutation updateCommunityRole($inputType: UpdateCommunityRuleInputType!) {
  communityConnection {
    updateCommunityRole(inputType: $inputType) {
      id
    }
  }
}
    `;
export type UpdateCommunityRoleMutationFn = Apollo.MutationFunction<UpdateCommunityRoleMutation, UpdateCommunityRoleMutationVariables>;

/**
 * __useUpdateCommunityRoleMutation__
 *
 * To run a mutation, you first call `useUpdateCommunityRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommunityRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommunityRoleMutation, { data, loading, error }] = useUpdateCommunityRoleMutation({
 *   variables: {
 *      inputType: // value for 'inputType'
 *   },
 * });
 */
export function useUpdateCommunityRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommunityRoleMutation, UpdateCommunityRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommunityRoleMutation, UpdateCommunityRoleMutationVariables>(UpdateCommunityRoleDocument, options);
      }
export type UpdateCommunityRoleMutationHookResult = ReturnType<typeof useUpdateCommunityRoleMutation>;
export type UpdateCommunityRoleMutationResult = Apollo.MutationResult<UpdateCommunityRoleMutation>;
export type UpdateCommunityRoleMutationOptions = Apollo.BaseMutationOptions<UpdateCommunityRoleMutation, UpdateCommunityRoleMutationVariables>;
export const UpdatePollDocument = gql`
    mutation updatePoll($postId: Int!, $title: String!, $items: [PollItemInputType]!) {
  poll {
    update(postId: $postId, title: $title, items: $items) {
      id
    }
  }
}
    `;
export type UpdatePollMutationFn = Apollo.MutationFunction<UpdatePollMutation, UpdatePollMutationVariables>;

/**
 * __useUpdatePollMutation__
 *
 * To run a mutation, you first call `useUpdatePollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePollMutation, { data, loading, error }] = useUpdatePollMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      title: // value for 'title'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useUpdatePollMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePollMutation, UpdatePollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePollMutation, UpdatePollMutationVariables>(UpdatePollDocument, options);
      }
export type UpdatePollMutationHookResult = ReturnType<typeof useUpdatePollMutation>;
export type UpdatePollMutationResult = Apollo.MutationResult<UpdatePollMutation>;
export type UpdatePollMutationOptions = Apollo.BaseMutationOptions<UpdatePollMutation, UpdatePollMutationVariables>;
export const UpdatePostDocument = gql`
    mutation updatePost($request: UpdatePostInputType!) {
  post {
    update(request: $request) {
      ...post
    }
  }
}
    ${PostFragmentDoc}`;
export type UpdatePostMutationFn = Apollo.MutationFunction<UpdatePostMutation, UpdatePostMutationVariables>;

/**
 * __useUpdatePostMutation__
 *
 * To run a mutation, you first call `useUpdatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostMutation, { data, loading, error }] = useUpdatePostMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useUpdatePostMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePostMutation, UpdatePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePostMutation, UpdatePostMutationVariables>(UpdatePostDocument, options);
      }
export type UpdatePostMutationHookResult = ReturnType<typeof useUpdatePostMutation>;
export type UpdatePostMutationResult = Apollo.MutationResult<UpdatePostMutation>;
export type UpdatePostMutationOptions = Apollo.BaseMutationOptions<UpdatePostMutation, UpdatePostMutationVariables>;
export const UpdatePostStatusDocument = gql`
    mutation UpdatePostStatus($postId: Int!, $status: EEntryStatus!) {
  post {
    updateStatus(postId: $postId, status: $status)
  }
}
    `;
export type UpdatePostStatusMutationFn = Apollo.MutationFunction<UpdatePostStatusMutation, UpdatePostStatusMutationVariables>;

/**
 * __useUpdatePostStatusMutation__
 *
 * To run a mutation, you first call `useUpdatePostStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostStatusMutation, { data, loading, error }] = useUpdatePostStatusMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdatePostStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePostStatusMutation, UpdatePostStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePostStatusMutation, UpdatePostStatusMutationVariables>(UpdatePostStatusDocument, options);
      }
export type UpdatePostStatusMutationHookResult = ReturnType<typeof useUpdatePostStatusMutation>;
export type UpdatePostStatusMutationResult = Apollo.MutationResult<UpdatePostStatusMutation>;
export type UpdatePostStatusMutationOptions = Apollo.BaseMutationOptions<UpdatePostStatusMutation, UpdatePostStatusMutationVariables>;
export const UpdateSettingsDocument = gql`
    mutation updateSettings($inputType: [EUserSettings]!) {
  user {
    updateSettings(inputType: $inputType) {
      id
      settings
    }
  }
}
    `;
export type UpdateSettingsMutationFn = Apollo.MutationFunction<UpdateSettingsMutation, UpdateSettingsMutationVariables>;

/**
 * __useUpdateSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSettingsMutation, { data, loading, error }] = useUpdateSettingsMutation({
 *   variables: {
 *      inputType: // value for 'inputType'
 *   },
 * });
 */
export function useUpdateSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSettingsMutation, UpdateSettingsMutationVariables>(UpdateSettingsDocument, options);
      }
export type UpdateSettingsMutationHookResult = ReturnType<typeof useUpdateSettingsMutation>;
export type UpdateSettingsMutationResult = Apollo.MutationResult<UpdateSettingsMutation>;
export type UpdateSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>;
export const UpdateUserAboutDocument = gql`
    mutation updateUserAbout($about: String!) {
  user {
    updateAbout(about: $about)
  }
}
    `;
export type UpdateUserAboutMutationFn = Apollo.MutationFunction<UpdateUserAboutMutation, UpdateUserAboutMutationVariables>;

/**
 * __useUpdateUserAboutMutation__
 *
 * To run a mutation, you first call `useUpdateUserAboutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAboutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAboutMutation, { data, loading, error }] = useUpdateUserAboutMutation({
 *   variables: {
 *      about: // value for 'about'
 *   },
 * });
 */
export function useUpdateUserAboutMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAboutMutation, UpdateUserAboutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAboutMutation, UpdateUserAboutMutationVariables>(UpdateUserAboutDocument, options);
      }
export type UpdateUserAboutMutationHookResult = ReturnType<typeof useUpdateUserAboutMutation>;
export type UpdateUserAboutMutationResult = Apollo.MutationResult<UpdateUserAboutMutation>;
export type UpdateUserAboutMutationOptions = Apollo.BaseMutationOptions<UpdateUserAboutMutation, UpdateUserAboutMutationVariables>;
export const UpdateUserImagesDocument = gql`
    mutation updateUserImages($profileImage: String, $coverImage: String) {
  user {
    updateUserImages(profileImage: $profileImage, coverImage: $coverImage)
  }
}
    `;
export type UpdateUserImagesMutationFn = Apollo.MutationFunction<UpdateUserImagesMutation, UpdateUserImagesMutationVariables>;

/**
 * __useUpdateUserImagesMutation__
 *
 * To run a mutation, you first call `useUpdateUserImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserImagesMutation, { data, loading, error }] = useUpdateUserImagesMutation({
 *   variables: {
 *      profileImage: // value for 'profileImage'
 *      coverImage: // value for 'coverImage'
 *   },
 * });
 */
export function useUpdateUserImagesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserImagesMutation, UpdateUserImagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserImagesMutation, UpdateUserImagesMutationVariables>(UpdateUserImagesDocument, options);
      }
export type UpdateUserImagesMutationHookResult = ReturnType<typeof useUpdateUserImagesMutation>;
export type UpdateUserImagesMutationResult = Apollo.MutationResult<UpdateUserImagesMutation>;
export type UpdateUserImagesMutationOptions = Apollo.BaseMutationOptions<UpdateUserImagesMutation, UpdateUserImagesMutationVariables>;
export const VoteAPollDocument = gql`
    mutation voteAPoll($pollId: Int!, $itemId: Int!) {
  poll {
    vote(pollId: $pollId, itemId: $itemId) {
      ...poll
    }
  }
}
    ${PollFragmentDoc}`;
export type VoteAPollMutationFn = Apollo.MutationFunction<VoteAPollMutation, VoteAPollMutationVariables>;

/**
 * __useVoteAPollMutation__
 *
 * To run a mutation, you first call `useVoteAPollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoteAPollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voteAPollMutation, { data, loading, error }] = useVoteAPollMutation({
 *   variables: {
 *      pollId: // value for 'pollId'
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useVoteAPollMutation(baseOptions?: Apollo.MutationHookOptions<VoteAPollMutation, VoteAPollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoteAPollMutation, VoteAPollMutationVariables>(VoteAPollDocument, options);
      }
export type VoteAPollMutationHookResult = ReturnType<typeof useVoteAPollMutation>;
export type VoteAPollMutationResult = Apollo.MutationResult<VoteAPollMutation>;
export type VoteAPollMutationOptions = Apollo.BaseMutationOptions<VoteAPollMutation, VoteAPollMutationVariables>;
export const GetAllPublicCommunitiesDocument = gql`
    query getAllPublicCommunities($after: String, $first: Int, $filter: String) {
  community {
    allPublic(after: $after, first: $first, filter: $filter) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          categoryId
          description
          id
          key
          title
          privacy
          profileImage {
            presignedUrl
          }
          userConnection {
            status
            user {
              activeCommunities {
                edges {
                  node {
                    id
                  }
                }
              }
            }
          }
        }
      }
      totalCount
    }
  }
}
    `;

/**
 * __useGetAllPublicCommunitiesQuery__
 *
 * To run a query within a React component, call `useGetAllPublicCommunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPublicCommunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPublicCommunitiesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAllPublicCommunitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPublicCommunitiesQuery, GetAllPublicCommunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPublicCommunitiesQuery, GetAllPublicCommunitiesQueryVariables>(GetAllPublicCommunitiesDocument, options);
      }
export function useGetAllPublicCommunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPublicCommunitiesQuery, GetAllPublicCommunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPublicCommunitiesQuery, GetAllPublicCommunitiesQueryVariables>(GetAllPublicCommunitiesDocument, options);
        }
export type GetAllPublicCommunitiesQueryHookResult = ReturnType<typeof useGetAllPublicCommunitiesQuery>;
export type GetAllPublicCommunitiesLazyQueryHookResult = ReturnType<typeof useGetAllPublicCommunitiesLazyQuery>;
export type GetAllPublicCommunitiesQueryResult = Apollo.QueryResult<GetAllPublicCommunitiesQuery, GetAllPublicCommunitiesQueryVariables>;
export const GetCommentRelatesDocument = gql`
    query getCommentRelates($after: String, $first: Int, $commentId: Int!) {
  commentRelate {
    get(after: $after, first: $first, commentId: $commentId) {
      totalCount
      edges {
        cursor
        node {
          commentId
          id
          type
          user {
            displayedName
            firstName
            id
            isAnonymous
            lastName
            userConnection {
              ...userConnection
            }
          }
          userId
        }
      }
    }
  }
}
    ${UserConnectionFragmentDoc}`;

/**
 * __useGetCommentRelatesQuery__
 *
 * To run a query within a React component, call `useGetCommentRelatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentRelatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentRelatesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useGetCommentRelatesQuery(baseOptions: Apollo.QueryHookOptions<GetCommentRelatesQuery, GetCommentRelatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommentRelatesQuery, GetCommentRelatesQueryVariables>(GetCommentRelatesDocument, options);
      }
export function useGetCommentRelatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommentRelatesQuery, GetCommentRelatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommentRelatesQuery, GetCommentRelatesQueryVariables>(GetCommentRelatesDocument, options);
        }
export type GetCommentRelatesQueryHookResult = ReturnType<typeof useGetCommentRelatesQuery>;
export type GetCommentRelatesLazyQueryHookResult = ReturnType<typeof useGetCommentRelatesLazyQuery>;
export type GetCommentRelatesQueryResult = Apollo.QueryResult<GetCommentRelatesQuery, GetCommentRelatesQueryVariables>;
export const GetCommentReportsDocument = gql`
    query getCommentReports($after: String, $first: Int, $communityId: Int!) {
  report {
    getCommentReports(after: $after, first: $first, communityId: $communityId) {
      edges {
        cursor
        node {
          id
          message
          reporterId
          reporter {
            ...userBasic
          }
          type
          viewed
          ...reportCommentFragment
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
}
    ${UserBasicFragmentDoc}
${ReportCommentFragmentFragmentDoc}`;

/**
 * __useGetCommentReportsQuery__
 *
 * To run a query within a React component, call `useGetCommentReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentReportsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useGetCommentReportsQuery(baseOptions: Apollo.QueryHookOptions<GetCommentReportsQuery, GetCommentReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommentReportsQuery, GetCommentReportsQueryVariables>(GetCommentReportsDocument, options);
      }
export function useGetCommentReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommentReportsQuery, GetCommentReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommentReportsQuery, GetCommentReportsQueryVariables>(GetCommentReportsDocument, options);
        }
export type GetCommentReportsQueryHookResult = ReturnType<typeof useGetCommentReportsQuery>;
export type GetCommentReportsLazyQueryHookResult = ReturnType<typeof useGetCommentReportsLazyQuery>;
export type GetCommentReportsQueryResult = Apollo.QueryResult<GetCommentReportsQuery, GetCommentReportsQueryVariables>;
export const GetCommentsDocument = gql`
    query getComments($after: String, $subCommentsAfter: String, $subSubCommentsAfter: String, $first: Int, $postId: Int, $commentStatus: EEntryStatus, $shouldIncludeSubComments: Boolean = true, $shouldIncludeSubSubComments: Boolean = true, $sort: ESorting = NEWEST_FIRST) {
  comment {
    getComments(
      after: $after
      first: $first
      postId: $postId
      commentStatus: $commentStatus
      sorting: $sort
    ) {
      edges {
        cursor
        node {
          ...commentGraphType
          comments(after: $subCommentsAfter, first: $first) @include(if: $shouldIncludeSubComments) {
            edges {
              cursor
              node {
                ...commentGraphType
                comments(after: $subSubCommentsAfter, first: $first) @include(if: $shouldIncludeSubSubComments) {
                  edges {
                    cursor
                    node {
                      ...commentGraphType
                    }
                  }
                  pageInfo {
                    endCursor
                    hasNextPage
                    hasPreviousPage
                    startCursor
                  }
                  totalCount
                }
              }
            }
            pageInfo {
              endCursor
              hasNextPage
              hasPreviousPage
              startCursor
            }
            totalCount
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
}
    ${CommentGraphTypeFragmentDoc}`;

/**
 * __useGetCommentsQuery__
 *
 * To run a query within a React component, call `useGetCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      subCommentsAfter: // value for 'subCommentsAfter'
 *      subSubCommentsAfter: // value for 'subSubCommentsAfter'
 *      first: // value for 'first'
 *      postId: // value for 'postId'
 *      commentStatus: // value for 'commentStatus'
 *      shouldIncludeSubComments: // value for 'shouldIncludeSubComments'
 *      shouldIncludeSubSubComments: // value for 'shouldIncludeSubSubComments'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCommentsQuery(baseOptions?: Apollo.QueryHookOptions<GetCommentsQuery, GetCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommentsQuery, GetCommentsQueryVariables>(GetCommentsDocument, options);
      }
export function useGetCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommentsQuery, GetCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommentsQuery, GetCommentsQueryVariables>(GetCommentsDocument, options);
        }
export type GetCommentsQueryHookResult = ReturnType<typeof useGetCommentsQuery>;
export type GetCommentsLazyQueryHookResult = ReturnType<typeof useGetCommentsLazyQuery>;
export type GetCommentsQueryResult = Apollo.QueryResult<GetCommentsQuery, GetCommentsQueryVariables>;
export const SearchByCategoryDocument = gql`
    query searchByCategory($after: String, $first: Int, $categoryId: Int!, $shouldIncludeUserConnection: Boolean = false) {
  community {
    searchByCategory(after: $after, first: $first, categoryId: $categoryId) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          bannerImage {
            presignedUrl
          }
          categoryId
          description
          id
          privacy
          profileImage {
            presignedUrl
          }
          status
          title
          userConnection @include(if: $shouldIncludeUserConnection) {
            communityId
            id
            role
            status
            userId
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchByCategoryQuery__
 *
 * To run a query within a React component, call `useSearchByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchByCategoryQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      categoryId: // value for 'categoryId'
 *      shouldIncludeUserConnection: // value for 'shouldIncludeUserConnection'
 *   },
 * });
 */
export function useSearchByCategoryQuery(baseOptions: Apollo.QueryHookOptions<SearchByCategoryQuery, SearchByCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchByCategoryQuery, SearchByCategoryQueryVariables>(SearchByCategoryDocument, options);
      }
export function useSearchByCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchByCategoryQuery, SearchByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchByCategoryQuery, SearchByCategoryQueryVariables>(SearchByCategoryDocument, options);
        }
export type SearchByCategoryQueryHookResult = ReturnType<typeof useSearchByCategoryQuery>;
export type SearchByCategoryLazyQueryHookResult = ReturnType<typeof useSearchByCategoryLazyQuery>;
export type SearchByCategoryQueryResult = Apollo.QueryResult<SearchByCategoryQuery, SearchByCategoryQueryVariables>;
export const GetCommunitiesByUserDocument = gql`
    query getCommunitiesByUser($after: String, $first: Int, $filter: String, $shouldIncludeCommunities: Boolean = false, $shouldIncludeProfileImage: Boolean = false, $shouldIncludeUserConnection: Boolean = false) {
  community {
    userCommunities(after: $after, first: $first, filter: $filter) {
      totalCount
      edges @include(if: $shouldIncludeCommunities) {
        cursor
        node {
          categoryId
          description
          id
          key
          privacy
          profileImage @include(if: $shouldIncludeProfileImage) {
            presignedUrl
          }
          status
          title
          userConnection @include(if: $shouldIncludeUserConnection) {
            communityId
            createdDate
            id
            role
            status
            userId
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCommunitiesByUserQuery__
 *
 * To run a query within a React component, call `useGetCommunitiesByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunitiesByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunitiesByUserQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *      shouldIncludeCommunities: // value for 'shouldIncludeCommunities'
 *      shouldIncludeProfileImage: // value for 'shouldIncludeProfileImage'
 *      shouldIncludeUserConnection: // value for 'shouldIncludeUserConnection'
 *   },
 * });
 */
export function useGetCommunitiesByUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCommunitiesByUserQuery, GetCommunitiesByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunitiesByUserQuery, GetCommunitiesByUserQueryVariables>(GetCommunitiesByUserDocument, options);
      }
export function useGetCommunitiesByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunitiesByUserQuery, GetCommunitiesByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunitiesByUserQuery, GetCommunitiesByUserQueryVariables>(GetCommunitiesByUserDocument, options);
        }
export type GetCommunitiesByUserQueryHookResult = ReturnType<typeof useGetCommunitiesByUserQuery>;
export type GetCommunitiesByUserLazyQueryHookResult = ReturnType<typeof useGetCommunitiesByUserLazyQuery>;
export type GetCommunitiesByUserQueryResult = Apollo.QueryResult<GetCommunitiesByUserQuery, GetCommunitiesByUserQueryVariables>;
export const GetCommunitiesOfUserDocument = gql`
    query getCommunitiesOfUser($userId: Int!, $status: EConnectionStatus, $shouldIncludeProfileImage: Boolean = false, $shouldIncludeUserConnection: Boolean = false) {
  communityConnection {
    ofUser(userId: $userId, status: $status) {
      community {
        categoryId
        description
        id
        key
        privacy
        profileImage @include(if: $shouldIncludeProfileImage) {
          presignedUrl
        }
        status
        title
        userConnection @include(if: $shouldIncludeUserConnection) {
          communityId
          createdDate
          id
          role
          status
          userId
        }
      }
    }
  }
}
    `;

/**
 * __useGetCommunitiesOfUserQuery__
 *
 * To run a query within a React component, call `useGetCommunitiesOfUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunitiesOfUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunitiesOfUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      status: // value for 'status'
 *      shouldIncludeProfileImage: // value for 'shouldIncludeProfileImage'
 *      shouldIncludeUserConnection: // value for 'shouldIncludeUserConnection'
 *   },
 * });
 */
export function useGetCommunitiesOfUserQuery(baseOptions: Apollo.QueryHookOptions<GetCommunitiesOfUserQuery, GetCommunitiesOfUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunitiesOfUserQuery, GetCommunitiesOfUserQueryVariables>(GetCommunitiesOfUserDocument, options);
      }
export function useGetCommunitiesOfUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunitiesOfUserQuery, GetCommunitiesOfUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunitiesOfUserQuery, GetCommunitiesOfUserQueryVariables>(GetCommunitiesOfUserDocument, options);
        }
export type GetCommunitiesOfUserQueryHookResult = ReturnType<typeof useGetCommunitiesOfUserQuery>;
export type GetCommunitiesOfUserLazyQueryHookResult = ReturnType<typeof useGetCommunitiesOfUserLazyQuery>;
export type GetCommunitiesOfUserQueryResult = Apollo.QueryResult<GetCommunitiesOfUserQuery, GetCommunitiesOfUserQueryVariables>;
export const GetCommunityDocument = gql`
    query getCommunity($communityId: Int, $key: String, $shouldIncludeUserConnection: Boolean = false) {
  community {
    get(communityId: $communityId, key: $key) {
      bannerImage {
        presignedUrl
      }
      categoryId
      description
      key
      id
      privacy
      profileImage {
        presignedUrl
      }
      status
      title
      userConnection @include(if: $shouldIncludeUserConnection) {
        communityId
        id
        role
        status
        userId
      }
    }
  }
}
    `;

/**
 * __useGetCommunityQuery__
 *
 * To run a query within a React component, call `useGetCommunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      key: // value for 'key'
 *      shouldIncludeUserConnection: // value for 'shouldIncludeUserConnection'
 *   },
 * });
 */
export function useGetCommunityQuery(baseOptions?: Apollo.QueryHookOptions<GetCommunityQuery, GetCommunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunityQuery, GetCommunityQueryVariables>(GetCommunityDocument, options);
      }
export function useGetCommunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunityQuery, GetCommunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunityQuery, GetCommunityQueryVariables>(GetCommunityDocument, options);
        }
export type GetCommunityQueryHookResult = ReturnType<typeof useGetCommunityQuery>;
export type GetCommunityLazyQueryHookResult = ReturnType<typeof useGetCommunityLazyQuery>;
export type GetCommunityQueryResult = Apollo.QueryResult<GetCommunityQuery, GetCommunityQueryVariables>;
export const GetCommunityCategoriesDocument = gql`
    query getCommunityCategories {
  communityCategory {
    getCommunityCategories {
      id
      title
    }
  }
}
    `;

/**
 * __useGetCommunityCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCommunityCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCommunityCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCommunityCategoriesQuery, GetCommunityCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunityCategoriesQuery, GetCommunityCategoriesQueryVariables>(GetCommunityCategoriesDocument, options);
      }
export function useGetCommunityCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunityCategoriesQuery, GetCommunityCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunityCategoriesQuery, GetCommunityCategoriesQueryVariables>(GetCommunityCategoriesDocument, options);
        }
export type GetCommunityCategoriesQueryHookResult = ReturnType<typeof useGetCommunityCategoriesQuery>;
export type GetCommunityCategoriesLazyQueryHookResult = ReturnType<typeof useGetCommunityCategoriesLazyQuery>;
export type GetCommunityCategoriesQueryResult = Apollo.QueryResult<GetCommunityCategoriesQuery, GetCommunityCategoriesQueryVariables>;
export const GetCommunityCommentsDocument = gql`
    query getCommunityComments($after: String, $first: Int, $communityId: Int!, $commentStatus: EEntryStatus) {
  comment {
    getCommunityComments(
      after: $after
      first: $first
      communityId: $communityId
      commentStatus: $commentStatus
    ) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          ...commentGraphType
        }
      }
    }
  }
}
    ${CommentGraphTypeFragmentDoc}`;

/**
 * __useGetCommunityCommentsQuery__
 *
 * To run a query within a React component, call `useGetCommunityCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityCommentsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      communityId: // value for 'communityId'
 *      commentStatus: // value for 'commentStatus'
 *   },
 * });
 */
export function useGetCommunityCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetCommunityCommentsQuery, GetCommunityCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunityCommentsQuery, GetCommunityCommentsQueryVariables>(GetCommunityCommentsDocument, options);
      }
export function useGetCommunityCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunityCommentsQuery, GetCommunityCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunityCommentsQuery, GetCommunityCommentsQueryVariables>(GetCommunityCommentsDocument, options);
        }
export type GetCommunityCommentsQueryHookResult = ReturnType<typeof useGetCommunityCommentsQuery>;
export type GetCommunityCommentsLazyQueryHookResult = ReturnType<typeof useGetCommunityCommentsLazyQuery>;
export type GetCommunityCommentsQueryResult = Apollo.QueryResult<GetCommunityCommentsQuery, GetCommunityCommentsQueryVariables>;
export const GetCommunityConnectionStatusDocument = gql`
    query getCommunityConnectionStatus($communityId: Int!) {
  communityConnection {
    connectionStatus(communityId: $communityId) {
      communityId
      id
      role
      status
      userId
    }
  }
}
    `;

/**
 * __useGetCommunityConnectionStatusQuery__
 *
 * To run a query within a React component, call `useGetCommunityConnectionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityConnectionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityConnectionStatusQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useGetCommunityConnectionStatusQuery(baseOptions: Apollo.QueryHookOptions<GetCommunityConnectionStatusQuery, GetCommunityConnectionStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunityConnectionStatusQuery, GetCommunityConnectionStatusQueryVariables>(GetCommunityConnectionStatusDocument, options);
      }
export function useGetCommunityConnectionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunityConnectionStatusQuery, GetCommunityConnectionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunityConnectionStatusQuery, GetCommunityConnectionStatusQueryVariables>(GetCommunityConnectionStatusDocument, options);
        }
export type GetCommunityConnectionStatusQueryHookResult = ReturnType<typeof useGetCommunityConnectionStatusQuery>;
export type GetCommunityConnectionStatusLazyQueryHookResult = ReturnType<typeof useGetCommunityConnectionStatusLazyQuery>;
export type GetCommunityConnectionStatusQueryResult = Apollo.QueryResult<GetCommunityConnectionStatusQuery, GetCommunityConnectionStatusQueryVariables>;
export const GetCommunityPostsDocument = gql`
    query getCommunityPosts($after: String, $first: Int, $communityId: Int!, $message: String, $shouldIncludeComments: Boolean = false) {
  post {
    getCommunityPosts(
      after: $after
      first: $first
      communityId: $communityId
      message: $message
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          anonymousMode
          assets {
            postId
            assetId
            contentType
            fileName
            presignedUrl
          }
          author {
            ...userBasic
            communityConnections {
              edges {
                node {
                  communityId
                  id
                  role
                }
              }
            }
          }
          commentCount
          communityId
          createdDate
          createdDateTime
          feeling
          hasRelated
          message
          pinned
          relateCount
          shareCount
          shareOption
          status
          tags
          taggedUsers {
            placeholder
            user {
              id
              displayedName
              firstName
              lastName
              profileImage {
                presignedUrl
              }
            }
          }
          topicId
          topic {
            id
            title
            description
            postsCount
          }
          updatedDate
          comments(after: $after, first: $first) @include(if: $shouldIncludeComments) {
            pageInfo {
              endCursor
              hasNextPage
              hasPreviousPage
            }
            edges {
              cursor
              node {
                ...commentGraphType
              }
            }
          }
          ...post
          ...postShareGraphType
        }
      }
    }
  }
}
    ${UserBasicFragmentDoc}
${CommentGraphTypeFragmentDoc}
${PostFragmentDoc}
${PostShareGraphTypeFragmentDoc}`;

/**
 * __useGetCommunityPostsQuery__
 *
 * To run a query within a React component, call `useGetCommunityPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityPostsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      communityId: // value for 'communityId'
 *      message: // value for 'message'
 *      shouldIncludeComments: // value for 'shouldIncludeComments'
 *   },
 * });
 */
export function useGetCommunityPostsQuery(baseOptions: Apollo.QueryHookOptions<GetCommunityPostsQuery, GetCommunityPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunityPostsQuery, GetCommunityPostsQueryVariables>(GetCommunityPostsDocument, options);
      }
export function useGetCommunityPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunityPostsQuery, GetCommunityPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunityPostsQuery, GetCommunityPostsQueryVariables>(GetCommunityPostsDocument, options);
        }
export type GetCommunityPostsQueryHookResult = ReturnType<typeof useGetCommunityPostsQuery>;
export type GetCommunityPostsLazyQueryHookResult = ReturnType<typeof useGetCommunityPostsLazyQuery>;
export type GetCommunityPostsQueryResult = Apollo.QueryResult<GetCommunityPostsQuery, GetCommunityPostsQueryVariables>;
export const GetCommunityUsersDocument = gql`
    query getCommunityUsers($after: String, $first: Int, $filter: String, $communityId: Int!, $searchPrivacy: [ESearchPrivacy], $status: [EConnectionStatus], $shouldIncludeUser: Boolean = false, $hasAcceptedTerms: Boolean = true) {
  communityConnection {
    users(
      after: $after
      first: $first
      filter: $filter
      communityId: $communityId
      searchPrivacy: $searchPrivacy
      status: $status
      hasAcceptedTerms: $hasAcceptedTerms
    ) {
      totalCount
      edges @include(if: $shouldIncludeUser) {
        cursor
        node {
          communityId
          id
          role
          status
          updatedDate
          userId
          user {
            ...userBasic
          }
        }
      }
    }
  }
}
    ${UserBasicFragmentDoc}`;

/**
 * __useGetCommunityUsersQuery__
 *
 * To run a query within a React component, call `useGetCommunityUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityUsersQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *      communityId: // value for 'communityId'
 *      searchPrivacy: // value for 'searchPrivacy'
 *      status: // value for 'status'
 *      shouldIncludeUser: // value for 'shouldIncludeUser'
 *      hasAcceptedTerms: // value for 'hasAcceptedTerms'
 *   },
 * });
 */
export function useGetCommunityUsersQuery(baseOptions: Apollo.QueryHookOptions<GetCommunityUsersQuery, GetCommunityUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommunityUsersQuery, GetCommunityUsersQueryVariables>(GetCommunityUsersDocument, options);
      }
export function useGetCommunityUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommunityUsersQuery, GetCommunityUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommunityUsersQuery, GetCommunityUsersQueryVariables>(GetCommunityUsersDocument, options);
        }
export type GetCommunityUsersQueryHookResult = ReturnType<typeof useGetCommunityUsersQuery>;
export type GetCommunityUsersLazyQueryHookResult = ReturnType<typeof useGetCommunityUsersLazyQuery>;
export type GetCommunityUsersQueryResult = Apollo.QueryResult<GetCommunityUsersQuery, GetCommunityUsersQueryVariables>;
export const GetConnectedUsersDocument = gql`
    query getConnectedUsers($after: String, $first: Int, $includeConnections: Boolean, $includeSharedCommunity: Boolean) {
  user {
    connectedUsers(
      after: $after
      first: $first
      includeConnections: $includeConnections
      includeSharedCommunity: $includeSharedCommunity
    ) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          activeCommunities {
            edges {
              node {
                id
              }
            }
          }
          displayedName
          firstName
          id
          isAnonymous
          isTermsAndConditionsAccepted
          key
          lastName
          profileImage {
            presignedUrl
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetConnectedUsersQuery__
 *
 * To run a query within a React component, call `useGetConnectedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectedUsersQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      includeConnections: // value for 'includeConnections'
 *      includeSharedCommunity: // value for 'includeSharedCommunity'
 *   },
 * });
 */
export function useGetConnectedUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetConnectedUsersQuery, GetConnectedUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectedUsersQuery, GetConnectedUsersQueryVariables>(GetConnectedUsersDocument, options);
      }
export function useGetConnectedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectedUsersQuery, GetConnectedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectedUsersQuery, GetConnectedUsersQueryVariables>(GetConnectedUsersDocument, options);
        }
export type GetConnectedUsersQueryHookResult = ReturnType<typeof useGetConnectedUsersQuery>;
export type GetConnectedUsersLazyQueryHookResult = ReturnType<typeof useGetConnectedUsersLazyQuery>;
export type GetConnectedUsersQueryResult = Apollo.QueryResult<GetConnectedUsersQuery, GetConnectedUsersQueryVariables>;
export const GetConnectionDocument = gql`
    query getConnection($connectionId: Int!) {
  userConnection {
    get(connectionId: $connectionId) {
      connectionStatus
      createdDate
      friendId
      id
      updatedDate
      userId
    }
  }
}
    `;

/**
 * __useGetConnectionQuery__
 *
 * To run a query within a React component, call `useGetConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectionQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useGetConnectionQuery(baseOptions: Apollo.QueryHookOptions<GetConnectionQuery, GetConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectionQuery, GetConnectionQueryVariables>(GetConnectionDocument, options);
      }
export function useGetConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectionQuery, GetConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectionQuery, GetConnectionQueryVariables>(GetConnectionDocument, options);
        }
export type GetConnectionQueryHookResult = ReturnType<typeof useGetConnectionQuery>;
export type GetConnectionLazyQueryHookResult = ReturnType<typeof useGetConnectionLazyQuery>;
export type GetConnectionQueryResult = Apollo.QueryResult<GetConnectionQuery, GetConnectionQueryVariables>;
export const GetConnectionPostsDocument = gql`
    query getConnectionPosts($after: String, $first: Int, $message: String, $tags: [String], $sort: EPostSorting, $shouldIncludeComments: Boolean = false) {
  post {
    connectionPosts(
      after: $after
      first: $first
      message: $message
      tags: $tags
      sort: $sort
    ) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          anonymousMode
          assets {
            postId
            assetId
            contentType
            fileName
            presignedUrl
          }
          author {
            ...userBasic
            communityConnections {
              edges {
                node {
                  communityId
                  id
                  role
                }
              }
            }
          }
          commentCount
          communityId
          createdDate
          createdDateTime
          feeling
          hasRelated
          message
          pinned
          relateCount
          shareCount
          shareOption
          status
          tags
          taggedUsers {
            placeholder
            user {
              id
              displayedName
              firstName
              lastName
              profileImage {
                presignedUrl
              }
            }
          }
          topicId
          topic {
            id
            title
            description
            postsCount
          }
          updatedDate
          comments(after: $after, first: $first) @include(if: $shouldIncludeComments) {
            pageInfo {
              endCursor
              hasNextPage
              hasPreviousPage
            }
            edges {
              cursor
              node {
                ...commentGraphType
              }
            }
          }
          ...post
          ...postShareGraphType
        }
      }
    }
  }
}
    ${UserBasicFragmentDoc}
${CommentGraphTypeFragmentDoc}
${PostFragmentDoc}
${PostShareGraphTypeFragmentDoc}`;

/**
 * __useGetConnectionPostsQuery__
 *
 * To run a query within a React component, call `useGetConnectionPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectionPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectionPostsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      message: // value for 'message'
 *      tags: // value for 'tags'
 *      sort: // value for 'sort'
 *      shouldIncludeComments: // value for 'shouldIncludeComments'
 *   },
 * });
 */
export function useGetConnectionPostsQuery(baseOptions?: Apollo.QueryHookOptions<GetConnectionPostsQuery, GetConnectionPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectionPostsQuery, GetConnectionPostsQueryVariables>(GetConnectionPostsDocument, options);
      }
export function useGetConnectionPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectionPostsQuery, GetConnectionPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectionPostsQuery, GetConnectionPostsQueryVariables>(GetConnectionPostsDocument, options);
        }
export type GetConnectionPostsQueryHookResult = ReturnType<typeof useGetConnectionPostsQuery>;
export type GetConnectionPostsLazyQueryHookResult = ReturnType<typeof useGetConnectionPostsLazyQuery>;
export type GetConnectionPostsQueryResult = Apollo.QueryResult<GetConnectionPostsQuery, GetConnectionPostsQueryVariables>;
export const GetConversationDocument = gql`
    query getConversation($after: String, $first: Int, $otherUserId: Int) {
  message {
    getConversation(
      after: $after
      first: $first
      otherUserId: $otherUserId
      sort: OLDEST_FIRST
    ) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          createdDate
          id
          isSeenByReceiver
          receiver {
            ...userBasic
          }
          sender {
            ...userBasic
          }
          status
          text
        }
      }
    }
  }
}
    ${UserBasicFragmentDoc}`;

/**
 * __useGetConversationQuery__
 *
 * To run a query within a React component, call `useGetConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      otherUserId: // value for 'otherUserId'
 *   },
 * });
 */
export function useGetConversationQuery(baseOptions?: Apollo.QueryHookOptions<GetConversationQuery, GetConversationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationQuery, GetConversationQueryVariables>(GetConversationDocument, options);
      }
export function useGetConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationQuery, GetConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationQuery, GetConversationQueryVariables>(GetConversationDocument, options);
        }
export type GetConversationQueryHookResult = ReturnType<typeof useGetConversationQuery>;
export type GetConversationLazyQueryHookResult = ReturnType<typeof useGetConversationLazyQuery>;
export type GetConversationQueryResult = Apollo.QueryResult<GetConversationQuery, GetConversationQueryVariables>;
export const GetConversationsDocument = gql`
    query getConversations($after: String, $first: Int) {
  message {
    getConversationList(after: $after, first: $first) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          lastMessage {
            id
            createdDate
            isSeenByReceiver
            status
            sender {
              ...userBasic
              __typename
            }
            text
          }
          receiver {
            ...userBasic
          }
          unReadCount
        }
      }
    }
  }
}
    ${UserBasicFragmentDoc}`;

/**
 * __useGetConversationsQuery__
 *
 * To run a query within a React component, call `useGetConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetConversationsQuery(baseOptions?: Apollo.QueryHookOptions<GetConversationsQuery, GetConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationsQuery, GetConversationsQueryVariables>(GetConversationsDocument, options);
      }
export function useGetConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationsQuery, GetConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationsQuery, GetConversationsQueryVariables>(GetConversationsDocument, options);
        }
export type GetConversationsQueryHookResult = ReturnType<typeof useGetConversationsQuery>;
export type GetConversationsLazyQueryHookResult = ReturnType<typeof useGetConversationsLazyQuery>;
export type GetConversationsQueryResult = Apollo.QueryResult<GetConversationsQuery, GetConversationsQueryVariables>;
export const GetEmbargoCommentsDocument = gql`
    query GetEmbargoComments($after: String, $first: Int, $communityId: Int!) {
  comment {
    embargoComments(after: $after, first: $first, communityId: $communityId) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          author {
            id
            displayedName
            profileImage {
              presignedUrl
            }
          }
          id
          message
          createdDate
        }
      }
    }
  }
}
    `;

/**
 * __useGetEmbargoCommentsQuery__
 *
 * To run a query within a React component, call `useGetEmbargoCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmbargoCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmbargoCommentsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useGetEmbargoCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetEmbargoCommentsQuery, GetEmbargoCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmbargoCommentsQuery, GetEmbargoCommentsQueryVariables>(GetEmbargoCommentsDocument, options);
      }
export function useGetEmbargoCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmbargoCommentsQuery, GetEmbargoCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmbargoCommentsQuery, GetEmbargoCommentsQueryVariables>(GetEmbargoCommentsDocument, options);
        }
export type GetEmbargoCommentsQueryHookResult = ReturnType<typeof useGetEmbargoCommentsQuery>;
export type GetEmbargoCommentsLazyQueryHookResult = ReturnType<typeof useGetEmbargoCommentsLazyQuery>;
export type GetEmbargoCommentsQueryResult = Apollo.QueryResult<GetEmbargoCommentsQuery, GetEmbargoCommentsQueryVariables>;
export const GetEmbargoPostsDocument = gql`
    query GetEmbargoPosts($communityId: Int!, $after: String, $first: Int!) {
  post {
    embargoPosts(after: $after, first: $first, communityId: $communityId) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          message
          createdDate
          topic {
            id
            title
          }
          author {
            id
            displayedName
            profileImage {
              presignedUrl
            }
          }
          status
        }
      }
    }
  }
}
    `;

/**
 * __useGetEmbargoPostsQuery__
 *
 * To run a query within a React component, call `useGetEmbargoPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmbargoPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmbargoPostsQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetEmbargoPostsQuery(baseOptions: Apollo.QueryHookOptions<GetEmbargoPostsQuery, GetEmbargoPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmbargoPostsQuery, GetEmbargoPostsQueryVariables>(GetEmbargoPostsDocument, options);
      }
export function useGetEmbargoPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmbargoPostsQuery, GetEmbargoPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmbargoPostsQuery, GetEmbargoPostsQueryVariables>(GetEmbargoPostsDocument, options);
        }
export type GetEmbargoPostsQueryHookResult = ReturnType<typeof useGetEmbargoPostsQuery>;
export type GetEmbargoPostsLazyQueryHookResult = ReturnType<typeof useGetEmbargoPostsLazyQuery>;
export type GetEmbargoPostsQueryResult = Apollo.QueryResult<GetEmbargoPostsQuery, GetEmbargoPostsQueryVariables>;
export const GetIsOnlineDocument = gql`
    query getIsOnline {
  user {
    getUser {
      id
      isOnline
    }
  }
}
    `;

/**
 * __useGetIsOnlineQuery__
 *
 * To run a query within a React component, call `useGetIsOnlineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsOnlineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsOnlineQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIsOnlineQuery(baseOptions?: Apollo.QueryHookOptions<GetIsOnlineQuery, GetIsOnlineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIsOnlineQuery, GetIsOnlineQueryVariables>(GetIsOnlineDocument, options);
      }
export function useGetIsOnlineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIsOnlineQuery, GetIsOnlineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIsOnlineQuery, GetIsOnlineQueryVariables>(GetIsOnlineDocument, options);
        }
export type GetIsOnlineQueryHookResult = ReturnType<typeof useGetIsOnlineQuery>;
export type GetIsOnlineLazyQueryHookResult = ReturnType<typeof useGetIsOnlineLazyQuery>;
export type GetIsOnlineQueryResult = Apollo.QueryResult<GetIsOnlineQuery, GetIsOnlineQueryVariables>;
export const GetModeratorsPostsDocument = gql`
    query getModeratorsPosts($after: String, $first: Int, $message: String, $tags: [String], $sort: EPostSorting, $shouldIncludeComments: Boolean = false) {
  post {
    moderatorsPosts(
      after: $after
      first: $first
      message: $message
      tags: $tags
      sort: $sort
    ) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          anonymousMode
          assets {
            postId
            assetId
            contentType
            fileName
            presignedUrl
          }
          author {
            ...userBasic
            communityConnections {
              edges {
                node {
                  communityId
                  id
                  role
                }
              }
            }
          }
          commentCount
          communityId
          createdDate
          createdDateTime
          feeling
          hasRelated
          message
          pinned
          relateCount
          shareCount
          shareOption
          status
          tags
          taggedUsers {
            placeholder
            user {
              id
              displayedName
              firstName
              lastName
              profileImage {
                presignedUrl
              }
            }
          }
          topicId
          topic {
            id
            title
            description
            postsCount
          }
          updatedDate
          comments(after: $after, first: $first) @include(if: $shouldIncludeComments) {
            pageInfo {
              endCursor
              hasNextPage
              hasPreviousPage
            }
            edges {
              cursor
              node {
                ...commentGraphType
              }
            }
          }
          ...post
          ...postShareGraphType
        }
      }
    }
  }
}
    ${UserBasicFragmentDoc}
${CommentGraphTypeFragmentDoc}
${PostFragmentDoc}
${PostShareGraphTypeFragmentDoc}`;

/**
 * __useGetModeratorsPostsQuery__
 *
 * To run a query within a React component, call `useGetModeratorsPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModeratorsPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModeratorsPostsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      message: // value for 'message'
 *      tags: // value for 'tags'
 *      sort: // value for 'sort'
 *      shouldIncludeComments: // value for 'shouldIncludeComments'
 *   },
 * });
 */
export function useGetModeratorsPostsQuery(baseOptions?: Apollo.QueryHookOptions<GetModeratorsPostsQuery, GetModeratorsPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModeratorsPostsQuery, GetModeratorsPostsQueryVariables>(GetModeratorsPostsDocument, options);
      }
export function useGetModeratorsPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModeratorsPostsQuery, GetModeratorsPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModeratorsPostsQuery, GetModeratorsPostsQueryVariables>(GetModeratorsPostsDocument, options);
        }
export type GetModeratorsPostsQueryHookResult = ReturnType<typeof useGetModeratorsPostsQuery>;
export type GetModeratorsPostsLazyQueryHookResult = ReturnType<typeof useGetModeratorsPostsLazyQuery>;
export type GetModeratorsPostsQueryResult = Apollo.QueryResult<GetModeratorsPostsQuery, GetModeratorsPostsQueryVariables>;
export const GetPossibleConnectionsDocument = gql`
    query getPossibleConnections($after: String, $first: Int) {
  user {
    possibleConnections(after: $after, first: $first) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          displayedName
          firstName
          id
          isAnonymous
          lastName
          username
          profileImage {
            presignedUrl
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPossibleConnectionsQuery__
 *
 * To run a query within a React component, call `useGetPossibleConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPossibleConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPossibleConnectionsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetPossibleConnectionsQuery(baseOptions?: Apollo.QueryHookOptions<GetPossibleConnectionsQuery, GetPossibleConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPossibleConnectionsQuery, GetPossibleConnectionsQueryVariables>(GetPossibleConnectionsDocument, options);
      }
export function useGetPossibleConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPossibleConnectionsQuery, GetPossibleConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPossibleConnectionsQuery, GetPossibleConnectionsQueryVariables>(GetPossibleConnectionsDocument, options);
        }
export type GetPossibleConnectionsQueryHookResult = ReturnType<typeof useGetPossibleConnectionsQuery>;
export type GetPossibleConnectionsLazyQueryHookResult = ReturnType<typeof useGetPossibleConnectionsLazyQuery>;
export type GetPossibleConnectionsQueryResult = Apollo.QueryResult<GetPossibleConnectionsQuery, GetPossibleConnectionsQueryVariables>;
export const GetPostDocument = gql`
    query getPost($postId: Int!) {
  post {
    getPost(postId: $postId) {
      anonymousMode
      assets {
        postId
        assetId
        contentType
        fileName
        presignedUrl
      }
      author {
        ...userBasic
        communityConnections {
          edges {
            node {
              communityId
              id
              role
            }
          }
        }
      }
      comments {
        pageInfo {
          endCursor
          hasNextPage
          hasPreviousPage
        }
        totalCount
        edges {
          cursor
          node {
            ...commentGraphType
            comments {
              pageInfo {
                endCursor
                hasNextPage
                hasPreviousPage
                startCursor
              }
              totalCount
              edges {
                cursor
                node {
                  ...commentGraphType
                  comments {
                    pageInfo {
                      endCursor
                      hasNextPage
                      hasPreviousPage
                      startCursor
                    }
                    totalCount
                    edges {
                      cursor
                      node {
                        ...commentGraphType
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      commentCount
      communityId
      createdDate
      createdDateTime
      feeling
      hasRelated
      message
      pinned
      relateCount
      shareCount
      shareOption
      status
      tags
      taggedUsers {
        placeholder
        user {
          id
          displayedName
          firstName
          lastName
          profileImage {
            presignedUrl
          }
        }
      }
      topicId
      topic {
        id
        title
        description
        postsCount
      }
      updatedDate
      ...post
      ...postShareGraphType
    }
  }
}
    ${UserBasicFragmentDoc}
${CommentGraphTypeFragmentDoc}
${PostFragmentDoc}
${PostShareGraphTypeFragmentDoc}`;

/**
 * __useGetPostQuery__
 *
 * To run a query within a React component, call `useGetPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetPostQuery(baseOptions: Apollo.QueryHookOptions<GetPostQuery, GetPostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostQuery, GetPostQueryVariables>(GetPostDocument, options);
      }
export function useGetPostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostQuery, GetPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostQuery, GetPostQueryVariables>(GetPostDocument, options);
        }
export type GetPostQueryHookResult = ReturnType<typeof useGetPostQuery>;
export type GetPostLazyQueryHookResult = ReturnType<typeof useGetPostLazyQuery>;
export type GetPostQueryResult = Apollo.QueryResult<GetPostQuery, GetPostQueryVariables>;
export const GetPostRelatesDocument = gql`
    query getPostRelates($after: String, $first: Int, $postId: Int!) {
  postRelate {
    get(after: $after, first: $first, postId: $postId) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          postId
          id
          type
          user {
            displayedName
            firstName
            email
            id
            isAnonymous
            lastName
            profileImage {
              ...bonoboAsset
            }
            userConnection {
              ...userConnection
            }
          }
          userId
        }
      }
    }
  }
}
    ${BonoboAssetFragmentDoc}
${UserConnectionFragmentDoc}`;

/**
 * __useGetPostRelatesQuery__
 *
 * To run a query within a React component, call `useGetPostRelatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostRelatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostRelatesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetPostRelatesQuery(baseOptions: Apollo.QueryHookOptions<GetPostRelatesQuery, GetPostRelatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostRelatesQuery, GetPostRelatesQueryVariables>(GetPostRelatesDocument, options);
      }
export function useGetPostRelatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostRelatesQuery, GetPostRelatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostRelatesQuery, GetPostRelatesQueryVariables>(GetPostRelatesDocument, options);
        }
export type GetPostRelatesQueryHookResult = ReturnType<typeof useGetPostRelatesQuery>;
export type GetPostRelatesLazyQueryHookResult = ReturnType<typeof useGetPostRelatesLazyQuery>;
export type GetPostRelatesQueryResult = Apollo.QueryResult<GetPostRelatesQuery, GetPostRelatesQueryVariables>;
export const GetPostReportsDocument = gql`
    query getPostReports($after: String, $first: Int, $communityId: Int!) {
  report {
    getPostReports(after: $after, first: $first, communityId: $communityId) {
      edges {
        cursor
        node {
          id
          message
          reporterId
          reporter {
            ...userBasic
          }
          type
          viewed
          ...reportPostFragment
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
}
    ${UserBasicFragmentDoc}
${ReportPostFragmentFragmentDoc}`;

/**
 * __useGetPostReportsQuery__
 *
 * To run a query within a React component, call `useGetPostReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostReportsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useGetPostReportsQuery(baseOptions: Apollo.QueryHookOptions<GetPostReportsQuery, GetPostReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostReportsQuery, GetPostReportsQueryVariables>(GetPostReportsDocument, options);
      }
export function useGetPostReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostReportsQuery, GetPostReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostReportsQuery, GetPostReportsQueryVariables>(GetPostReportsDocument, options);
        }
export type GetPostReportsQueryHookResult = ReturnType<typeof useGetPostReportsQuery>;
export type GetPostReportsLazyQueryHookResult = ReturnType<typeof useGetPostReportsLazyQuery>;
export type GetPostReportsQueryResult = Apollo.QueryResult<GetPostReportsQuery, GetPostReportsQueryVariables>;
export const GetFeedPostsDocument = gql`
    query getFeedPosts($after: String, $first: Int, $commentsAfter: String, $commentsFirst: Int, $repliesFirst: Int, $message: String, $tags: [String], $topics: [Int], $authorId: Int, $communityId: Int, $from: Date, $to: Date, $postStatus: EEntryStatus, $sort: EPostSorting, $shouldIncludeComments: Boolean = false) {
  post {
    getFeedPosts(
      after: $after
      first: $first
      message: $message
      tags: $tags
      topics: $topics
      authorId: $authorId
      communityId: $communityId
      from: $from
      to: $to
      postStatus: $postStatus
      sort: $sort
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          anonymousMode
          assets {
            postId
            assetId
            contentType
            fileName
            presignedUrl
          }
          author {
            ...userBasic
            communityConnections {
              edges {
                node {
                  communityId
                  id
                  role
                }
              }
            }
          }
          commentCount
          communityId
          createdDate
          createdDateTime
          feeling
          hasRelated
          message
          pinned
          relateCount
          shareCount
          shareOption
          status
          tags
          taggedUsers {
            placeholder
            user {
              id
              displayedName
              firstName
              lastName
              profileImage {
                presignedUrl
              }
            }
          }
          topicId
          topic {
            id
            title
            description
            postsCount
          }
          updatedDate
          comments(after: $commentsAfter, first: $commentsFirst) @include(if: $shouldIncludeComments) {
            pageInfo {
              endCursor
              hasNextPage
              hasPreviousPage
            }
            totalCount
            edges {
              cursor
              node {
                ...commentGraphType
                comments(after: $commentsAfter, first: $repliesFirst) {
                  pageInfo {
                    endCursor
                    hasNextPage
                    hasPreviousPage
                    startCursor
                  }
                  totalCount
                  edges {
                    cursor
                    node {
                      ...commentGraphType
                      comments(after: $commentsAfter, first: $repliesFirst) {
                        pageInfo {
                          endCursor
                          hasNextPage
                          hasPreviousPage
                          startCursor
                        }
                        totalCount
                        edges {
                          cursor
                          node {
                            ...commentGraphType
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          ...post
          ...postShareGraphType
        }
      }
    }
  }
}
    ${UserBasicFragmentDoc}
${CommentGraphTypeFragmentDoc}
${PostFragmentDoc}
${PostShareGraphTypeFragmentDoc}`;

/**
 * __useGetFeedPostsQuery__
 *
 * To run a query within a React component, call `useGetFeedPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedPostsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      commentsAfter: // value for 'commentsAfter'
 *      commentsFirst: // value for 'commentsFirst'
 *      repliesFirst: // value for 'repliesFirst'
 *      message: // value for 'message'
 *      tags: // value for 'tags'
 *      topics: // value for 'topics'
 *      authorId: // value for 'authorId'
 *      communityId: // value for 'communityId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      postStatus: // value for 'postStatus'
 *      sort: // value for 'sort'
 *      shouldIncludeComments: // value for 'shouldIncludeComments'
 *   },
 * });
 */
export function useGetFeedPostsQuery(baseOptions?: Apollo.QueryHookOptions<GetFeedPostsQuery, GetFeedPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeedPostsQuery, GetFeedPostsQueryVariables>(GetFeedPostsDocument, options);
      }
export function useGetFeedPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeedPostsQuery, GetFeedPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeedPostsQuery, GetFeedPostsQueryVariables>(GetFeedPostsDocument, options);
        }
export type GetFeedPostsQueryHookResult = ReturnType<typeof useGetFeedPostsQuery>;
export type GetFeedPostsLazyQueryHookResult = ReturnType<typeof useGetFeedPostsLazyQuery>;
export type GetFeedPostsQueryResult = Apollo.QueryResult<GetFeedPostsQuery, GetFeedPostsQueryVariables>;
export const GetReportsDocument = gql`
    query getReports($after: String, $first: Int, $communityId: Int!) {
  report {
    getReports(after: $after, first: $first, communityId: $communityId) {
      edges {
        cursor
        node {
          id
          message
          reporterId
          reporter {
            ...userBasic
          }
          type
          viewed
          ...reportPostGraphType
          ...reportCommentGraphType
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
}
    ${UserBasicFragmentDoc}
${ReportPostGraphTypeFragmentDoc}
${ReportCommentGraphTypeFragmentDoc}`;

/**
 * __useGetReportsQuery__
 *
 * To run a query within a React component, call `useGetReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useGetReportsQuery(baseOptions: Apollo.QueryHookOptions<GetReportsQuery, GetReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportsQuery, GetReportsQueryVariables>(GetReportsDocument, options);
      }
export function useGetReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportsQuery, GetReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportsQuery, GetReportsQueryVariables>(GetReportsDocument, options);
        }
export type GetReportsQueryHookResult = ReturnType<typeof useGetReportsQuery>;
export type GetReportsLazyQueryHookResult = ReturnType<typeof useGetReportsLazyQuery>;
export type GetReportsQueryResult = Apollo.QueryResult<GetReportsQuery, GetReportsQueryVariables>;
export const GetSharedPostsDocument = gql`
    query getSharedPosts($after: String, $first: Int, $postId: Int!) {
  post {
    sharedPosts(after: $after, first: $first, postId: $postId) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          anonymousMode
          assets {
            postId
            assetId
            contentType
            fileName
            presignedUrl
          }
          author {
            ...userBasic
            communityConnections {
              edges {
                node {
                  communityId
                  id
                  role
                }
              }
            }
          }
          commentCount
          communityId
          createdDate
          createdDateTime
          feeling
          hasRelated
          message
          pinned
          relateCount
          shareCount
          shareOption
          status
          tags
          taggedUsers {
            placeholder
            user {
              id
              displayedName
              firstName
              lastName
              profileImage {
                presignedUrl
              }
            }
          }
          topicId
          topic {
            id
            title
            description
            postsCount
          }
          updatedDate
          ...post
          ...postShareGraphType
        }
      }
    }
  }
}
    ${UserBasicFragmentDoc}
${PostFragmentDoc}
${PostShareGraphTypeFragmentDoc}`;

/**
 * __useGetSharedPostsQuery__
 *
 * To run a query within a React component, call `useGetSharedPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharedPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharedPostsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetSharedPostsQuery(baseOptions: Apollo.QueryHookOptions<GetSharedPostsQuery, GetSharedPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSharedPostsQuery, GetSharedPostsQueryVariables>(GetSharedPostsDocument, options);
      }
export function useGetSharedPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSharedPostsQuery, GetSharedPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSharedPostsQuery, GetSharedPostsQueryVariables>(GetSharedPostsDocument, options);
        }
export type GetSharedPostsQueryHookResult = ReturnType<typeof useGetSharedPostsQuery>;
export type GetSharedPostsLazyQueryHookResult = ReturnType<typeof useGetSharedPostsLazyQuery>;
export type GetSharedPostsQueryResult = Apollo.QueryResult<GetSharedPostsQuery, GetSharedPostsQueryVariables>;
export const GetSubCommentsDocument = gql`
    query getSubComments($after: String, $first: Int, $commentId: Int!) {
  comment {
    getSubComments(commentId: $commentId, first: $first, after: $after) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          ...commentGraphType
        }
      }
    }
  }
}
    ${CommentGraphTypeFragmentDoc}`;

/**
 * __useGetSubCommentsQuery__
 *
 * To run a query within a React component, call `useGetSubCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubCommentsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useGetSubCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetSubCommentsQuery, GetSubCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubCommentsQuery, GetSubCommentsQueryVariables>(GetSubCommentsDocument, options);
      }
export function useGetSubCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubCommentsQuery, GetSubCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubCommentsQuery, GetSubCommentsQueryVariables>(GetSubCommentsDocument, options);
        }
export type GetSubCommentsQueryHookResult = ReturnType<typeof useGetSubCommentsQuery>;
export type GetSubCommentsLazyQueryHookResult = ReturnType<typeof useGetSubCommentsLazyQuery>;
export type GetSubCommentsQueryResult = Apollo.QueryResult<GetSubCommentsQuery, GetSubCommentsQueryVariables>;
export const GetTagsByCommunityDocument = gql`
    query getTagsByCommunity($communityId: Int!) {
  community {
    tagsByCommunity(communityId: $communityId) {
      count
      key
    }
  }
}
    `;

/**
 * __useGetTagsByCommunityQuery__
 *
 * To run a query within a React component, call `useGetTagsByCommunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagsByCommunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagsByCommunityQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useGetTagsByCommunityQuery(baseOptions: Apollo.QueryHookOptions<GetTagsByCommunityQuery, GetTagsByCommunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTagsByCommunityQuery, GetTagsByCommunityQueryVariables>(GetTagsByCommunityDocument, options);
      }
export function useGetTagsByCommunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTagsByCommunityQuery, GetTagsByCommunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTagsByCommunityQuery, GetTagsByCommunityQueryVariables>(GetTagsByCommunityDocument, options);
        }
export type GetTagsByCommunityQueryHookResult = ReturnType<typeof useGetTagsByCommunityQuery>;
export type GetTagsByCommunityLazyQueryHookResult = ReturnType<typeof useGetTagsByCommunityLazyQuery>;
export type GetTagsByCommunityQueryResult = Apollo.QueryResult<GetTagsByCommunityQuery, GetTagsByCommunityQueryVariables>;
export const MarkWholeConversationReadDocument = gql`
    mutation markWholeConversationRead($senderId: Int!) {
  message {
    makeWholeConversationRead(senderId: $senderId)
  }
}
    `;
export type MarkWholeConversationReadMutationFn = Apollo.MutationFunction<MarkWholeConversationReadMutation, MarkWholeConversationReadMutationVariables>;

/**
 * __useMarkWholeConversationReadMutation__
 *
 * To run a mutation, you first call `useMarkWholeConversationReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkWholeConversationReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markWholeConversationReadMutation, { data, loading, error }] = useMarkWholeConversationReadMutation({
 *   variables: {
 *      senderId: // value for 'senderId'
 *   },
 * });
 */
export function useMarkWholeConversationReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkWholeConversationReadMutation, MarkWholeConversationReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkWholeConversationReadMutation, MarkWholeConversationReadMutationVariables>(MarkWholeConversationReadDocument, options);
      }
export type MarkWholeConversationReadMutationHookResult = ReturnType<typeof useMarkWholeConversationReadMutation>;
export type MarkWholeConversationReadMutationResult = Apollo.MutationResult<MarkWholeConversationReadMutation>;
export type MarkWholeConversationReadMutationOptions = Apollo.BaseMutationOptions<MarkWholeConversationReadMutation, MarkWholeConversationReadMutationVariables>;
export const GetUnreadMessagesCountDocument = gql`
    query getUnreadMessagesCount {
  message {
    unreadMessagesCount
  }
}
    `;

/**
 * __useGetUnreadMessagesCountQuery__
 *
 * To run a query within a React component, call `useGetUnreadMessagesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnreadMessagesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnreadMessagesCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnreadMessagesCountQuery(baseOptions?: Apollo.QueryHookOptions<GetUnreadMessagesCountQuery, GetUnreadMessagesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnreadMessagesCountQuery, GetUnreadMessagesCountQueryVariables>(GetUnreadMessagesCountDocument, options);
      }
export function useGetUnreadMessagesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnreadMessagesCountQuery, GetUnreadMessagesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnreadMessagesCountQuery, GetUnreadMessagesCountQueryVariables>(GetUnreadMessagesCountDocument, options);
        }
export type GetUnreadMessagesCountQueryHookResult = ReturnType<typeof useGetUnreadMessagesCountQuery>;
export type GetUnreadMessagesCountLazyQueryHookResult = ReturnType<typeof useGetUnreadMessagesCountLazyQuery>;
export type GetUnreadMessagesCountQueryResult = Apollo.QueryResult<GetUnreadMessagesCountQuery, GetUnreadMessagesCountQueryVariables>;
export const GetUserDocument = gql`
    query getUser {
  user {
    getUser {
      ...user
    }
  }
}
    ${UserFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetUserByKeyDocument = gql`
    query GetUserByKey($key: String!) {
  user {
    get(key: $key) {
      ...userDetails
    }
  }
}
    ${UserDetailsFragmentDoc}`;

/**
 * __useGetUserByKeyQuery__
 *
 * To run a query within a React component, call `useGetUserByKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByKeyQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetUserByKeyQuery(baseOptions: Apollo.QueryHookOptions<GetUserByKeyQuery, GetUserByKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByKeyQuery, GetUserByKeyQueryVariables>(GetUserByKeyDocument, options);
      }
export function useGetUserByKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByKeyQuery, GetUserByKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByKeyQuery, GetUserByKeyQueryVariables>(GetUserByKeyDocument, options);
        }
export type GetUserByKeyQueryHookResult = ReturnType<typeof useGetUserByKeyQuery>;
export type GetUserByKeyLazyQueryHookResult = ReturnType<typeof useGetUserByKeyLazyQuery>;
export type GetUserByKeyQueryResult = Apollo.QueryResult<GetUserByKeyQuery, GetUserByKeyQueryVariables>;
export const GetUserConnectionWithOtherUserDocument = gql`
    query getUserConnectionWithOtherUser($userId: Int!, $shouldIncludeUser: Boolean = true) {
  userConnection {
    getUserConnection(userId: $userId) {
      connectionStatus
      createdDate
      friendId
      id
      updatedDate
      userId
      user @include(if: $shouldIncludeUser) {
        displayedName
        firstName
        id
        isAnonymous
        isTermsAndConditionsAccepted
        lastName
        connections(after: null, first: null) {
          totalCount
        }
        activeCommunities(after: null, first: null) {
          totalCount
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserConnectionWithOtherUserQuery__
 *
 * To run a query within a React component, call `useGetUserConnectionWithOtherUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserConnectionWithOtherUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserConnectionWithOtherUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      shouldIncludeUser: // value for 'shouldIncludeUser'
 *   },
 * });
 */
export function useGetUserConnectionWithOtherUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserConnectionWithOtherUserQuery, GetUserConnectionWithOtherUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserConnectionWithOtherUserQuery, GetUserConnectionWithOtherUserQueryVariables>(GetUserConnectionWithOtherUserDocument, options);
      }
export function useGetUserConnectionWithOtherUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserConnectionWithOtherUserQuery, GetUserConnectionWithOtherUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserConnectionWithOtherUserQuery, GetUserConnectionWithOtherUserQueryVariables>(GetUserConnectionWithOtherUserDocument, options);
        }
export type GetUserConnectionWithOtherUserQueryHookResult = ReturnType<typeof useGetUserConnectionWithOtherUserQuery>;
export type GetUserConnectionWithOtherUserLazyQueryHookResult = ReturnType<typeof useGetUserConnectionWithOtherUserLazyQuery>;
export type GetUserConnectionWithOtherUserQueryResult = Apollo.QueryResult<GetUserConnectionWithOtherUserQuery, GetUserConnectionWithOtherUserQueryVariables>;
export const GetUserConnectionsDocument = gql`
    query getUserConnections($after: String, $first: Int, $filter: String, $userId: Int, $status: [EConnectionStatus]) {
  userConnection {
    getUserConnections(
      after: $after
      first: $first
      filter: $filter
      userId: $userId
      status: $status
    ) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          connectionStatus
          createdDate
          friendId
          id
          updatedDate
          userId
          user {
            displayedName
            firstName
            id
            key
            isAnonymous
            isTermsAndConditionsAccepted
            lastName
            profileImage {
              id: assetId
              presignedUrl
            }
            userConnection {
              connectionStatus
              createdDate
              friendId
              id
              updatedDate
              userId
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserConnectionsQuery__
 *
 * To run a query within a React component, call `useGetUserConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserConnectionsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *      userId: // value for 'userId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetUserConnectionsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserConnectionsQuery, GetUserConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserConnectionsQuery, GetUserConnectionsQueryVariables>(GetUserConnectionsDocument, options);
      }
export function useGetUserConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserConnectionsQuery, GetUserConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserConnectionsQuery, GetUserConnectionsQueryVariables>(GetUserConnectionsDocument, options);
        }
export type GetUserConnectionsQueryHookResult = ReturnType<typeof useGetUserConnectionsQuery>;
export type GetUserConnectionsLazyQueryHookResult = ReturnType<typeof useGetUserConnectionsLazyQuery>;
export type GetUserConnectionsQueryResult = Apollo.QueryResult<GetUserConnectionsQuery, GetUserConnectionsQueryVariables>;
export const GetUserInformationDocument = gql`
    query getUserInformation($userId: Int!) {
  user {
    getUserInformation(userId: $userId) {
      ...userDetails
    }
  }
}
    ${UserDetailsFragmentDoc}`;

/**
 * __useGetUserInformationQuery__
 *
 * To run a query within a React component, call `useGetUserInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInformationQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserInformationQuery(baseOptions: Apollo.QueryHookOptions<GetUserInformationQuery, GetUserInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserInformationQuery, GetUserInformationQueryVariables>(GetUserInformationDocument, options);
      }
export function useGetUserInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserInformationQuery, GetUserInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserInformationQuery, GetUserInformationQueryVariables>(GetUserInformationDocument, options);
        }
export type GetUserInformationQueryHookResult = ReturnType<typeof useGetUserInformationQuery>;
export type GetUserInformationLazyQueryHookResult = ReturnType<typeof useGetUserInformationLazyQuery>;
export type GetUserInformationQueryResult = Apollo.QueryResult<GetUserInformationQuery, GetUserInformationQueryVariables>;